import {
  ArrayList3it5z8td81qkl as ArrayList,
  Unit_instanceat14thlj150z as Unit_instance,
  equals2au1ep9vhcato as equals,
  VOID7hggqo3abtya as VOID,
  Paire9pteg33gng7 as Pair,
  listOf1jh22dvmctj1r as listOf,
  last1vo29oleiqj36 as last,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Long2qws0ah9gnpki as Long,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
  emptySetcxexqki71qfa as emptySet,
  emptyList1g2z5xcrvp2zy as emptyList,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  isInterface3d6p8outrmvmk as isInterface,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  plus1ogy4liedzq5j as plus,
  listOfvhqybd2zx248 as listOf_0,
  plus310ted5e4i90h as plus_0,
  take3onnpy6q7ctcz as take,
  plus20p0vtfmu0596 as plus_1,
  Enum3alwj03lh1n41 as Enum,
  to2cs3ny02qtbcb as to,
  sorted354mfsiv4s7x5 as sorted,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Collection1k04j3hzsbod0 as Collection,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  random234odtwlu7lq2 as random,
  first58ocm7j58k3q as first,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  sortedDescending1829b1te0xwte as sortedDescending,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  numberToLong1a4cndvg6c52s as numberToLong,
  abs1kdzbjes1idip as abs,
  toLongw1zpgk99d84b as toLong,
  toList3jhuyej2anx2q as toList,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  removeLast3759euu1xvfa3 as removeLast,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  toString14fd7g605f91p as toString_1,
  firstOrNull1982767dljvdy as firstOrNull,
  numberToDouble210hrknaofnhf as numberToDouble,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2jp2gwqhnirp8 as _Result___get_isFailure__impl__jpiriv,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  lazy2hsh8ze7j6ikd as lazy_0,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  coerceIn1xblvmyr0tby6 as coerceIn,
  coerceAtMostfyc3emgaderp as coerceAtMost,
  StringBuildermazzzhj6kkai as StringBuilder,
  split2bvyvnrlcifjv as split,
  DurationUnit_DAYS_getInstance3he068lsy3pdd as DurationUnit_DAYS_getInstance,
  padStart36w1507hs626a as padStart,
  joinToString1cxrrlmo0chqs as joinToString,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  roundToInt1ue8x8yshtznx as roundToInt,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  coerceIn10f36k81le1mm as coerceIn_0,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  repeat2w4c6j8zoq09o as repeat,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  LongSerializer_getInstance1b6u8yq9dg9zr as LongSerializer_getInstance,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  serializer1i4e9ym37oxmo as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
  localVfs1bmv3sf89y0wp as localVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  Resources1ysf2j4wd5yk7 as Resources,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_0,
  _DateTime___get_unixMillisLong__impl__sdx9bd2a9o7fvoi9ybx as _DateTime___get_unixMillisLong__impl__sdx9bd,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  DateTime__minus_impl_10njw81qwhaqtma3616 as DateTime__minus_impl_10njw8,
} from './korlibs-time-root-korlibs-time-core.mjs';
import { get_localifotpmym6b8f as get_local } from './korlibs-time-root-korlibs-time.mjs';
import {
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_1,
  Companion_getInstance3lu3946d91kk8 as Companion_getInstance_2,
  RectCorners2yrtl8r42p5bs as RectCorners,
  get_degrees1wvulgxbo1fy6 as get_degrees,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_3,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_4,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_6,
  RGBA34obx2i62wcl3 as RGBA,
  Bitmap32Context2d1xx7pfswf9phl as Bitmap32Context2d,
  CycleMethod_NO_CYCLE_getInstancea5nq2e90b21x as CycleMethod_NO_CYCLE_getInstance,
  GradientKind_RADIAL_getInstance32x9dxhe31xgu as GradientKind_RADIAL_getInstance,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  PNG_getInstance30449hvvlhbbs as PNG_getInstance,
  writeBitmap1pzywoab73ikp as writeBitmap,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_7,
  _RGBA___get_r__impl__duz7mojwqekabyzvum as _RGBA___get_r__impl__duz7mo,
  _RGBA___get_g__impl__o8pukr1q8mr1galt839 as _RGBA___get_g__impl__o8pukr,
  _RGBA___get_b__impl__m6tl80qg881mr99i7e as _RGBA___get_b__impl__m6tl80,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  _RGBA___get_a__impl__6msvu7bgji1ly0wy68 as _RGBA___get_a__impl__6msvu7,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readFont34z4s2654u5hd as readFont,
  Companion_instance1zw3l6m7tnvps as Companion_instance_0,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  CharacterSetvf7yl3wrjq2o as CharacterSet,
  Companion_getInstance1qaz5nihq39ec as Companion_getInstance_8,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Korge3fi4cwjkh8up9 as Korge,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  addTo25e29vq105prw as addTo,
  Companion_getInstance2b4rje0hs8ulh as Companion_getInstance_9,
  Stage1ggtrzujnnkl0 as Stage,
  positionu6441b7hkb4l as position,
  Scenezu810y12qpqp as Scene,
  Container7486fjmip554 as Container,
  RoundRect16qm0yoxjizxs as RoundRect,
  addUpdater1la23qj9g2d42 as addUpdater,
  ClipContainernpx31s3mxtjx as ClipContainer,
  GraphicsRenderer_GPU_getInstance3l98mt1a5bjlb as GraphicsRenderer_GPU_getInstance,
  Circlepba9jsmewo4k as Circle,
  scalea9fc0mbrr7ub as scale,
  Image1b2d7ghyim7p5 as Image,
  anchor3c5itxst996yy as anchor,
  onMouseDrag20om3ch85u2pf as onMouseDrag,
  SolidRect131p7hyzlx7j8 as SolidRect,
  get_mouse1jstwhfaumelj as get_mouse,
  renderToBitmap3nglzwiwh97g5 as renderToBitmap,
  get_keysmipauarvwdlb as get_keys,
  Transition2j190usvy2fcc as Transition,
  CpuGraphics2sfhutqezpf4d as CpuGraphics,
  Companion_instance1qzytx5vkv693 as Companion_instance_1,
  Text3kimhvgfxflj3 as Text,
} from './korge-root-korge.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_10,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  LineCap_ROUND_getInstance1eh2deoilyz2r as LineCap_ROUND_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  LineJoin_ROUND_getInstances9v2da89mekl as LineJoin_ROUND_getInstance,
} from './korlibs-math-root-korlibs-math.mjs';
import { Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import {
  cancel1n0qjc93h2v6w as cancel,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_2,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  delay1f60wyf8ua1gc as delay,
  Dispatchers_getInstance2xomc0oxzllw9 as Dispatchers_getInstance,
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  readSoundcwkqnndcldwa as readSound,
  readMusic27z8rq3uu0hc8 as readMusic,
  get_infinitePlaybackTimes1mig91bkmo9y7 as get_infinitePlaybackTimes,
} from './korlibs-audio-root-korlibs-audio.mjs';
import {
  NativeVibration3hb1rsmskdobi as NativeVibration,
  TextClipboardDatafimoftc14pmm as TextClipboardData,
  Key_ESCAPE_getInstance1l2qun1w293s5 as Key_ESCAPE_getInstance,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Key_BACK_getInstance296cv9giwezig as Key_BACK_getInstance,
} from './korge-root-korge-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class GameLogic {
  constructor(renju) {
    renju = renju === VOID ? false : renju;
    this.bd8_1 = renju;
    this.cd8_1 = new Board();
    this.dd8_1 = StoneColor_BLACK_getInstance();
    this.ed8_1 = GameState_PLAYING_getInstance();
    this.fd8_1 = null;
    this.gd8_1 = null;
    this.hd8_1 = listOf([new Pair(0, 1), new Pair(1, 0), new Pair(1, 1), new Pair(1, -1)]);
  }
  nd8(row, col) {
    if (!this.ed8_1.equals(GameState_PLAYING_getInstance())) {
      return new GameEnded('\u0418\u0433\u0440\u0430 \u0443\u0436\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430');
    }
    if (!this.cd8_1.ld8(row, col)) {
      return new InvalidMove('\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B');
    }
    if (!this.cd8_1.od8(row, col)) {
      return new InvalidMove('\u041A\u043B\u0435\u0442\u043A\u0430 \u0443\u0436\u0435 \u0437\u0430\u043D\u044F\u0442\u0430');
    }
    if (this.bd8_1 && this.dd8_1.equals(StoneColor_BLACK_getInstance())) {
      var tmp0_safe_receiver = RenjuRules_getInstance().qd8(this.cd8_1, row, col);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return new Forbidden(tmp0_safe_receiver, new Position(row, col));
      }
    }
    this.cd8_1.rd8(row, col, this.dd8_1);
    var winCheck = checkWin(this, row, col, this.dd8_1);
    if (!(winCheck == null)) {
      this.ed8_1 = this.dd8_1.equals(StoneColor_BLACK_getInstance()) ? GameState_BLACK_WINS_getInstance() : GameState_WHITE_WINS_getInstance();
      this.fd8_1 = this.dd8_1;
      this.gd8_1 = winCheck;
    } else if (this.cd8_1.sd8()) {
      this.ed8_1 = GameState_DRAW_getInstance();
    }
    var movePlayer = this.dd8_1;
    if (this.ed8_1.equals(GameState_PLAYING_getInstance())) {
      this.dd8_1 = this.dd8_1.vd8();
    }
    return new Success(last(this.cd8_1.wd8()), this.ed8_1, this.fd8_1, this.gd8_1, this.dd8_1);
  }
  xd8() {
    if (this.cd8_1.yd8() === 0) {
      return NoMovesToUndo_getInstance();
    }
    var undoneMove = this.cd8_1.zd8();
    if (!(undoneMove == null)) {
      this.ed8_1 = GameState_PLAYING_getInstance();
      this.fd8_1 = null;
      this.gd8_1 = null;
      this.dd8_1 = undoneMove.cd9_1;
      return new Success_0(undoneMove);
    }
    return new Error_0('\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0445\u043E\u0434');
  }
  ed9() {
    return this.cd8_1;
  }
  fd9() {
    return this.cd8_1.yd8();
  }
  gd9() {
    return this.cd8_1.wd8();
  }
  hd9(row, col) {
    if (!this.ed8_1.equals(GameState_PLAYING_getInstance()) || !this.cd8_1.od8(row, col))
      return false;
    if (this.bd8_1 && this.dd8_1.equals(StoneColor_BLACK_getInstance()) && !(RenjuRules_getInstance().qd8(this.cd8_1, row, col) == null))
      return false;
    return true;
  }
}
class MoveResult {}
class Success extends MoveResult {
  constructor(move, gameState, winner, winningLine, nextPlayer) {
    super();
    this.id9_1 = move;
    this.jd9_1 = gameState;
    this.kd9_1 = winner;
    this.ld9_1 = winningLine;
    this.md9_1 = nextPlayer;
  }
  toString() {
    return 'Success(move=' + this.id9_1.toString() + ', gameState=' + this.jd9_1.toString() + ', winner=' + toString(this.kd9_1) + ', winningLine=' + toString(this.ld9_1) + ', nextPlayer=' + this.md9_1.toString() + ')';
  }
  hashCode() {
    var result = this.id9_1.hashCode();
    result = imul(result, 31) + this.jd9_1.hashCode() | 0;
    result = imul(result, 31) + (this.kd9_1 == null ? 0 : this.kd9_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ld9_1 == null ? 0 : this.ld9_1.hashCode()) | 0;
    result = imul(result, 31) + this.md9_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Success))
      return false;
    var tmp0_other_with_cast = other instanceof Success ? other : THROW_CCE();
    if (!this.id9_1.equals(tmp0_other_with_cast.id9_1))
      return false;
    if (!this.jd9_1.equals(tmp0_other_with_cast.jd9_1))
      return false;
    if (!equals(this.kd9_1, tmp0_other_with_cast.kd9_1))
      return false;
    if (!equals(this.ld9_1, tmp0_other_with_cast.ld9_1))
      return false;
    if (!this.md9_1.equals(tmp0_other_with_cast.md9_1))
      return false;
    return true;
  }
}
class InvalidMove extends MoveResult {
  constructor(reason) {
    super();
    this.nd9_1 = reason;
  }
  toString() {
    return 'InvalidMove(reason=' + this.nd9_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.nd9_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InvalidMove))
      return false;
    var tmp0_other_with_cast = other instanceof InvalidMove ? other : THROW_CCE();
    if (!(this.nd9_1 === tmp0_other_with_cast.nd9_1))
      return false;
    return true;
  }
}
class GameEnded extends MoveResult {
  constructor(reason) {
    super();
    this.od9_1 = reason;
  }
  toString() {
    return 'GameEnded(reason=' + this.od9_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.od9_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameEnded))
      return false;
    var tmp0_other_with_cast = other instanceof GameEnded ? other : THROW_CCE();
    if (!(this.od9_1 === tmp0_other_with_cast.od9_1))
      return false;
    return true;
  }
}
class Forbidden extends MoveResult {
  constructor(violation, position) {
    super();
    this.pd9_1 = violation;
    this.qd9_1 = position;
  }
  toString() {
    return 'Forbidden(violation=' + this.pd9_1.toString() + ', position=' + this.qd9_1.toString() + ')';
  }
  hashCode() {
    var result = this.pd9_1.hashCode();
    result = imul(result, 31) + this.qd9_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Forbidden))
      return false;
    var tmp0_other_with_cast = other instanceof Forbidden ? other : THROW_CCE();
    if (!this.pd9_1.equals(tmp0_other_with_cast.pd9_1))
      return false;
    if (!this.qd9_1.equals(tmp0_other_with_cast.qd9_1))
      return false;
    return true;
  }
}
class UndoResult {}
class Success_0 extends UndoResult {
  constructor(undoneMove) {
    super();
    this.rd9_1 = undoneMove;
  }
  toString() {
    return 'Success(undoneMove=' + this.rd9_1.toString() + ')';
  }
  hashCode() {
    return this.rd9_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Success_0))
      return false;
    var tmp0_other_with_cast = other instanceof Success_0 ? other : THROW_CCE();
    if (!this.rd9_1.equals(tmp0_other_with_cast.rd9_1))
      return false;
    return true;
  }
}
class NoMovesToUndo extends UndoResult {
  constructor() {
    NoMovesToUndo_instance = null;
    super();
    NoMovesToUndo_instance = this;
  }
}
class Error_0 extends UndoResult {
  constructor(message) {
    super();
    this.sd9_1 = message;
  }
  toString() {
    return 'Error(message=' + this.sd9_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.sd9_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Error_0))
      return false;
    var tmp0_other_with_cast = other instanceof Error_0 ? other : THROW_CCE();
    if (!(this.sd9_1 === tmp0_other_with_cast.sd9_1))
      return false;
    return true;
  }
}
class Companion {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.wd9_1 = [null, null, Companion_getInstance_17().mcz(), Companion_getInstance_21().mcz(), Companion_getInstance_18().mcz(), new ArrayListSerializer($serializer_getInstance_4()), new ArrayListSerializer($serializer_getInstance_3())];
  }
}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('logic.GameRecord', this, 7);
    tmp0_serialDesc.scn('endedAt', false);
    tmp0_serialDesc.scn('mode', false);
    tmp0_serialDesc.scn('difficulty', true);
    tmp0_serialDesc.scn('result', false);
    tmp0_serialDesc.scn('humanColor', true);
    tmp0_serialDesc.scn('moves', false);
    tmp0_serialDesc.scn('winLine', true);
    this.xd9_1 = tmp0_serialDesc;
  }
  yd9(encoder, value) {
    var tmp0_desc = this.xd9_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().wd9_1;
    tmp1_output.rch(tmp0_desc, 0, value.zd9_1);
    tmp1_output.vch(tmp0_desc, 1, value.ada_1);
    if (tmp1_output.dci(tmp0_desc, 2) ? true : !(value.bda_1 == null)) {
      tmp1_output.zch(tmp0_desc, 2, tmp2_cached[2], value.bda_1);
    }
    tmp1_output.xch(tmp0_desc, 3, tmp2_cached[3], value.cda_1);
    if (tmp1_output.dci(tmp0_desc, 4) ? true : !(value.dda_1 == null)) {
      tmp1_output.zch(tmp0_desc, 4, tmp2_cached[4], value.dda_1);
    }
    tmp1_output.xch(tmp0_desc, 5, tmp2_cached[5], value.eda_1);
    if (tmp1_output.dci(tmp0_desc, 6) ? true : !(value.fda_1 == null)) {
      tmp1_output.zch(tmp0_desc, 6, tmp2_cached[6], value.fda_1);
    }
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.yd9(encoder, value instanceof GameRecord ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.xd9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.fcg(tmp0_desc);
    var tmp12_cached = Companion_getInstance_11().wd9_1;
    if (tmp11_input.vcg()) {
      tmp4_local0 = tmp11_input.lcg(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.pcg(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.tcg(tmp0_desc, 2, tmp12_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.rcg(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.tcg(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.rcg(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.tcg(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.lcg(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.pcg(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.tcg(tmp0_desc, 2, tmp12_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.rcg(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.tcg(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.rcg(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.tcg(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp11_input.gcg(tmp0_desc);
    return GameRecord.gda(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  jcc() {
    return this.xd9_1;
  }
  hco() {
    var tmp0_cached = Companion_getInstance_11().wd9_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2]), tmp0_cached[3], get_nullable(tmp0_cached[4]), tmp0_cached[5], get_nullable(tmp0_cached[6])];
  }
}
class GameRecord {
  constructor(endedAt, mode, difficulty, result, humanColor, moves, winLine) {
    Companion_getInstance_11();
    difficulty = difficulty === VOID ? null : difficulty;
    humanColor = humanColor === VOID ? null : humanColor;
    winLine = winLine === VOID ? null : winLine;
    this.zd9_1 = endedAt;
    this.ada_1 = mode;
    this.bda_1 = difficulty;
    this.cda_1 = result;
    this.dda_1 = humanColor;
    this.eda_1 = moves;
    this.fda_1 = winLine;
  }
  toString() {
    return 'GameRecord(endedAt=' + this.zd9_1.toString() + ', mode=' + this.ada_1 + ', difficulty=' + toString(this.bda_1) + ', result=' + this.cda_1.toString() + ', humanColor=' + toString(this.dda_1) + ', moves=' + toString_0(this.eda_1) + ', winLine=' + toString(this.fda_1) + ')';
  }
  hashCode() {
    var result = this.zd9_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ada_1) | 0;
    result = imul(result, 31) + (this.bda_1 == null ? 0 : this.bda_1.hashCode()) | 0;
    result = imul(result, 31) + this.cda_1.hashCode() | 0;
    result = imul(result, 31) + (this.dda_1 == null ? 0 : this.dda_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.eda_1) | 0;
    result = imul(result, 31) + (this.fda_1 == null ? 0 : hashCode(this.fda_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameRecord))
      return false;
    var tmp0_other_with_cast = other instanceof GameRecord ? other : THROW_CCE();
    if (!this.zd9_1.equals(tmp0_other_with_cast.zd9_1))
      return false;
    if (!(this.ada_1 === tmp0_other_with_cast.ada_1))
      return false;
    if (!equals(this.bda_1, tmp0_other_with_cast.bda_1))
      return false;
    if (!this.cda_1.equals(tmp0_other_with_cast.cda_1))
      return false;
    if (!equals(this.dda_1, tmp0_other_with_cast.dda_1))
      return false;
    if (!equals(this.eda_1, tmp0_other_with_cast.eda_1))
      return false;
    if (!equals(this.fda_1, tmp0_other_with_cast.fda_1))
      return false;
    return true;
  }
  static gda(seen0, endedAt, mode, difficulty, result, humanColor, moves, winLine, serializationConstructorMarker) {
    Companion_getInstance_11();
    if (!(43 === (43 & seen0))) {
      throwMissingFieldException(seen0, 43, $serializer_getInstance().xd9_1);
    }
    var $this = createThis(this);
    $this.zd9_1 = endedAt;
    $this.ada_1 = mode;
    if (0 === (seen0 & 4))
      $this.bda_1 = null;
    else
      $this.bda_1 = difficulty;
    $this.cda_1 = result;
    if (0 === (seen0 & 16))
      $this.dda_1 = null;
    else
      $this.dda_1 = humanColor;
    $this.eda_1 = moves;
    if (0 === (seen0 & 64))
      $this.fda_1 = null;
    else
      $this.fda_1 = winLine;
    return $this;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.hda_1 = [null, null, null, null, null, null, new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('logic.PlayerStats', this, 7);
    tmp0_serialDesc.scn('games', true);
    tmp0_serialDesc.scn('wins', true);
    tmp0_serialDesc.scn('streak', true);
    tmp0_serialDesc.scn('bestStreak', true);
    tmp0_serialDesc.scn('stonesTotal', true);
    tmp0_serialDesc.scn('pvpGames', true);
    tmp0_serialDesc.scn('seals', true);
    this.ida_1 = tmp0_serialDesc;
  }
  jda(encoder, value) {
    var tmp0_desc = this.ida_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    var tmp2_cached = Companion_getInstance_12().hda_1;
    if (tmp1_output.dci(tmp0_desc, 0) ? true : !(value.kda_1 === 0)) {
      tmp1_output.qch(tmp0_desc, 0, value.kda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 1) ? true : !(value.lda_1 === 0)) {
      tmp1_output.qch(tmp0_desc, 1, value.lda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 2) ? true : !(value.mda_1 === 0)) {
      tmp1_output.qch(tmp0_desc, 2, value.mda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 3) ? true : !(value.nda_1 === 0)) {
      tmp1_output.qch(tmp0_desc, 3, value.nda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 4) ? true : !(value.oda_1 === 0)) {
      tmp1_output.qch(tmp0_desc, 4, value.oda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 5) ? true : !(value.pda_1 === 0)) {
      tmp1_output.qch(tmp0_desc, 5, value.pda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 6) ? true : !equals(value.qda_1, emptySet())) {
      tmp1_output.xch(tmp0_desc, 6, tmp2_cached[6], value.qda_1);
    }
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.jda(encoder, value instanceof PlayerStats ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.ida_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_input = decoder.fcg(tmp0_desc);
    var tmp12_cached = Companion_getInstance_12().hda_1;
    if (tmp11_input.vcg()) {
      tmp4_local0 = tmp11_input.kcg(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.kcg(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.kcg(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.kcg(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.kcg(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.kcg(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.rcg(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.kcg(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.kcg(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.kcg(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.kcg(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.kcg(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.kcg(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.rcg(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp11_input.gcg(tmp0_desc);
    return PlayerStats.rda(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  jcc() {
    return this.ida_1;
  }
  hco() {
    var tmp0_cached = Companion_getInstance_12().hda_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[6]];
  }
}
class PlayerStats {
  constructor(games, wins, streak, bestStreak, stonesTotal, pvpGames, seals) {
    Companion_getInstance_12();
    games = games === VOID ? 0 : games;
    wins = wins === VOID ? 0 : wins;
    streak = streak === VOID ? 0 : streak;
    bestStreak = bestStreak === VOID ? 0 : bestStreak;
    stonesTotal = stonesTotal === VOID ? 0 : stonesTotal;
    pvpGames = pvpGames === VOID ? 0 : pvpGames;
    seals = seals === VOID ? emptySet() : seals;
    this.kda_1 = games;
    this.lda_1 = wins;
    this.mda_1 = streak;
    this.nda_1 = bestStreak;
    this.oda_1 = stonesTotal;
    this.pda_1 = pvpGames;
    this.qda_1 = seals;
  }
  sda(games, wins, streak, bestStreak, stonesTotal, pvpGames, seals) {
    return new PlayerStats(games, wins, streak, bestStreak, stonesTotal, pvpGames, seals);
  }
  toString() {
    return 'PlayerStats(games=' + this.kda_1 + ', wins=' + this.lda_1 + ', streak=' + this.mda_1 + ', bestStreak=' + this.nda_1 + ', stonesTotal=' + this.oda_1 + ', pvpGames=' + this.pda_1 + ', seals=' + toString_0(this.qda_1) + ')';
  }
  hashCode() {
    var result = this.kda_1;
    result = imul(result, 31) + this.lda_1 | 0;
    result = imul(result, 31) + this.mda_1 | 0;
    result = imul(result, 31) + this.nda_1 | 0;
    result = imul(result, 31) + this.oda_1 | 0;
    result = imul(result, 31) + this.pda_1 | 0;
    result = imul(result, 31) + hashCode(this.qda_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayerStats))
      return false;
    var tmp0_other_with_cast = other instanceof PlayerStats ? other : THROW_CCE();
    if (!(this.kda_1 === tmp0_other_with_cast.kda_1))
      return false;
    if (!(this.lda_1 === tmp0_other_with_cast.lda_1))
      return false;
    if (!(this.mda_1 === tmp0_other_with_cast.mda_1))
      return false;
    if (!(this.nda_1 === tmp0_other_with_cast.nda_1))
      return false;
    if (!(this.oda_1 === tmp0_other_with_cast.oda_1))
      return false;
    if (!(this.pda_1 === tmp0_other_with_cast.pda_1))
      return false;
    if (!equals(this.qda_1, tmp0_other_with_cast.qda_1))
      return false;
    return true;
  }
  static rda(seen0, games, wins, streak, bestStreak, stonesTotal, pvpGames, seals, serializationConstructorMarker) {
    Companion_getInstance_12();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_0().ida_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.kda_1 = 0;
    else
      $this.kda_1 = games;
    if (0 === (seen0 & 2))
      $this.lda_1 = 0;
    else
      $this.lda_1 = wins;
    if (0 === (seen0 & 4))
      $this.mda_1 = 0;
    else
      $this.mda_1 = streak;
    if (0 === (seen0 & 8))
      $this.nda_1 = 0;
    else
      $this.nda_1 = bestStreak;
    if (0 === (seen0 & 16))
      $this.oda_1 = 0;
    else
      $this.oda_1 = stonesTotal;
    if (0 === (seen0 & 32))
      $this.pda_1 = 0;
    else
      $this.pda_1 = pvpGames;
    if (0 === (seen0 & 64))
      $this.qda_1 = emptySet();
    else
      $this.qda_1 = seals;
    return $this;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.tda_1 = [null, new ArrayListSerializer($serializer_getInstance())];
  }
}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('logic.RecordsData', this, 2);
    tmp0_serialDesc.scn('stats', true);
    tmp0_serialDesc.scn('games', true);
    this.uda_1 = tmp0_serialDesc;
  }
  vda(encoder, value) {
    var tmp0_desc = this.uda_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().tda_1;
    if (tmp1_output.dci(tmp0_desc, 0) ? true : !value.wda_1.equals(new PlayerStats())) {
      tmp1_output.xch(tmp0_desc, 0, $serializer_getInstance_0(), value.wda_1);
    }
    if (tmp1_output.dci(tmp0_desc, 1) ? true : !equals(value.xda_1, emptyList())) {
      tmp1_output.xch(tmp0_desc, 1, tmp2_cached[1], value.xda_1);
    }
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.vda(encoder, value instanceof RecordsData ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.uda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fcg(tmp0_desc);
    var tmp7_cached = Companion_getInstance_13().tda_1;
    if (tmp6_input.vcg()) {
      tmp4_local0 = tmp6_input.rcg(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.rcg(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.rcg(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.rcg(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp6_input.gcg(tmp0_desc);
    return RecordsData.yda(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  jcc() {
    return this.uda_1;
  }
  hco() {
    var tmp0_cached = Companion_getInstance_13().tda_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_0(), tmp0_cached[1]];
  }
}
class RecordsData {
  constructor(stats, games) {
    Companion_getInstance_13();
    stats = stats === VOID ? new PlayerStats() : stats;
    games = games === VOID ? emptyList() : games;
    this.wda_1 = stats;
    this.xda_1 = games;
  }
  toString() {
    return 'RecordsData(stats=' + this.wda_1.toString() + ', games=' + toString_0(this.xda_1) + ')';
  }
  hashCode() {
    var result = this.wda_1.hashCode();
    result = imul(result, 31) + hashCode(this.xda_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RecordsData))
      return false;
    var tmp0_other_with_cast = other instanceof RecordsData ? other : THROW_CCE();
    if (!this.wda_1.equals(tmp0_other_with_cast.wda_1))
      return false;
    if (!equals(this.xda_1, tmp0_other_with_cast.xda_1))
      return false;
    return true;
  }
  static yda(seen0, stats, games, serializationConstructorMarker) {
    Companion_getInstance_13();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_1().uda_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.wda_1 = new PlayerStats();
    else
      $this.wda_1 = stats;
    if (0 === (seen0 & 2))
      $this.xda_1 = emptyList();
    else
      $this.xda_1 = games;
    return $this;
  }
}
class Seals {
  constructor() {
    Seals_instance = this;
    this.zda_1 = listOf(['\u521D', '\u9023', '\u901F', '\u5FC3', '\u5E2B', '\u767D', '\u77F3', '\u6708', '\u53CB']);
    this.adb_1 = '\u548C';
    this.bdb_1 = '\u6975';
  }
  cdb(stats) {
    return stats.qda_1.a3(this.zda_1);
  }
}
class RecordsStore$scheduleSave$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class RecordsStore {
  constructor() {
    RecordsStore_instance = this;
    this.ddb_1 = new RecordsData();
    this.edb_1 = 'gomoku';
    this.fdb_1 = 'records.json';
    this.gdb_1 = 50;
    var tmp = this;
    tmp.hdb_1 = Json(VOID, RecordsStore$json$lambda);
  }
  idb($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_load__qllgda.bind(VOID, this), $completion);
  }
  jdb(record, undoUsed) {
    var s = this.ddb_1.wda_1;
    var tmp;
    if (record.ada_1 === 'ai' && !(record.dda_1 == null)) {
      switch (record.cda_1.t3_1) {
        case 1:
          tmp = equals(record.dda_1, StoneColor_BLACK_getInstance());
          break;
        case 2:
          tmp = equals(record.dda_1, StoneColor_WHITE_getInstance());
          break;
        default:
          tmp = false;
          break;
      }
    } else {
      tmp = false;
    }
    var humanWon = tmp;
    var streak = !(record.ada_1 === 'ai') ? s.mda_1 : humanWon ? s.mda_1 + 1 | 0 : 0;
    var stones = s.oda_1 + record.eda_1.e1() | 0;
    var pvp = s.pda_1 + (record.ada_1 === 'pvp' ? 1 : 0) | 0;
    var hour = get_local(Companion_getInstance_0().h1y(record.zd9_1)).e6j();
    // Inline function 'kotlin.collections.mutableSetOf' call
    var earned = LinkedHashSet.h1();
    onGameFinished$award(s, earned, '\u521D', humanWon);
    onGameFinished$award(s, earned, '\u9023', streak >= 3);
    onGameFinished$award(s, earned, '\u901F', humanWon && record.eda_1.e1() <= 20);
    onGameFinished$award(s, earned, '\u5FC3', humanWon && !undoUsed);
    onGameFinished$award(s, earned, '\u5E2B', humanWon && equals(record.bda_1, Difficulty_HARD_getInstance()));
    onGameFinished$award(s, earned, '\u767D', humanWon && equals(record.dda_1, StoneColor_WHITE_getInstance()));
    onGameFinished$award(s, earned, '\u77F3', stones >= 1000);
    onGameFinished$award(s, earned, '\u6708', 0 <= hour ? hour <= 3 : false);
    onGameFinished$award(s, earned, '\u53CB', pvp >= 10);
    onGameFinished$award(s, earned, '\u548C', record.cda_1.equals(GameState_DRAW_getInstance()));
    var tmp_0 = this;
    var tmp_1 = s.kda_1 + 1 | 0;
    var tmp_2 = s.lda_1 + (humanWon ? 1 : 0) | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = s.nda_1;
    var tmp$ret$1 = Math.max(a, streak);
    tmp_0.ddb_1 = new RecordsData(s.sda(tmp_1, tmp_2, streak, tmp$ret$1, stones, pvp, plus(s.qda_1, earned)), take(plus_0(listOf_0(record), this.ddb_1.xda_1), 50));
    scheduleSave(this);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = plus_1(Seals_getInstance().zda_1, '\u548C');
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'logic.RecordsStore.onGameFinished.<anonymous>' call
      if (earned.z2(element)) {
        destination.h(element);
      }
    }
    return destination;
  }
}
class RenjuViolation extends Enum {}
class RenjuRules {
  constructor() {
    RenjuRules_instance = this;
    this.pd8_1 = listOf([to(0, 1), to(1, 0), to(1, 1), to(1, -1)]);
  }
  qd8(board, r, c) {
    if (!board.rd8(r, c, StoneColor_BLACK_getInstance()))
      return null;
    try {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.pd8_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'logic.RenjuRules.violation.<anonymous>' call
        var dr = item.ul();
        var dc = item.vl();
        var tmp$ret$0 = runLength(RenjuRules_getInstance(), board, r, c, dr, dc);
        destination.h(tmp$ret$0);
      }
      var runs = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(runs, Collection)) {
          tmp = runs.g1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var tmp0_iterator_0 = runs.a1();
        while (tmp0_iterator_0.b1()) {
          var element = tmp0_iterator_0.c1();
          // Inline function 'logic.RenjuRules.violation.<anonymous>' call
          if (element === 5) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3)
        return null;
      var tmp$ret$5;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(runs, Collection)) {
          tmp_0 = runs.g1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$5 = false;
          break $l$block_2;
        }
        var tmp0_iterator_1 = runs.a1();
        while (tmp0_iterator_1.b1()) {
          var element_0 = tmp0_iterator_1.c1();
          // Inline function 'logic.RenjuRules.violation.<anonymous>' call
          if (element_0 >= 6) {
            tmp$ret$5 = true;
            break $l$block_2;
          }
        }
        tmp$ret$5 = false;
      }
      if (tmp$ret$5)
        return RenjuViolation_OVERLINE_getInstance();
      var fours = 0;
      var openThrees = 0;
      var _iterator__ex2g4s = this.pd8_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s.c1();
        var dr_0 = _destruct__k2r9zo.ul();
        var dc_0 = _destruct__k2r9zo.vl();
        var f = countFours(this, board, r, c, dr_0, dc_0);
        fours = fours + f | 0;
        if (f === 0 && hasOpenThree(this, board, r, c, dr_0, dc_0)) {
          openThrees = openThrees + 1 | 0;
        }
      }
      if (fours >= 2)
        return RenjuViolation_DOUBLE_FOUR_getInstance();
      if (openThrees >= 2)
        return RenjuViolation_DOUBLE_THREE_getInstance();
      return null;
    }finally {
      board.zd8();
    }
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.kdb_1 = lazy(tmp_0, PlayerColorPref$Companion$_anonymous__iwyb0q);
  }
  mcz() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  tco(typeParamsSerializers) {
    return this.mcz();
  }
}
class PlayerColorPref extends Enum {}
class Companion_3 {
  constructor() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ldb_1 = lazy(tmp_0, Rules$Companion$_anonymous__vhp53s);
  }
  mcz() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
  tco(typeParamsSerializers) {
    return this.mcz();
  }
}
class Rules extends Enum {}
class Companion_4 {
  constructor() {
    Companion_instance_8 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.mdb_1 = [null, Companion_getInstance_15().mcz(), Companion_getInstance_17().mcz(), null, null, null, null, Companion_getInstance_14().mcz(), null, null, null];
  }
}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('logic.Settings', this, 11);
    tmp0_serialDesc.scn('dark', true);
    tmp0_serialDesc.scn('rules', true);
    tmp0_serialDesc.scn('aiDifficulty', true);
    tmp0_serialDesc.scn('hints', true);
    tmp0_serialDesc.scn('sound', true);
    tmp0_serialDesc.scn('music', true);
    tmp0_serialDesc.scn('confirmMoves', true);
    tmp0_serialDesc.scn('playerColor', true);
    tmp0_serialDesc.scn('firstRun', true);
    tmp0_serialDesc.scn('firstRunAt', true);
    tmp0_serialDesc.scn('adsRemoved', true);
    this.ndb_1 = tmp0_serialDesc;
  }
  odb(encoder, value) {
    var tmp0_desc = this.ndb_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().mdb_1;
    if (tmp1_output.dci(tmp0_desc, 0) ? true : !(value.pdb_1 === false)) {
      tmp1_output.nch(tmp0_desc, 0, value.pdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 1) ? true : !value.qdb_1.equals(Rules_CLASSIC_getInstance())) {
      tmp1_output.xch(tmp0_desc, 1, tmp2_cached[1], value.qdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 2) ? true : !value.rdb_1.equals(Difficulty_MID_getInstance())) {
      tmp1_output.xch(tmp0_desc, 2, tmp2_cached[2], value.rdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 3) ? true : !(value.sdb_1 === false)) {
      tmp1_output.nch(tmp0_desc, 3, value.sdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 4) ? true : !(value.tdb_1 === true)) {
      tmp1_output.nch(tmp0_desc, 4, value.tdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 5) ? true : !(value.udb_1 === true)) {
      tmp1_output.nch(tmp0_desc, 5, value.udb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 6) ? true : !(value.vdb_1 === false)) {
      tmp1_output.nch(tmp0_desc, 6, value.vdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 7) ? true : !value.wdb_1.equals(PlayerColorPref_ALTERNATE_getInstance())) {
      tmp1_output.xch(tmp0_desc, 7, tmp2_cached[7], value.wdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 8) ? true : !(value.xdb_1 === true)) {
      tmp1_output.nch(tmp0_desc, 8, value.xdb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 9) ? true : !value.ydb_1.equals(new Long(0, 0))) {
      tmp1_output.rch(tmp0_desc, 9, value.ydb_1);
    }
    if (tmp1_output.dci(tmp0_desc, 10) ? true : !(value.zdb_1 === false)) {
      tmp1_output.nch(tmp0_desc, 10, value.zdb_1);
    }
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.odb(encoder, value instanceof Settings ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.ndb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = false;
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = false;
    var tmp15_input = decoder.fcg(tmp0_desc);
    var tmp16_cached = Companion_getInstance_16().mdb_1;
    if (tmp15_input.vcg()) {
      tmp4_local0 = tmp15_input.hcg(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.rcg(tmp0_desc, 1, tmp16_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.rcg(tmp0_desc, 2, tmp16_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.hcg(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.hcg(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.hcg(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.hcg(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.rcg(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.hcg(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.lcg(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.hcg(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.hcg(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.rcg(tmp0_desc, 1, tmp16_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.rcg(tmp0_desc, 2, tmp16_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.hcg(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.hcg(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.hcg(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.hcg(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.rcg(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.hcg(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.lcg(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.hcg(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp15_input.gcg(tmp0_desc);
    return Settings.adc(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  }
  jcc() {
    return this.ndb_1;
  }
  hco() {
    var tmp0_cached = Companion_getInstance_16().mdb_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), tmp0_cached[1], tmp0_cached[2], BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[7], BooleanSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class Settings {
  constructor(dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved) {
    Companion_getInstance_16();
    dark = dark === VOID ? false : dark;
    rules = rules === VOID ? Rules_CLASSIC_getInstance() : rules;
    aiDifficulty = aiDifficulty === VOID ? Difficulty_MID_getInstance() : aiDifficulty;
    hints = hints === VOID ? false : hints;
    sound = sound === VOID ? true : sound;
    music = music === VOID ? true : music;
    confirmMoves = confirmMoves === VOID ? false : confirmMoves;
    playerColor = playerColor === VOID ? PlayerColorPref_ALTERNATE_getInstance() : playerColor;
    firstRun = firstRun === VOID ? true : firstRun;
    firstRunAt = firstRunAt === VOID ? new Long(0, 0) : firstRunAt;
    adsRemoved = adsRemoved === VOID ? false : adsRemoved;
    this.pdb_1 = dark;
    this.qdb_1 = rules;
    this.rdb_1 = aiDifficulty;
    this.sdb_1 = hints;
    this.tdb_1 = sound;
    this.udb_1 = music;
    this.vdb_1 = confirmMoves;
    this.wdb_1 = playerColor;
    this.xdb_1 = firstRun;
    this.ydb_1 = firstRunAt;
    this.zdb_1 = adsRemoved;
  }
  bdc(dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved) {
    return new Settings(dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved);
  }
  cdc(dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved, $super) {
    dark = dark === VOID ? this.pdb_1 : dark;
    rules = rules === VOID ? this.qdb_1 : rules;
    aiDifficulty = aiDifficulty === VOID ? this.rdb_1 : aiDifficulty;
    hints = hints === VOID ? this.sdb_1 : hints;
    sound = sound === VOID ? this.tdb_1 : sound;
    music = music === VOID ? this.udb_1 : music;
    confirmMoves = confirmMoves === VOID ? this.vdb_1 : confirmMoves;
    playerColor = playerColor === VOID ? this.wdb_1 : playerColor;
    firstRun = firstRun === VOID ? this.xdb_1 : firstRun;
    firstRunAt = firstRunAt === VOID ? this.ydb_1 : firstRunAt;
    adsRemoved = adsRemoved === VOID ? this.zdb_1 : adsRemoved;
    return $super === VOID ? this.bdc(dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved) : $super.bdc.call(this, dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved);
  }
  toString() {
    return 'Settings(dark=' + this.pdb_1 + ', rules=' + this.qdb_1.toString() + ', aiDifficulty=' + this.rdb_1.toString() + ', hints=' + this.sdb_1 + ', sound=' + this.tdb_1 + ', music=' + this.udb_1 + ', confirmMoves=' + this.vdb_1 + ', playerColor=' + this.wdb_1.toString() + ', firstRun=' + this.xdb_1 + ', firstRunAt=' + this.ydb_1.toString() + ', adsRemoved=' + this.zdb_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.pdb_1);
    result = imul(result, 31) + this.qdb_1.hashCode() | 0;
    result = imul(result, 31) + this.rdb_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sdb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.tdb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.udb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vdb_1) | 0;
    result = imul(result, 31) + this.wdb_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xdb_1) | 0;
    result = imul(result, 31) + this.ydb_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zdb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Settings))
      return false;
    var tmp0_other_with_cast = other instanceof Settings ? other : THROW_CCE();
    if (!(this.pdb_1 === tmp0_other_with_cast.pdb_1))
      return false;
    if (!this.qdb_1.equals(tmp0_other_with_cast.qdb_1))
      return false;
    if (!this.rdb_1.equals(tmp0_other_with_cast.rdb_1))
      return false;
    if (!(this.sdb_1 === tmp0_other_with_cast.sdb_1))
      return false;
    if (!(this.tdb_1 === tmp0_other_with_cast.tdb_1))
      return false;
    if (!(this.udb_1 === tmp0_other_with_cast.udb_1))
      return false;
    if (!(this.vdb_1 === tmp0_other_with_cast.vdb_1))
      return false;
    if (!this.wdb_1.equals(tmp0_other_with_cast.wdb_1))
      return false;
    if (!(this.xdb_1 === tmp0_other_with_cast.xdb_1))
      return false;
    if (!this.ydb_1.equals(tmp0_other_with_cast.ydb_1))
      return false;
    if (!(this.zdb_1 === tmp0_other_with_cast.zdb_1))
      return false;
    return true;
  }
  static adc(seen0, dark, rules, aiDifficulty, hints, sound, music, confirmMoves, playerColor, firstRun, firstRunAt, adsRemoved, serializationConstructorMarker) {
    Companion_getInstance_16();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().ndb_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.pdb_1 = false;
    else
      $this.pdb_1 = dark;
    if (0 === (seen0 & 2))
      $this.qdb_1 = Rules_CLASSIC_getInstance();
    else
      $this.qdb_1 = rules;
    if (0 === (seen0 & 4))
      $this.rdb_1 = Difficulty_MID_getInstance();
    else
      $this.rdb_1 = aiDifficulty;
    if (0 === (seen0 & 8))
      $this.sdb_1 = false;
    else
      $this.sdb_1 = hints;
    if (0 === (seen0 & 16))
      $this.tdb_1 = true;
    else
      $this.tdb_1 = sound;
    if (0 === (seen0 & 32))
      $this.udb_1 = true;
    else
      $this.udb_1 = music;
    if (0 === (seen0 & 64))
      $this.vdb_1 = false;
    else
      $this.vdb_1 = confirmMoves;
    if (0 === (seen0 & 128))
      $this.wdb_1 = PlayerColorPref_ALTERNATE_getInstance();
    else
      $this.wdb_1 = playerColor;
    if (0 === (seen0 & 256))
      $this.xdb_1 = true;
    else
      $this.xdb_1 = firstRun;
    if (0 === (seen0 & 512))
      $this.ydb_1 = new Long(0, 0);
    else
      $this.ydb_1 = firstRunAt;
    if (0 === (seen0 & 1024))
      $this.zdb_1 = false;
    else
      $this.zdb_1 = adsRemoved;
    return $this;
  }
}
class SettingsStore$scheduleSave$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class SettingsStore {
  constructor() {
    SettingsStore_instance = this;
    this.ddc_1 = new Settings();
    this.edc_1 = 'gomoku';
    this.fdc_1 = 'settings.json';
    var tmp = this;
    tmp.gdc_1 = Json(VOID, SettingsStore$json$lambda);
  }
  idb($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_load__qllgda_0.bind(VOID, this), $completion);
  }
  hdc(block) {
    this.ddc_1 = block(this.ddc_1);
    scheduleSave_0(this);
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.td9_1 = lazy(tmp_0, Difficulty$Companion$_anonymous__8jmm7g);
  }
  mcz() {
    return _get_$cachedSerializer__te6jhj_1(this);
  }
  tco(typeParamsSerializers) {
    return this.mcz();
  }
}
class Difficulty extends Enum {}
class AiFactory {
  idc(d) {
    var tmp;
    switch (d.t3_1) {
      case 0:
        tmp = new RandomNearAi();
        break;
      case 1:
        tmp = new HeuristicAi(1, 0.9);
        break;
      case 2:
        tmp = new HeuristicAi(2, 1.0, 2);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
class RandomNearAi {
  jdc(game) {
    var board = game.ed9();
    if (board.yd8() === 0)
      return new Position(7, 7);
    var candidates = legalCandidates(game, 2);
    return random(candidates, Default_getInstance());
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.kdc_1 = function_0;
  }
  hj(a, b) {
    return this.kdc_1(a, b);
  }
  compare(a, b) {
    return this.hj(a, b);
  }
  s4() {
    return this.kdc_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class HeuristicAi {
  constructor(neighborhood, opponentBias, depth) {
    neighborhood = neighborhood === VOID ? 1 : neighborhood;
    opponentBias = opponentBias === VOID ? 0.9 : opponentBias;
    depth = depth === VOID ? 1 : depth;
    this.ldc_1 = neighborhood;
    this.mdc_1 = opponentBias;
    this.ndc_1 = depth;
  }
  jdc(game) {
    var board = game.ed9();
    var me = game.dd8_1;
    var opp = me.vd8();
    if (board.yd8() === 0)
      return new Position(7, 7);
    var candidates = legalCandidates(game, this.ldc_1);
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(candidates, 10));
    var tmp0_iterator = candidates.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'logic.ai.HeuristicAi.chooseMove.<anonymous>' call
      var tmp$ret$0 = to(item, scoreMove(board, item.odc_1, item.pdc_1, me, opp, this.mdc_1));
      destination.h(tmp$ret$0);
    }
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = HeuristicAi$chooseMove$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0(tmp);
    var scored = sortedWith(destination, tmp$ret$3);
    if (this.ndc_1 < 2 || first(scored).tl_1.z1(new Long(10000000, 0)) >= 0) {
      return pickBest(this, scored);
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var results = ArrayList.i1();
    var _iterator__ex2g4s = take(scored, 10).a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.c1();
      var pos = _destruct__k2r9zo.ul();
      var myScore = _destruct__k2r9zo.vl();
      if (!board.rd8(pos.odc_1, pos.pdc_1, me))
        continue $l$loop;
      // Inline function 'kotlin.collections.map' call
      var this_0 = candidateCells(board, 1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var item_0 = tmp0_iterator_0.c1();
        // Inline function 'logic.ai.HeuristicAi.chooseMove.<anonymous>' call
        var tmp$ret$6 = scoreMove(board, item_0.odc_1, item_0.pdc_1, opp, me, this.mdc_1);
        destination_0.h(tmp$ret$6);
      }
      var tmp0_elvis_lhs = maxOrNull(take(sortedDescending(destination_0), 8));
      var oppBest = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
      board.zd8();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'kotlin.Long.times' call
      var tmp$ret$9 = oppBest.r4() * 0.9;
      var element = to(pos, myScore.a2(numberToLong(tmp$ret$9)));
      results.h(element);
    }
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_0 = HeuristicAi$chooseMove$lambda_0;
    var tmp$ret$10 = new sam$kotlin_Comparator$0(tmp_0);
    var tmp$ret$11 = sortedWith(results, tmp$ret$10);
    return pickBest(this, tmp$ret$11);
  }
}
class HintMove {
  constructor(pos, score) {
    this.rdc_1 = pos;
    this.sdc_1 = score;
  }
  toString() {
    return 'HintMove(pos=' + this.rdc_1.toString() + ', score=' + this.sdc_1.toString() + ')';
  }
  hashCode() {
    var result = this.rdc_1.hashCode();
    result = imul(result, 31) + this.sdc_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HintMove))
      return false;
    var tmp0_other_with_cast = other instanceof HintMove ? other : THROW_CCE();
    if (!this.rdc_1.equals(tmp0_other_with_cast.rdc_1))
      return false;
    if (!this.sdc_1.equals(tmp0_other_with_cast.sdc_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.tdc_1 = function_0;
  }
  hj(a, b) {
    return this.tdc_1(a, b);
  }
  compare(a, b) {
    return this.hj(a, b);
  }
  s4() {
    return this.tdc_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class main$slambda {
  a9u($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$Korge), $completion);
  }
  ge(p1, $completion) {
    return this.a9u(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Board {
  constructor(size) {
    size = size === VOID ? 15 : size;
    this.id8_1 = size;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.id8_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp_4 = 0;
      var tmp_5 = this.id8_1;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_6 = fillArrayVal(Array(tmp_5), null);
      while (tmp_4 < tmp_5) {
        tmp_6[tmp_4] = null;
        tmp_4 = tmp_4 + 1 | 0;
      }
      tmp_2[tmp_3] = tmp_6;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.jd8_1 = tmp_2;
    var tmp_7 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_7.kd8_1 = ArrayList.i1();
  }
  wd8() {
    return toList(this.kd8_1);
  }
  yd8() {
    return this.kd8_1.e1();
  }
  ld8(row, col) {
    return (0 <= row ? row < this.id8_1 : false) && (0 <= col ? col < this.id8_1 : false);
  }
  od8(row, col) {
    return this.ld8(row, col) && this.jd8_1[row][col] == null;
  }
  rd8(row, col, player) {
    if (!this.od8(row, col))
      return false;
    this.jd8_1[row][col] = player;
    this.kd8_1.h(new Move(row, col, player, this.kd8_1.e1() + 1 | 0));
    return true;
  }
  md8(row, col) {
    if (!this.ld8(row, col))
      return null;
    return this.jd8_1[row][col];
  }
  zd8() {
    if (this.kd8_1.g1())
      return null;
    var lastMove = removeLast(this.kd8_1);
    this.jd8_1[lastMove.ad9_1][lastMove.bd9_1] = null;
    return lastMove;
  }
  sd8() {
    return this.kd8_1.e1() === imul(this.id8_1, this.id8_1);
  }
  qdc() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var positions = ArrayList.i1();
    var inductionVariable = 0;
    var last = this.id8_1;
    if (inductionVariable < last)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.id8_1;
        if (inductionVariable_0 < last_0)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (this.od8(row, col)) {
              positions.h(new Position(row, col));
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    return positions;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.vd9_1 = lazy(tmp_0, StoneColor$Companion$_anonymous__ru0jxr);
  }
  mcz() {
    return _get_$cachedSerializer__te6jhj_2(this);
  }
  tco(typeParamsSerializers) {
    return this.mcz();
  }
}
class StoneColor extends Enum {
  kdd() {
    var tmp;
    switch (this.t3_1) {
      case 0:
        tmp = '\u25CF';
        break;
      case 1:
        tmp = '\u25CB';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  vd8() {
    var tmp;
    switch (this.t3_1) {
      case 0:
        tmp = StoneColor_WHITE_getInstance();
        break;
      case 1:
        tmp = StoneColor_BLACK_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
class Companion_7 {}
class $serializer_3 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('model.Position', this, 2);
    tmp0_serialDesc.scn('row', false);
    tmp0_serialDesc.scn('col', false);
    this.ldd_1 = tmp0_serialDesc;
  }
  mdd(encoder, value) {
    var tmp0_desc = this.ldd_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    tmp1_output.qch(tmp0_desc, 0, value.odc_1);
    tmp1_output.qch(tmp0_desc, 1, value.pdc_1);
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.mdd(encoder, value instanceof Position ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.ldd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.fcg(tmp0_desc);
    if (tmp6_input.vcg()) {
      tmp4_local0 = tmp6_input.kcg(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.kcg(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.kcg(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.kcg(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp6_input.gcg(tmp0_desc);
    return Position.ndd(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  jcc() {
    return this.ldd_1;
  }
  hco() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class Position {
  constructor(row, col) {
    this.odc_1 = row;
    this.pdc_1 = col;
  }
  odd() {
    var colLetter = toString_1(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), this.pdc_1));
    var rowNumber = this.odc_1 + 1 | 0;
    return colLetter + rowNumber;
  }
  toString() {
    return 'Position(row=' + this.odc_1 + ', col=' + this.pdc_1 + ')';
  }
  hashCode() {
    var result = this.odc_1;
    result = imul(result, 31) + this.pdc_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Position))
      return false;
    var tmp0_other_with_cast = other instanceof Position ? other : THROW_CCE();
    if (!(this.odc_1 === tmp0_other_with_cast.odc_1))
      return false;
    if (!(this.pdc_1 === tmp0_other_with_cast.pdc_1))
      return false;
    return true;
  }
  static ndd(seen0, row, col, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_3().ldd_1);
    }
    var $this = createThis(this);
    $this.odc_1 = row;
    $this.pdc_1 = col;
    return $this;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.pdd_1 = [null, null, Companion_getInstance_18().mcz(), null];
  }
}
class $serializer_4 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('model.Move', this, 4);
    tmp0_serialDesc.scn('row', false);
    tmp0_serialDesc.scn('col', false);
    tmp0_serialDesc.scn('player', false);
    tmp0_serialDesc.scn('moveNumber', false);
    this.qdd_1 = tmp0_serialDesc;
  }
  rdd(encoder, value) {
    var tmp0_desc = this.qdd_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    var tmp2_cached = Companion_getInstance_20().pdd_1;
    tmp1_output.qch(tmp0_desc, 0, value.ad9_1);
    tmp1_output.qch(tmp0_desc, 1, value.bd9_1);
    tmp1_output.xch(tmp0_desc, 2, tmp2_cached[2], value.cd9_1);
    tmp1_output.qch(tmp0_desc, 3, value.dd9_1);
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.rdd(encoder, value instanceof Move ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.qdd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.fcg(tmp0_desc);
    var tmp9_cached = Companion_getInstance_20().pdd_1;
    if (tmp8_input.vcg()) {
      tmp4_local0 = tmp8_input.kcg(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.kcg(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.rcg(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.kcg(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.kcg(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.kcg(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.rcg(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.kcg(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp8_input.gcg(tmp0_desc);
    return Move.sdd(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  jcc() {
    return this.qdd_1;
  }
  hco() {
    var tmp0_cached = Companion_getInstance_20().pdd_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[2], IntSerializer_getInstance()];
  }
}
class Move {
  constructor(row, col, player, moveNumber) {
    Companion_getInstance_20();
    this.ad9_1 = row;
    this.bd9_1 = col;
    this.cd9_1 = player;
    this.dd9_1 = moveNumber;
  }
  y1s() {
    return new Position(this.ad9_1, this.bd9_1);
  }
  tdd() {
    return this.y1s().odd();
  }
  toString() {
    return this.cd9_1.kdd() + ' ' + this.tdd() + ' (#' + this.dd9_1 + ')';
  }
  hashCode() {
    var result = this.ad9_1;
    result = imul(result, 31) + this.bd9_1 | 0;
    result = imul(result, 31) + this.cd9_1.hashCode() | 0;
    result = imul(result, 31) + this.dd9_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Move))
      return false;
    var tmp0_other_with_cast = other instanceof Move ? other : THROW_CCE();
    if (!(this.ad9_1 === tmp0_other_with_cast.ad9_1))
      return false;
    if (!(this.bd9_1 === tmp0_other_with_cast.bd9_1))
      return false;
    if (!this.cd9_1.equals(tmp0_other_with_cast.cd9_1))
      return false;
    if (!(this.dd9_1 === tmp0_other_with_cast.dd9_1))
      return false;
    return true;
  }
  static sdd(seen0, row, col, player, moveNumber, serializationConstructorMarker) {
    Companion_getInstance_20();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_4().qdd_1);
    }
    var $this = createThis(this);
    $this.ad9_1 = row;
    $this.bd9_1 = col;
    $this.cd9_1 = player;
    $this.dd9_1 = moveNumber;
    return $this;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ud9_1 = lazy(tmp_0, GameState$Companion$_anonymous__we4trk);
  }
  mcz() {
    return _get_$cachedSerializer__te6jhj_3(this);
  }
  tco(typeParamsSerializers) {
    return this.mcz();
  }
}
class GameState extends Enum {}
class Companion_10 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.udd_1 = [new ArrayListSerializer($serializer_getInstance_3())];
  }
}
class $serializer_5 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('model.WinningLine', this, 1);
    tmp0_serialDesc.scn('positions', false);
    this.vdd_1 = tmp0_serialDesc;
  }
  wdd(encoder, value) {
    var tmp0_desc = this.vdd_1;
    var tmp1_output = encoder.fcg(tmp0_desc);
    var tmp2_cached = Companion_getInstance_22().udd_1;
    tmp1_output.xch(tmp0_desc, 0, tmp2_cached[0], value.xdd_1);
    tmp1_output.gcg(tmp0_desc);
  }
  kcc(encoder, value) {
    return this.wdd(encoder, value instanceof WinningLine ? value : THROW_CCE());
  }
  lcc(decoder) {
    var tmp0_desc = this.vdd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fcg(tmp0_desc);
    var tmp6_cached = Companion_getInstance_22().udd_1;
    if (tmp5_input.vcg()) {
      tmp4_local0 = tmp5_input.rcg(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wcg(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rcg(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.qcd(tmp2_index);
        }
      }
    tmp5_input.gcg(tmp0_desc);
    return WinningLine.ydd(tmp3_bitMask0, tmp4_local0, null);
  }
  jcc() {
    return this.vdd_1;
  }
  hco() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_22().udd_1[0]];
  }
}
class WinningLine {
  constructor(positions) {
    Companion_getInstance_22();
    this.xdd_1 = positions;
  }
  toString() {
    return 'WinningLine(positions=' + toString_0(this.xdd_1) + ')';
  }
  hashCode() {
    return hashCode(this.xdd_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WinningLine))
      return false;
    var tmp0_other_with_cast = other instanceof WinningLine ? other : THROW_CCE();
    if (!equals(this.xdd_1, tmp0_other_with_cast.xdd_1))
      return false;
    return true;
  }
  static ydd(seen0, positions, serializationConstructorMarker) {
    Companion_getInstance_22();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_5().vdd_1);
    }
    var $this = createThis(this);
    $this.xdd_1 = positions;
    return $this;
  }
}
class VictoryScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var cx = w / 2.0;
    var record = GameSession_getInstance().gde_1;
    var tmp1_elvis_lhs = record == null ? null : record.cda_1;
    var result = tmp1_elvis_lhs == null ? GameSession_getInstance().bde_1.ed8_1 : tmp1_elvis_lhs;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, VictoryScene$sceneMain$lambda);
    position(kinAkaiItoV(_this__u8e3s4, 380.0, theme), w - 30.0, 96.0);
    var seal = firstOrNull(GameSession_getInstance().hde_1);
    var y = {_v: !(seal == null) ? 78.0 : 104.0};
    var winnerBlack = !result.equals(GameState_WHITE_WINS_getInstance());
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.VictoryScene.sceneMain.<anonymous>' call
    kinStone(this_1, winnerBlack, 42.0, VOID, VOID, theme);
    var tmp0_x1 = -50.0;
    var tmp1_y2 = -38.0;
    var tmp2_color = theme.gdf_1;
    var tmp3_colorSoft = theme.hdf_1;
    kinSeam(this_1, tmp0_x1, 38.0, 50.0, tmp1_y2, 2.8, 5.0, 11, true, VOID, VOID, tmp2_color, tmp3_colorSoft);
    var tmp4_y2 = -14.0;
    var tmp5_color = theme.gdf_1;
    var tmp6_colorSoft = theme.hdf_1;
    kinSeam(this_1, 0.0, 0.0, 22.0, tmp4_y2, 1.4, 2.0, 17, VOID, 0.85, VOID, tmp5_color, tmp6_colorSoft);
    position(this_1, cx, y._v + 42.0);
    y._v = y._v + (84.0 + 22.0);
    var tmp = Type_instance.jdf();
    kinText_0(_this__u8e3s4, '\u041F\u0410\u0420\u0422\u0418\u042F \u0417\u0410\u0412\u0415\u0420\u0428\u0415\u041D\u0410', tmp, theme.cdf_1, VictoryScene$sceneMain$lambda_0(cx, y));
    y._v = y._v + 20.0;
    var title;
    switch (result.t3_1) {
      case 1:
        title = '\u0427\u0451\u0440\u043D\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
        break;
      case 2:
        title = '\u0411\u0435\u043B\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
        break;
      default:
        title = '\u041D\u0438\u0447\u044C\u044F';
        break;
    }
    var tmp_0 = Fonts_instance.kdf();
    kinText(_this__u8e3s4, title, 32.0, theme.adf_1, tmp_0, VictoryScene$sceneMain$lambda_1(cx, y));
    y._v = y._v + (46.0 + 12.0);
    var boardSize = 100.0;
    if (!(record == null)) {
      position(kinMiniBoard(_this__u8e3s4, record.eda_1, record.fda_1, boardSize, theme, true), cx - boardSize / 2.0, y._v);
      y._v = y._v + (boardSize + 12.0);
    }
    if (!(seal == null)) {
      renderSealStamp(_this__u8e3s4, cx, y._v, seal, theme);
      y._v = y._v + (48.0 + 10.0);
    }
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.VictoryScene.sceneMain.<anonymous>' call
    kinSeam(this_3, 2.0, 22.0, 130.0, 18.0, 1.5, 3.0, 81, true, VOID, VOID, theme.gdf_1, theme.hdf_1);
    kinSeam(this_3, 130.0, 18.0, 258.0, 26.0, 1.4, 3.0, 83, true, VOID, VOID, theme.gdf_1, theme.hdf_1);
    kinSeam(this_3, 92.0, 20.0, 70.0, 4.0, 0.9, 2.0, 87, VOID, 0.8, VOID, theme.gdf_1, theme.hdf_1);
    kinSeam(this_3, 170.0, 20.0, 196.0, 36.0, 0.9, 2.0, 89, VOID, 0.8, VOID, theme.gdf_1, theme.hdf_1);
    kinSeam(this_3, 210.0, 24.0, 236.0, 6.0, 0.7, 1.5, 93, VOID, 0.7, VOID, theme.gdf_1, theme.hdf_1);
    position(this_3, cx - 130.0, y._v);
    y._v = y._v + (40.0 + 10.0);
    var btnW = 280.0;
    var btnX = cx - btnW / 2.0;
    position(kinButton(_this__u8e3s4, btnW, '\u0415\u0449\u0451 \u043F\u0430\u0440\u0442\u0438\u044E', true, VOID, VOID, true, VOID, theme, VictoryScene$sceneMain$lambda_2), btnX, y._v);
    y._v = y._v + (52.0 + 10.0);
    position(kinButton(_this__u8e3s4, btnW, '\u0412 \u043C\u0435\u043D\u044E', VOID, VOID, VOID, true, VOID, theme, VictoryScene$sceneMain$lambda_3), btnX, y._v);
    y._v = y._v + (52.0 + 16.0);
    if (!(record == null)) {
      // Inline function 'kotlin.apply' call
      var this_4 = kinTextButton(_this__u8e3s4, '\u041A\u0438\u0444\u0443 \u043F\u0430\u0440\u0442\u0438\u0438 \u2192', theme.cdf_1, VictoryScene$sceneMain$lambda_4(record));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.VictoryScene.sceneMain.<anonymous>' call
      this_4.fc7(Companion_getInstance_6().t4t_1);
      position(this_4, cx, y._v);
      y._v = y._v + 24.0;
    }
    // Inline function 'kotlin.apply' call
    var this_5 = kinTextButton(_this__u8e3s4, '\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u0441\u043A\u0443', theme.cdf_1, VictoryScene$sceneMain$lambda_5);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.VictoryScene.sceneMain.<anonymous>' call
    this_5.fc7(Companion_getInstance_6().t4t_1);
    position(this_5, cx, y._v);
  }
}
class DefeatScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var cx = w / 2.0;
    var record = GameSession_getInstance().gde_1;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, DefeatScene$sceneMain$lambda);
    var y = {_v: 128.0};
    var tmp = Type_instance.jdf();
    kinText_0(_this__u8e3s4, '\u041F\u0410\u0420\u0422\u0418\u042F \u0417\u0410\u0412\u0415\u0420\u0428\u0415\u041D\u0410', tmp, theme.cdf_1, DefeatScene$sceneMain$lambda_0(cx, y));
    y._v = y._v + 24.0;
    var tmp_0 = Fonts_instance.kdf();
    kinText(_this__u8e3s4, '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435', 36.0, theme.adf_1, tmp_0, DefeatScene$sceneMain$lambda_1(cx, y));
    y._v = y._v + 50.0;
    var tmp_1 = Type_instance.wdf();
    kinText_0(_this__u8e3s4, '\u0422\u0440\u0435\u0449\u0438\u043D\u0443 \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u0442 \u0437\u043E\u043B\u043E\u0442\u043E', tmp_1, theme.cdf_1, DefeatScene$sceneMain$lambda_2(cx, y));
    y._v = y._v + (22.0 + 32.0);
    position(kinBrokenStone(_this__u8e3s4, theme), cx - 52.0, y._v);
    y._v = y._v + (104.0 + 24.0);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.DefeatScene.sceneMain.<anonymous>' call
    kinSeam(this_1, 120.0, 6.0, 30.0, 26.0, 1.3, 3.0, 61, true, VOID, VOID, theme.gdf_1, theme.hdf_1);
    kinSeam(this_1, 120.0, 6.0, 214.0, 22.0, 1.2, 3.0, 67, true, VOID, VOID, theme.gdf_1, theme.hdf_1);
    position(this_1, cx - 120.0, y._v);
    y._v = y._v + (34.0 + 22.0);
    var btnW = 280.0;
    var btnX = cx - btnW / 2.0;
    position(kinButton(_this__u8e3s4, btnW, '\u0420\u0435\u0432\u0430\u043D\u0448', true, VOID, VOID, true, VOID, theme, DefeatScene$sceneMain$lambda_3), btnX, y._v);
    y._v = y._v + (52.0 + 12.0);
    position(kinButton(_this__u8e3s4, btnW, '\u0412 \u043C\u0435\u043D\u044E', VOID, VOID, VOID, true, VOID, theme, DefeatScene$sceneMain$lambda_4), btnX, y._v);
    y._v = y._v + (52.0 + 16.0);
    if (!(record == null)) {
      // Inline function 'kotlin.apply' call
      var this_2 = kinTextButton(_this__u8e3s4, '\u041A\u0438\u0444\u0443 \u043F\u0430\u0440\u0442\u0438\u0438 \u2192', theme.cdf_1, DefeatScene$sceneMain$lambda_5(record));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.DefeatScene.sceneMain.<anonymous>' call
      this_2.fc7(Companion_getInstance_6().t4t_1);
      position(this_2, cx, y._v);
      y._v = y._v + 24.0;
    }
    // Inline function 'kotlin.apply' call
    var this_3 = kinTextButton(_this__u8e3s4, '\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u0441\u043A\u0443', theme.cdf_1, DefeatScene$sceneMain$lambda_6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.DefeatScene.sceneMain.<anonymous>' call
    this_3.fc7(Companion_getInstance_6().t4t_1);
    position(this_3, cx, y._v);
  }
}
class GameScene$sceneMain$slambda$slambda {
  constructor($ai, $game) {
    this.adm_1 = $ai;
    this.bdm_1 = $game;
  }
  a1r($this$withContext, $completion) {
    return this.adm_1.jdc(this.bdm_1);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.ddp_1 = lazy_0(GameScene$Companion$petalBitmap$delegate$lambda);
  }
  edp() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ddp_1;
    petalBitmap$factory();
    return this_0.u1();
  }
}
class GameScene$sceneMain$slambda {
  constructor($game, this$0, $petalLayer, $boardX, $boardY) {
    this.vdk_1 = $game;
    this.wdk_1 = this$0;
    this.xdk_1 = $petalLayer;
    this.ydk_1 = $boardX;
    this.zdk_1 = $boardY;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$lambda$lambda$slambda {
  constructor(this$0) {
    this.ndl_1 = this$0;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$lambda$slambda {
  constructor($game, $mode, $res, this$0) {
    this.odl_1 = $game;
    this.pdl_1 = $mode;
    this.qdl_1 = $res;
    this.rdl_1 = this$0;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$lambda$slambda_0 {
  constructor(this$0) {
    this.sdl_1 = this$0;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$slambda_0 {
  constructor($mode, $game, this$0, $aiThinking, $renderUi, $applyMoveRef, $ai) {
    this.tdl_1 = $mode;
    this.udl_1 = $game;
    this.vdl_1 = this$0;
    this.wdl_1 = $aiThinking;
    this.xdl_1 = $renderUi;
    this.ydl_1 = $applyMoveRef;
    this.zdl_1 = $ai;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class GameScene$sceneMain$slambda_1 {
  constructor(this$0) {
    this.cdm_1 = this$0;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$aiTurnRef$slambda {
  fe($completion) {
    return Unit_instance;
  }
}
class GameScene$playStoneSound$slambda {
  constructor($it) {
    this.ddm_1 = $it;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene extends Scene {
  constructor() {
    Companion_getInstance_23();
    super();
    var tmp = this;
    tmp.kdl_1 = GameScene$aiTurnRef$slambda_0();
    var tmp_0 = this;
    tmp_0.ldl_1 = lazy_0(GameScene$vibration$delegate$lambda(this));
    this.mdl_1 = null;
  }
  tag(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
class HelpScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var h = 720;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, HelpScene$sceneMain$lambda);
    // Inline function 'kotlin.apply' call
    var this_0 = kinTextButton(_this__u8e3s4, '\u2190 \u041D\u0430\u0437\u0430\u0434', theme.cdf_1, HelpScene$sceneMain$lambda_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.HelpScene.sceneMain.<anonymous>' call
    this_0.fc7(Companion_getInstance_6().s4t_1);
    position(this_0, 24.0, 22.0);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.HelpScene.sceneMain.<anonymous>' call
    var content = addTo(this_1, _this__u8e3s4);
    var y = {_v: 56.0};
    var tmp = Type_instance.g9g();
    kinText_0(content, '\u041F\u043E\u043C\u043E\u0449\u044C', tmp, theme.adf_1, HelpScene$sceneMain$lambda_1(y));
    y._v = y._v + 44.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, content);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.HelpScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_3, 2.0, 9.0, 108.0, 11.0, 1.3, 3.0, 53, true, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_3, 24.0, y._v - 4.0);
    y._v = y._v + 16.0;
    var tmp_0 = Type_instance.edq();
    kinText_0(content, '\u041F\u0420\u0410\u0412\u0418\u041B\u0410 \u0418 \u0421\u041E\u0412\u0415\u0422\u042B', tmp_0, theme.cdf_1, HelpScene$sceneMain$lambda_2(y));
    y._v = y._v + 36.0;
    var _iterator__ex2g4s = Str_getInstance().sdk_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var entry = _iterator__ex2g4s.c1();
      renderEntry(this, content, y._v, entry, theme);
      y._v = y._v + (entryHeight(this, entry, theme) + 16.0);
    }
    var contentH = y._v + 24.0;
    var minY = coerceAtMost(h - contentH, 0.0);
    var baseY = {_v: 0.0};
    onMouseDrag(_this__u8e3s4, VOID, VOID, HelpScene$sceneMain$lambda_3(baseY, content, minY));
  }
}
class DotKind extends Enum {}
class JournalScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var h = 720;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, JournalScene$sceneMain$lambda);
    // Inline function 'kotlin.apply' call
    var this_0 = kinTextButton(_this__u8e3s4, '\u2190 \u041D\u0430\u0437\u0430\u0434', theme.cdf_1, JournalScene$sceneMain$lambda_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.JournalScene.sceneMain.<anonymous>' call
    this_0.fc7(Companion_getInstance_6().s4t_1);
    position(this_0, 24.0, 22.0);
    var y = {_v: 56.0};
    var tmp = Type_instance.g9g();
    kinText_0(_this__u8e3s4, '\u0416\u0443\u0440\u043D\u0430\u043B', tmp, theme.adf_1, JournalScene$sceneMain$lambda_1(y));
    y._v = y._v + 44.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.JournalScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_2, 2.0, 6.0, 94.0, 6.0, 1.3, 2.5, 71, VOID, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_2, 24.0, y._v);
    y._v = y._v + 18.0;
    var tmp_0 = Type_instance.edq().fdm_1;
    var tmp_1 = Fonts_instance.adg();
    kinText(_this__u8e3s4, '\u041A\u0418\u0424\u0423 \u0421\u042B\u0413\u0420\u0410\u041D\u041D\u042B\u0425 \u041F\u0410\u0420\u0422\u0418\u0419', tmp_0, theme.cdf_1, tmp_1, JournalScene$sceneMain$lambda_2(y));
    y._v = y._v + 32.0;
    var unfinished = GameSession_getInstance().bde_1.ed8_1.equals(GameState_PLAYING_getInstance()) && GameSession_getInstance().bde_1.fd9() > 0;
    var records = take(RecordsStore_getInstance().ddb_1.xda_1, unfinished ? 3 : 4);
    if (!unfinished && records.g1()) {
      var tmp_2 = Type_instance.wdf();
      kinText_0(_this__u8e3s4, '\u041F\u0430\u0440\u0442\u0438\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u2014 \u0441\u044B\u0433\u0440\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0432\u0443\u044E.', tmp_2, theme.cdf_1, JournalScene$sceneMain$lambda_3(w, y));
    }
    if (unfinished) {
      var g = GameSession_getInstance().bde_1;
      var tmp_3 = y._v;
      var tmp_4 = g.gd9();
      var tmp_5 = modeLine(this, GameSession_getInstance().cde_1.equals(GameMode_AI_getInstance()) ? 'ai' : 'pvp', SettingsStore_getInstance().ddc_1.rdb_1);
      var tmp_6 = '\u041D\u0435 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430 \xB7 \u0445\u043E\u0434 ' + g.fd9();
      var tmp_7 = DotKind_UNFINISHED_getInstance();
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp_8 = !records.g1();
      y._v = renderRow(this, _this__u8e3s4, tmp_3, w, theme, tmp_4, null, tmp_5, tmp_6, tmp_7, true, tmp_8, JournalScene$sceneMain$lambda_4);
    }
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = records.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'scenes.JournalScene.sceneMain.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var i = checkIndexOverflow(tmp1);
      var tmp_9 = y._v;
      var tmp_10 = dateLabel(this, item.zd9_1) + ' \xB7 ' + modeLine(this, item.ada_1, item.bda_1);
      var tmp_11 = resultLabel(this, item);
      var tmp_12 = dotKind(this, item);
      var tmp_13 = i < (records.e1() - 1 | 0);
      y._v = renderRow(this, _this__u8e3s4, tmp_9, w, theme, item.eda_1, item.fda_1, tmp_10, tmp_11, tmp_12, false, tmp_13, JournalScene$sceneMain$lambda_5(item));
    }
    var s = RecordsStore_getInstance().ddb_1.wda_1;
    if (s.kda_1 > 0) {
      var footerY = h - 40.0;
      // Inline function 'korlibs.korge.view.solidRect' call
      var width = w - 48.0;
      var color = theme.ddf_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = SolidRect.rc2(Size2D.u2l(width, 1.0), color);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, _this__u8e3s4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.JournalScene.sceneMain.<anonymous>' call
      position(this_4, 24.0, footerY - 16.0);
      var statsLine = '' + s.kda_1 + ' ' + Str_getInstance().sdq(s.kda_1) + ' \xB7 ' + s.lda_1 + ' ' + Str_getInstance().tdq(s.lda_1) + (' \xB7 \u043B\u0443\u0447\u0448\u0430\u044F \u0441\u0435\u0440\u0438\u044F ' + s.nda_1);
      var tmp_14 = capsTracked(statsLine, 0);
      var tmp_15 = Fonts_instance.adg();
      kinText(_this__u8e3s4, tmp_14, 11.0, theme.cdf_1, tmp_15, JournalScene$sceneMain$lambda_6(w, footerY));
    }
  }
}
class KifuScene$sceneMain$lambda$slambda {
  constructor(this$0, $status) {
    this.udq_1 = this$0;
    this.vdq_1 = $status;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KifuScene$sceneMain$lambda$slambda_0 {
  constructor($board, this$0, $status) {
    this.wdq_1 = $board;
    this.xdq_1 = this$0;
    this.ydq_1 = $status;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KifuScene extends Scene {
  constructor(record, onBack) {
    super();
    this.jdr_1 = record;
    this.kdr_1 = onBack;
  }
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, KifuScene$sceneMain$lambda(this));
    // Inline function 'kotlin.apply' call
    var this_0 = kinTextButton(_this__u8e3s4, '\u2190 \u041D\u0430\u0437\u0430\u0434', theme.cdf_1, KifuScene$sceneMain$lambda_0(this));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.KifuScene.sceneMain.<anonymous>' call
    this_0.fc7(Companion_getInstance_6().s4t_1);
    position(this_0, 24.0, 22.0);
    var y = {_v: 56.0};
    var tmp = Type_instance.g9g();
    kinText_0(_this__u8e3s4, '\u041A\u0438\u0444\u0443', tmp, theme.adf_1, KifuScene$sceneMain$lambda_1(y));
    y._v = y._v + 44.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.KifuScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_2, 2.0, 6.0, 94.0, 6.0, 1.3, 2.5, 23, VOID, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_2, 24.0, y._v);
    y._v = y._v + 18.0;
    var tmp_0;
    switch (this.jdr_1.cda_1.t3_1) {
      case 1:
        tmp_0 = '\u0427\u0451\u0440\u043D\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
        break;
      case 2:
        tmp_0 = '\u0411\u0435\u043B\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
        break;
      case 3:
        tmp_0 = '\u041D\u0438\u0447\u044C\u044F';
        break;
      case 0:
        tmp_0 = '\u041F\u0430\u0440\u0442\u0438\u044F \u043D\u0435 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var resultLabel = tmp_0;
    var tmp_1 = capsTracked(resultLabel + ' \xB7 \u0445\u043E\u0434\u043E\u0432: ' + this.jdr_1.eda_1.e1(), 0);
    var tmp_2 = Type_instance.edq().fdm_1;
    var tmp_3 = Fonts_instance.adg();
    kinText(_this__u8e3s4, tmp_1, tmp_2, theme.cdf_1, tmp_3, KifuScene$sceneMain$lambda_2(y));
    y._v = y._v + 34.0;
    var board = renderKifuBoard(this, _this__u8e3s4, (w - 336.0) / 2.0, y._v, theme);
    y._v = y._v + (336.0 + 18.0);
    var tmp_4 = Type_instance.gdp().fdm_1;
    var tmp_5 = Fonts_instance.tdp();
    var status = kinText(_this__u8e3s4, '', tmp_4, theme.cdf_1, tmp_5, KifuScene$sceneMain$lambda_3(w, y));
    var btnW = (w - 24.0 * 2.0 - 10.0) / 2.0;
    position(kinButton(_this__u8e3s4, btnW, '\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F', VOID, true, VOID, true, VOID, theme, KifuScene$sceneMain$lambda_4(this, status)), 24.0, y._v);
    position(kinButton(_this__u8e3s4, btnW, '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C', true, true, VOID, true, VOID, theme, KifuScene$sceneMain$lambda_5(this, board, status)), 24.0 + btnW + 10.0, y._v);
  }
}
class MenuScene$sceneMain$slambda {
  constructor(this$0) {
    this.udr_1 = this$0;
  }
  fa6(it, $completion) {
    if (it.f6n_1.equals(Key_ESCAPE_getInstance())) {
      this.udr_1.eae().i8x();
      it.i6m();
    }
  }
  ge(p1, $completion) {
    return this.fa6(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class MenuScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var h = 720;
    var centerX = w / 2.0;
    kinPaperBackground(_this__u8e3s4, theme);
    var tmp = get_keys(_this__u8e3s4);
    tmp.ha6(MenuScene$sceneMain$slambda_0(this));
    var tmp_0 = theme.idf_1 ? '\u263E' : '\u2600';
    position(kinIconRound(_this__u8e3s4, tmp_0, theme, MenuScene$sceneMain$lambda), w - 56.0, 36.0);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.MenuScene.sceneMain.<anonymous>' call
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var indexedObject = '\u4E94\u76EE\u4E26\u3079';
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var item = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'scenes.MenuScene.sceneMain.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp_1 = toString_1(item);
      var tmp_2 = Fonts_instance.zdf();
      kinText(this_1, tmp_1, 10.0, theme.cdf_1, tmp_2, MenuScene$sceneMain$lambda_0(tmp1));
    }
    this_1.kas(0.5);
    position(this_1, w - 29.0, 118.0);
    var y = {_v: 64.0};
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.MenuScene.sceneMain.<anonymous>' call
    kinEnso(this_3, 96.0, theme);
    position(this_3, centerX - 48.0, y._v);
    y._v = y._v + (96.0 + 8.0);
    var tmp_3 = Type_instance.kds().fdm_1;
    var tmp_4 = Fonts_instance.zdf();
    kinText(_this__u8e3s4, '\u4E94\u76EE', tmp_3, theme.adf_1, tmp_4, MenuScene$sceneMain$lambda_1(centerX, y));
    y._v = y._v + (Type_instance.kds().fdm_1 + 12.0);
    var tmp_5 = Type_instance.lds();
    kinText_0(_this__u8e3s4, 'G  O  M  O  K  U', tmp_5, theme.cdf_1, MenuScene$sceneMain$lambda_2(centerX, y));
    y._v = y._v + 18.0;
    var tmp_6 = Type_instance.wdf();
    kinText_0(_this__u8e3s4, '\u041F\u044F\u0442\u044C \u043A\u0430\u043C\u043D\u0435\u0439 \u0432 \u0440\u044F\u0434', tmp_6, theme.cdf_1, MenuScene$sceneMain$lambda_3(centerX, y));
    y._v = y._v + 22.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.MenuScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_5, 6.0, 22.0, 214.0, 12.0, 1.5, 4.0, 31, true, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_5, centerX - 110.0, y._v);
    y._v = y._v + (34.0 + 36.0);
    var btnW = 280.0;
    var btnX = centerX - btnW / 2.0;
    position(kinButton(_this__u8e3s4, btnW, '\u0418\u0433\u0440\u0430 \u0441 AI', true, VOID, true, VOID, VOID, theme, MenuScene$sceneMain$lambda_4), btnX, y._v);
    y._v = y._v + (52.0 + 12.0);
    position(kinButton(_this__u8e3s4, btnW, '\u0418\u0433\u0440\u0430 \u0432\u0434\u0432\u043E\u0451\u043C', VOID, VOID, true, VOID, VOID, theme, MenuScene$sceneMain$lambda_5), btnX, y._v);
    y._v = y._v + (52.0 + 12.0);
    var gap = 12.0;
    var smallW = (btnW - gap) / 2.0;
    position(kinButton(_this__u8e3s4, smallW, '\u0416\u0443\u0440\u043D\u0430\u043B', VOID, true, VOID, VOID, VOID, theme, MenuScene$sceneMain$lambda_6), btnX, y._v);
    position(kinButton(_this__u8e3s4, smallW, '\u041F\u0435\u0447\u0430\u0442\u0438', VOID, true, VOID, VOID, VOID, theme, MenuScene$sceneMain$lambda_7), btnX + smallW + gap, y._v);
    y._v = y._v + (44.0 + 8.0);
    position(kinButton(_this__u8e3s4, smallW, '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438', VOID, true, VOID, VOID, VOID, theme, MenuScene$sceneMain$lambda_8), btnX, y._v);
    position(kinButton(_this__u8e3s4, smallW, '\u041F\u043E\u043C\u043E\u0449\u044C', VOID, true, VOID, VOID, VOID, theme, MenuScene$sceneMain$lambda_9), btnX + smallW + gap, y._v);
    y._v = y._v + (44.0 + 18.0);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(this_6, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.MenuScene.sceneMain.<anonymous>' call
    var tmp_7 = Type_instance.wdf().fdm_1;
    var tmp_8 = Fonts_instance.fdp();
    var part1 = kinText(this_7, '\u0427\u0430\u0439\u043D\u0430\u044F ', tmp_7, theme.cdf_1, tmp_8, MenuScene$sceneMain$lambda_10);
    var tmp_9 = Type_instance.wdf().fdm_1;
    var tmp_10 = Fonts_instance.zdf();
    var part2 = kinText(this_7, '\u8336 \u2192', tmp_9, theme.cdf_1, tmp_10, MenuScene$sceneMain$lambda_11(part1));
    var totalW = part1.mbi() + part2.mbi();
    position(this_7, centerX - totalW / 2.0, y._v);
    // Inline function 'korlibs.korge.input.onClick' call
    // Inline function 'korlibs.korge.view.solidRect' call
    var color = Colors_getInstance().d45_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_8 = SolidRect.rc2(Size2D.u2l(totalW, 20.0), color);
    // Inline function 'kotlin.apply' call
    var this_9 = addTo(this_8, this_7);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var handler = MenuScene$sceneMain$lambda_12;
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_0();
    var tmp1_safe_receiver = this_9 == null ? null : this_9.far();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_11 = prop.get(tmp1_safe_receiver_0);
          tmp_11.p22(MenuScene$sceneMain$lambda_13(handler));
        }
      }
    }
    var footerY = h - 28.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_10 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_11 = addTo(this_10, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.MenuScene.sceneMain.<anonymous>' call
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.u2l(16.0, 16.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var radius = new RectCorners(numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    var fill = new RGBA(theme.fdf_1);
    var stroke = new RGBA(Colors_getInstance().y44_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_12 = RoundRect.hc0(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    addTo(this_12, this_11);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    var tmp_12 = get_KIN_LIGHT().xde_1;
    var tmp_13 = Fonts_instance.zdf();
    kinText(this_11, '\u4E94', 10.0, tmp_12, tmp_13, MenuScene$sceneMain$lambda_14);
    this_11.kas(0.9);
    position(this_11, centerX - 96.0, footerY - 8.0);
    var tmp_14 = Fonts_instance.adg();
    kinText(_this__u8e3s4, '2026 \xB7 KORGE EDITION', 11.0, theme.cdf_1, tmp_14, MenuScene$sceneMain$lambda_15(centerX, footerY));
  }
}
class GameMode extends Enum {}
class GameSession {
  constructor() {
    GameSession_instance = this;
    this.ade_1 = 3;
    this.bde_1 = new GameLogic();
    this.cde_1 = GameMode_PVP_getInstance();
    this.dde_1 = StoneColor_WHITE_getInstance();
    this.ede_1 = 3;
    this.fde_1 = false;
    this.gde_1 = null;
    this.hde_1 = emptyList();
  }
  ide(mode) {
    this.bde_1 = new GameLogic(SettingsStore_getInstance().ddc_1.qdb_1.equals(Rules_RENJU_getInstance()));
    this.cde_1 = mode;
    this.ede_1 = 3;
    this.fde_1 = false;
    this.gde_1 = null;
    this.hde_1 = emptyList();
    if (mode.equals(GameMode_AI_getInstance())) {
      var tmp = this;
      var tmp_0;
      switch (SettingsStore_getInstance().ddc_1.wdb_1.t3_1) {
        case 2:
          tmp_0 = StoneColor_BLACK_getInstance();
          break;
        case 1:
          tmp_0 = StoneColor_WHITE_getInstance();
          break;
        case 0:
          tmp_0 = this.dde_1.vd8();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp.dde_1 = tmp_0;
    }
  }
  mdp() {
    this.gde_1 = null;
    this.hde_1 = emptyList();
  }
  ldp() {
    var g = this.bde_1;
    if (g.ed8_1.equals(GameState_PLAYING_getInstance()) || !(this.gde_1 == null))
      return Unit_instance;
    var tmp = _DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance_0().i1y());
    var tmp_0 = this.cde_1.equals(GameMode_AI_getInstance()) ? 'ai' : 'pvp';
    var tmp_1 = this.cde_1.equals(GameMode_AI_getInstance()) ? SettingsStore_getInstance().ddc_1.rdb_1 : null;
    var tmp_2 = g.ed8_1;
    var tmp_3 = this.cde_1.equals(GameMode_AI_getInstance()) ? this.dde_1 : null;
    var tmp_4 = g.gd9();
    var tmp0_safe_receiver = g.gd8_1;
    var record = new GameRecord(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xdd_1);
    this.gde_1 = record;
    this.hde_1 = RecordsStore_getInstance().jdb(record, this.fde_1);
  }
}
class Nav$goMenu$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class Nav$goGame$slambda {
  constructor($mode) {
    this.nds_1 = $mode;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class Nav$goGameKeepState$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class Nav$goSettings$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
  }
}
class Nav$goHelp$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class Nav$goJournal$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class Nav$goSeals$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class Nav$goTea$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this), $completion);
  }
}
class Nav$goVictory$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this), $completion);
  }
}
class Nav$goDefeat$slambda {
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this), $completion);
  }
}
class Nav$goKifu$slambda {
  constructor($record, $back) {
    this.ods_1 = $record;
    this.pds_1 = $back;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this), $completion);
  }
}
class Nav$launch$slambda {
  constructor($block) {
    this.qds_1 = $block;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this), $completion);
  }
}
class Nav {
  constructor() {
    Nav_instance = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.jdd_1 = toDuration(220, DurationUnit_MILLISECONDS_getInstance());
  }
  mds() {
    var tmp = this.idd_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('container');
    }
  }
  zdd() {
    return launch_0(this, Nav$goMenu$slambda_0());
  }
  vdr(mode) {
    return launch_0(this, Nav$goGame$slambda_0(mode));
  }
  jde() {
    return launch_0(this, Nav$goGameKeepState$slambda_0());
  }
  xdr() {
    return launch_0(this, Nav$goSettings$slambda_0());
  }
  ydr() {
    return launch_0(this, Nav$goHelp$slambda_0());
  }
  hdq() {
    return launch_0(this, Nav$goJournal$slambda_0());
  }
  wdr() {
    return launch_0(this, Nav$goSeals$slambda_0());
  }
  zdr() {
    return launch_0(this, Nav$goTea$slambda_0());
  }
  kde() {
    return launch_0(this, Nav$goVictory$slambda_0());
  }
  ldf() {
    return launch_0(this, Nav$goDefeat$slambda_0());
  }
  lde(record, back) {
    return launch_0(this, Nav$goKifu$slambda_0(record, back));
  }
}
class onBackOrEscape$slambda {
  constructor($handler) {
    this.rds_1 = $handler;
  }
  fa6(it, $completion) {
    if (it.f6n_1.equals(Key_BACK_getInstance()) || it.f6n_1.equals(Key_ESCAPE_getInstance())) {
      this.rds_1();
      it.i6m();
    }
  }
  ge(p1, $completion) {
    return this.fa6(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class SealsScene extends Scene {
  constructor() {
    super();
    this.cdt_1 = listOf([-2.5, 1.5, -1.0, 2.0, 1.0, -1.5, 2.5, -2.0, 1.0]);
  }
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var stats = RecordsStore_getInstance().ddb_1.wda_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var this_0 = Seals_getInstance().zda_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var count = 0;
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
        if (stats.qda_1.z2(element)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$0 = count;
    }
    var got = tmp$ret$0;
    var complete = Seals_getInstance().cdb(stats);
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, SealsScene$sceneMain$lambda);
    // Inline function 'kotlin.apply' call
    var this_1 = kinTextButton(_this__u8e3s4, '\u2190 \u041D\u0430\u0437\u0430\u0434', theme.cdf_1, SealsScene$sceneMain$lambda_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
    this_1.fc7(Companion_getInstance_6().s4t_1);
    position(this_1, 24.0, 22.0);
    var y = {_v: 56.0};
    var tmp_0 = Type_instance.g9g();
    kinText_0(_this__u8e3s4, '\u041F\u0435\u0447\u0430\u0442\u0438', tmp_0, theme.adf_1, SealsScene$sceneMain$lambda_1(y));
    y._v = y._v + 44.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_3, 2.0, 6.0, 94.0, 6.0, 1.3, 2.5, 77, VOID, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_3, 24.0, y._v);
    y._v = y._v + 18.0;
    var tmp_1 = '\u0421\u041E\u0411\u0420\u0410\u041D\u041E ' + got + ' \u0418\u0417 ' + Seals_getInstance().zda_1.e1();
    var tmp_2 = Type_instance.edq().fdm_1;
    var tmp_3 = Fonts_instance.adg();
    kinText(_this__u8e3s4, tmp_1, tmp_2, theme.cdf_1, tmp_3, SealsScene$sceneMain$lambda_2(y));
    y._v = y._v + 22.0;
    var barW = w - 48.0;
    // Inline function 'korlibs.korge.view.solidRect' call
    var color = theme.ddf_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = SolidRect.rc2(Size2D.u2l(barW, 1.0), color);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
    position(this_5, 24.0, y._v + 6.0);
    if (got > 0) {
      // Inline function 'korlibs.korge.view.container' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_6 = Container.cae(false);
      // Inline function 'kotlin.apply' call
      var this_7 = addTo(this_6, _this__u8e3s4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
      var tmp0_x2 = barW * got / Seals_getInstance().zda_1.e1();
      var tmp1_color = theme.gdf_1;
      var tmp2_colorSoft = theme.hdf_1;
      kinSeam(this_7, 1.0, 6.0, tmp0_x2, 6.0, 1.2, 1.5, 79, VOID, VOID, VOID, tmp1_color, tmp2_colorSoft);
      position(this_7, 24.0, y._v);
    }
    y._v = y._v + 24.0;
    if (complete) {
      var cardH = 78.0;
      // Inline function 'korlibs.korge.view.roundRect' call
      var size = Size2D.u2l(barW, cardH);
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_2();
      var radius = new RectCorners(numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0));
      var fill = new RGBA(Colors_getInstance().d45_1);
      var stroke = new RGBA(theme.ddf_1);
      // Inline function 'korlibs.korge.view.addTo' call
      var this_8 = RoundRect.hc0(size, radius, fill, stroke, 1.0, true);
      // Inline function 'kotlin.apply' call
      var this_9 = addTo(this_8, _this__u8e3s4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
      position(this_9, 24.0, y._v);
      renderTile(this, _this__u8e3s4, 24.0 + 14.0, y._v + (cardH - 52.0) / 2.0, 52.0, '\u6975', theme.gdf_1, true, theme);
      var tmp_4 = Fonts_instance.adg();
      kinText(_this__u8e3s4, '\u041C\u0410\u0421\u0422\u0415\u0420\u0421\u041A\u0410\u042F \u041F\u0415\u0427\u0410\u0422\u042C', 9.0, theme.gdf_1, tmp_4, SealsScene$sceneMain$lambda_3(y));
      var tmp_5 = Fonts_instance.udk();
      kinText(_this__u8e3s4, '\u6975 \xB7 \u0412\u0435\u0440\u0448\u0438\u043D\u0430', 13.0, theme.adf_1, tmp_5, SealsScene$sceneMain$lambda_4(y));
      var tmp_6 = Fonts_instance.tdp();
      kinText(_this__u8e3s4, '\u0412\u0441\u0435 \u043F\u0435\u0447\u0430\u0442\u0438 \u0441\u043E\u0431\u0440\u0430\u043D\u044B \u2014 \u0443\u0437\u043E\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D \u0437\u043E\u043B\u043E\u0442\u043E\u043C.', 11.0, theme.cdf_1, tmp_6, SealsScene$sceneMain$lambda_5(y));
      y._v = y._v + (cardH + 16.0);
    }
    var cellW = barW / 3.0;
    var tileSize = 62.0;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_0 = Seals_getInstance().zda_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var i = checkIndexOverflow(tmp1);
      var col = i % 3 | 0;
      var rowI = i / 3 | 0;
      var cx = 24.0 + col * cellW + cellW / 2.0;
      var ty = y._v + rowI * 100.0;
      var gotIt = stats.qda_1.z2(item);
      // Inline function 'korlibs.korge.view.container' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_10 = Container.cae(false);
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.SealsScene.sceneMain.<anonymous>.<anonymous>' call
      var tile = addTo(this_10, _this__u8e3s4);
      _this__u8e3s4.waq(tile);
      if (gotIt) {
        renderTile(this, tile, -tileSize / 2.0, 0.0, tileSize, item, theme.fdf_1, false, theme);
        tile.fas(get_degrees(this.cdt_1.d1(i)));
      } else {
        // Inline function 'korlibs.korge.view.roundRect' call
        var size_0 = Size2D.u2l(tileSize, tileSize);
        // Inline function 'korlibs.math.geom.Companion.invoke' call
        Companion_getInstance_2();
        var radius_0 = new RectCorners(numberToDouble(6.0), numberToDouble(6.0), numberToDouble(6.0), numberToDouble(6.0));
        var fill_0 = new RGBA(Colors_getInstance().d45_1);
        var stroke_0 = new RGBA(theme.ddf_1);
        // Inline function 'korlibs.korge.view.addTo' call
        var this_11 = RoundRect.hc0(size_0, radius_0, fill_0, stroke_0, 1.0, true);
        // Inline function 'kotlin.apply' call
        var this_12 = addTo(this_11, tile);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
        position(this_12, -tileSize / 2.0, 0.0);
        var tmp_7 = Fonts_instance.zdf();
        kinText(tile, item, 30.0, theme.adf_1, tmp_7, SealsScene$sceneMain$lambda_6(tileSize));
      }
      position(tile, cx, ty);
      var tmp_8 = Str_getInstance().tdk(item);
      var tmp_9 = gotIt ? theme.bdf_1 : theme.cdf_1;
      var tmp_10 = Fonts_instance.tdp();
      kinText(_this__u8e3s4, tmp_8, 10.0, tmp_9, tmp_10, SealsScene$sceneMain$lambda_7(cx, ty, tileSize, gotIt));
    }
    y._v = y._v + (3 * 100.0 + 6.0);
    // Inline function 'korlibs.korge.view.solidRect' call
    var color_0 = theme.ddf_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_13 = SolidRect.rc2(Size2D.u2l(barW, 1.0), color_0);
    // Inline function 'kotlin.apply' call
    var this_14 = addTo(this_13, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
    position(this_14, 24.0, y._v);
    y._v = y._v + 16.0;
    var legendSize = 52.0;
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.korge.view.roundRect' call
    var size_1 = Size2D.u2l(legendSize, legendSize);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var radius_1 = new RectCorners(numberToDouble(6.0), numberToDouble(6.0), numberToDouble(6.0), numberToDouble(6.0));
    var fill_1 = new RGBA(Colors_getInstance().d45_1);
    var stroke_1 = new RGBA(theme.gdf_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_15 = RoundRect.hc0(size_1, radius_1, fill_1, stroke_1, 1.0, true);
    // Inline function 'kotlin.apply' call
    var this_16 = addTo(this_15, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
    position(this_16, 24.0, y._v);
    this_16.kas(0.85);
    if (complete) {
      var tmp_11 = Fonts_instance.zdf();
      kinText(_this__u8e3s4, '\u548C', 24.0, theme.gdf_1, tmp_11, SealsScene$sceneMain$lambda_8(legendSize, y));
    } else {
      // Inline function 'korlibs.korge.view.circle' call
      var fill_2 = new RGBA(theme.gdf_1);
      var stroke_2 = new RGBA(Colors_getInstance().y44_1);
      var renderer = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call
      var this_17 = Circle.hbd(numberToDouble(4.0), fill_2, stroke_2, numberToDouble(0.0), true, renderer);
      // Inline function 'kotlin.apply' call
      var this_18 = addTo(this_17, _this__u8e3s4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.SealsScene.sceneMain.<anonymous>' call
      position(this_18, 24.0 + legendSize / 2.0 - 4.0, y._v + legendSize / 2.0 - 4.0);
      this_18.kas(0.6);
    }
    var lx = 24.0 + legendSize + 14.0;
    var tmp_12 = complete ? '\u041B\u0415\u0413\u0415\u041D\u0414\u0410 \xB7 \u0412\u041D\u0415 \u041A\u041E\u041B\u041B\u0415\u041A\u0426\u0418\u0418' : '\u041B\u0415\u0413\u0415\u041D\u0414\u0410';
    var tmp_13 = Fonts_instance.adg();
    kinText(_this__u8e3s4, tmp_12, 9.0, theme.gdf_1, tmp_13, SealsScene$sceneMain$lambda_9(lx, y));
    var tmp_14 = complete ? '\u548C \xB7 \u041D\u0438\u0447\u044C\u044F' : '\u0417\u043E\u043B\u043E\u0442\u0430\u044F \u043F\u0435\u0447\u0430\u0442\u044C';
    var tmp_15 = Fonts_instance.udk();
    kinText(_this__u8e3s4, tmp_14, 13.0, theme.adf_1, tmp_15, SealsScene$sceneMain$lambda_10(lx, y));
    var tmp_16 = complete ? '225 \u043A\u0430\u043C\u043D\u0435\u0439 \u0438 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u043F\u044F\u0442\u0451\u0440\u043A\u0438. \u041F\u043E\u0447\u0442\u0438 \u043D\u0438\u043A\u0442\u043E \u0435\u0451 \u043D\u0435 \u0432\u0438\u0434\u0435\u043B.' : '\u041E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F, \u043A\u043E\u0433\u0434\u0430 \u0441\u043E\u0431\u0435\u0440\u0451\u0442\u0435 \u0432\u0441\u0435 \u0434\u0435\u0432\u044F\u0442\u044C \u043F\u0435\u0447\u0430\u0442\u0435\u0439.';
    var tmp_17 = Fonts_instance.tdp();
    kinText(_this__u8e3s4, tmp_16, 11.0, theme.cdf_1, tmp_17, SealsScene$sceneMain$lambda_11(lx, y));
    y._v = y._v + (legendSize + 22.0);
    var tmp_18 = complete ? '\u0423\u0437\u043E\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D. \u041E\u0441\u0442\u0430\u043B\u0430\u0441\u044C \u043B\u0435\u0433\u0435\u043D\u0434\u0430.' : '\u041F\u0435\u0447\u0430\u0442\u0438 \u0441\u0442\u0430\u0432\u044F\u0442\u0441\u044F \u0441\u0430\u043C\u0438 \u2014 \u043F\u0440\u043E\u0441\u0442\u043E \u0438\u0433\u0440\u0430\u0439\u0442\u0435.';
    var tmp_19 = Type_instance.wdf().fdm_1;
    var tmp_20 = Fonts_instance.fdp();
    kinText(_this__u8e3s4, tmp_18, tmp_19, theme.cdf_1, tmp_20, SealsScene$sceneMain$lambda_12(w, y));
  }
}
class SettingsScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, SettingsScene$sceneMain$lambda);
    // Inline function 'kotlin.apply' call
    var this_0 = kinTextButton(_this__u8e3s4, '\u2190 \u041D\u0430\u0437\u0430\u0434', theme.cdf_1, SettingsScene$sceneMain$lambda_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    this_0.fc7(Companion_getInstance_6().s4t_1);
    position(this_0, 24.0, 22.0);
    var y = {_v: 56.0};
    var tmp = Type_instance.g9g();
    kinText_0(_this__u8e3s4, '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438', tmp, theme.adf_1, SettingsScene$sceneMain$lambda_1(y));
    y._v = y._v + 44.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_2, 2.0, 6.0, 94.0, 6.0, 1.3, 2.5, 41, VOID, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_2, 24.0, y._v);
    y._v = y._v + 16.0;
    var tmp_0 = Type_instance.edq();
    kinText_0(_this__u8e3s4, '\u041F\u0410\u0420\u0410\u041C\u0415\u0422\u0420\u042B \u041F\u0410\u0420\u0422\u0418\u0418', tmp_0, theme.cdf_1, SettingsScene$sceneMain$lambda_2(y));
    y._v = y._v + 28.0;
    // Inline function 'kotlin.apply' call
    var this_3 = kinFieldLabel(_this__u8e3s4, '\u0422\u0435\u043C\u0430', theme);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    this_3.fc7(Companion_getInstance_6().s4t_1);
    position(this_3, 24.0, y._v);
    y._v = y._v + 22.0;
    var tmp_1 = listOf(['\u2600  \u0421\u0432\u0435\u0442', '\u263E  \u0422\u044C\u043C\u0430']);
    var tmp_2 = SettingsStore_getInstance().ddc_1.pdb_1 ? 1 : 0;
    var tmp_3 = w - 48.0;
    position(kinSegmented(_this__u8e3s4, tmp_1, tmp_2, tmp_3, theme, SettingsScene$sceneMain$lambda_3), 24.0, y._v);
    y._v = y._v + (42.0 + 14.0);
    // Inline function 'kotlin.apply' call
    var this_4 = kinFieldLabel(_this__u8e3s4, '\u041F\u0440\u0430\u0432\u0438\u043B\u0430', theme);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    this_4.fc7(Companion_getInstance_6().s4t_1);
    position(this_4, 24.0, y._v);
    y._v = y._v + 22.0;
    var rulesList = listOf([Rules_CLASSIC_getInstance(), Rules_RENJU_getInstance()]);
    var tmp_4 = listOf(['\u041A\u043B\u0430\u0441\u0441\u0438\u043A\u0430', '\u0420\u044D\u043D\u0434\u0437\u044E']);
    var tmp_5 = coerceAtLeast(rulesList.b3(SettingsStore_getInstance().ddc_1.qdb_1), 0);
    var tmp_6 = w - 48.0;
    position(kinSegmented(_this__u8e3s4, tmp_4, tmp_5, tmp_6, theme, SettingsScene$sceneMain$lambda_4(rulesList)), 24.0, y._v);
    y._v = y._v + (42.0 + 14.0);
    // Inline function 'kotlin.apply' call
    var this_5 = kinFieldLabel(_this__u8e3s4, '\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C AI', theme);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    this_5.fc7(Companion_getInstance_6().s4t_1);
    position(this_5, 24.0, y._v);
    y._v = y._v + 22.0;
    var diffs = listOf([Difficulty_EASY_getInstance(), Difficulty_MID_getInstance(), Difficulty_HARD_getInstance()]);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(diffs, 10));
    var tmp0_iterator = diffs.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
      var tmp$ret$7 = get_label(item);
      destination.h(tmp$ret$7);
    }
    var tmp_7 = destination;
    var tmp_8 = coerceAtLeast(diffs.b3(SettingsStore_getInstance().ddc_1.rdb_1), 0);
    var tmp_9 = w - 48.0;
    position(kinSegmented(_this__u8e3s4, tmp_7, tmp_8, tmp_9, theme, SettingsScene$sceneMain$lambda_5(diffs)), 24.0, y._v);
    y._v = y._v + (42.0 + 14.0);
    // Inline function 'kotlin.apply' call
    var this_6 = kinFieldLabel(_this__u8e3s4, '\u0426\u0432\u0435\u0442 \u0438\u0433\u0440\u043E\u043A\u0430 (vs AI)', theme);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    this_6.fc7(Companion_getInstance_6().s4t_1);
    position(this_6, 24.0, y._v);
    y._v = y._v + 22.0;
    var colorPrefs = listOf([PlayerColorPref_ALTERNATE_getInstance(), PlayerColorPref_WHITE_getInstance(), PlayerColorPref_BLACK_getInstance()]);
    var tmp_10 = listOf(['\u0427\u0435\u0440\u0435\u0434\u043E\u0432\u0430\u0442\u044C', '\u0411\u0435\u043B\u044B\u0435', '\u0427\u0451\u0440\u043D\u044B\u0435']);
    var tmp_11 = coerceAtLeast(colorPrefs.b3(SettingsStore_getInstance().ddc_1.wdb_1), 0);
    var tmp_12 = w - 48.0;
    position(kinSegmented(_this__u8e3s4, tmp_10, tmp_11, tmp_12, theme, SettingsScene$sceneMain$lambda_6(colorPrefs)), 24.0, y._v);
    y._v = y._v + (42.0 + 14.0);
    // Inline function 'kotlin.apply' call
    var this_7 = kinFieldLabel(_this__u8e3s4, '\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A\u0438', theme);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.sceneMain.<anonymous>' call
    this_7.fc7(Companion_getInstance_6().s4t_1);
    position(this_7, 24.0, y._v);
    y._v = y._v + 22.0;
    var tmp_13 = y._v;
    var tmp_14 = SettingsStore_getInstance().ddc_1.sdb_1;
    renderToggleRow$default(this, _this__u8e3s4, w, tmp_13, '\u041F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 \u0445\u043E\u0434\u043E\u0432', tmp_14, theme, VOID, SettingsScene$sceneMain$lambda_7);
    y._v = y._v + 44.0;
    var tmp_15 = y._v;
    var tmp_16 = SettingsStore_getInstance().ddc_1.vdb_1;
    renderToggleRow$default(this, _this__u8e3s4, w, tmp_15, '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0445\u043E\u0434\u0430', tmp_16, theme, VOID, SettingsScene$sceneMain$lambda_8);
    y._v = y._v + 44.0;
    var tmp_17 = y._v;
    var tmp_18 = SettingsStore_getInstance().ddc_1.tdb_1;
    renderToggleRow$default(this, _this__u8e3s4, w, tmp_17, '\u0417\u0432\u0443\u043A\u0438 \u0438 \u0432\u0438\u0431\u0440\u0430\u0446\u0438\u044F', tmp_18, theme, VOID, SettingsScene$sceneMain$lambda_9);
    y._v = y._v + 44.0;
    var tmp_19 = y._v;
    var tmp_20 = SettingsStore_getInstance().ddc_1.udb_1;
    renderToggleRow(this, _this__u8e3s4, w, tmp_19, '\u041C\u0443\u0437\u044B\u043A\u0430', tmp_20, theme, true, SettingsScene$sceneMain$lambda_10);
    y._v = y._v + 44.0;
  }
}
class SplashScene$sceneMain$slambda {
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SplashScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var h = 720;
    var cx = w / 2.0;
    kinPaperBackground(_this__u8e3s4, theme);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SplashScene.sceneMain.<anonymous>' call
    kinStone(this_1, true, 44.0, VOID, VOID, theme);
    var tmp0_x1 = -48.0;
    var tmp1_y2 = -20.0;
    var tmp2_color = theme.gdf_1;
    var tmp3_colorSoft = theme.hdf_1;
    kinSeam(this_1, tmp0_x1, 14.0, 48.0, tmp1_y2, 2.6, 4.5, 7, true, VOID, VOID, tmp2_color, tmp3_colorSoft);
    var tmp4_x1 = -96.0;
    var tmp5_x2 = -42.0;
    var tmp6_color = theme.gdf_1;
    var tmp7_colorSoft = theme.hdf_1;
    kinSeam(this_1, tmp4_x1, 30.0, tmp5_x2, 12.0, 1.4, 3.0, 12, VOID, VOID, VOID, tmp6_color, tmp7_colorSoft);
    var tmp8_y1 = -18.0;
    var tmp9_y2 = -34.0;
    var tmp10_color = theme.gdf_1;
    var tmp11_colorSoft = theme.hdf_1;
    kinSeam(this_1, 42.0, tmp8_y1, 98.0, tmp9_y2, 1.4, 3.0, 19, VOID, VOID, VOID, tmp10_color, tmp11_colorSoft);
    var motif = position(this_1, cx, h * 0.4);
    var t = {_v: 0.0};
    addUpdater(motif, SplashScene$sceneMain$lambda(t, motif));
    var tmp = Fonts_instance.kdf();
    kinText(_this__u8e3s4, '\u0413\u043E\u043C\u043E\u043A\u0443', 34.0, theme.adf_1, tmp, SplashScene$sceneMain$lambda_0(cx, h));
    var tmp_0 = capsTracked('\u4E94\u76EE\u4E26\u3079', 2);
    var tmp_1 = Fonts_instance.zdf();
    kinText(_this__u8e3s4, tmp_0, 12.0, theme.cdf_1, tmp_1, SplashScene$sceneMain$lambda_1(cx, h));
    var tmp_2 = Fonts_instance.adg();
    kinText(_this__u8e3s4, '\u0417\u0410\u0413\u0420\u0423\u0417\u041A\u0410\u2026', 10.0, theme.cdf_1, tmp_2, SplashScene$sceneMain$lambda_2(cx, h));
    launch(this, VOID, VOID, SplashScene$sceneMain$slambda_0());
  }
}
class TeaScene extends Scene {
  tag(_this__u8e3s4, $completion) {
    var theme = Theme_instance.wde();
    var w = 360;
    var h = 720;
    kinPaperBackground(_this__u8e3s4, theme);
    onBackOrEscape(_this__u8e3s4, TeaScene$sceneMain$lambda);
    // Inline function 'kotlin.apply' call
    var this_0 = kinTextButton(_this__u8e3s4, '\u2190 \u041D\u0430\u0437\u0430\u0434', theme.cdf_1, TeaScene$sceneMain$lambda_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.TeaScene.sceneMain.<anonymous>' call
    this_0.fc7(Companion_getInstance_6().s4t_1);
    position(this_0, 24.0, 22.0);
    var y = {_v: 56.0};
    var tmp = Type_instance.g9g();
    kinText_0(_this__u8e3s4, '\u0427\u0430\u0439\u043D\u0430\u044F', tmp, theme.adf_1, TeaScene$sceneMain$lambda_1(y));
    y._v = y._v + 44.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.TeaScene.sceneMain.<anonymous>' call
    var tmp0_color = theme.gdf_1;
    var tmp1_colorSoft = theme.hdf_1;
    kinSeam(this_2, 2.0, 6.0, 94.0, 6.0, 1.3, 2.5, 91, VOID, VOID, VOID, tmp0_color, tmp1_colorSoft);
    position(this_2, 24.0, y._v);
    y._v = y._v + 18.0;
    var tmp_0 = Type_instance.edq().fdm_1;
    var tmp_1 = Fonts_instance.adg();
    kinText(_this__u8e3s4, '\u041F\u041E\u0414\u0414\u0415\u0420\u0416\u041A\u0410 \u041F\u0420\u041E\u0415\u041A\u0422\u0410', tmp_0, theme.cdf_1, tmp_1, TeaScene$sceneMain$lambda_2(y));
    y._v = y._v + 24.0;
    var tmp_2 = Type_instance.wdf().fdm_1;
    var tmp_3 = Fonts_instance.fdp();
    kinText(_this__u8e3s4, '\u0413\u043E\u043C\u043E\u043A\u0443 \u2014 \u043F\u0440\u043E\u0435\u043A\u0442 \u0434\u043B\u044F \u0434\u0443\u0448\u0438: \u0431\u0435\u0437 \u043F\u043E\u0434\u043F\u0438\u0441\u043E\u043A \u0438 \u0441\u043B\u0435\u0436\u043A\u0438. \u0415\u0441\u043B\u0438 \u0438\u0433\u0440\u0430 \u0434\u0430\u0440\u0438\u0442 \u0442\u0438\u0448\u0438\u043D\u0443 \u2014 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0442\u0435.', tmp_2, theme.bdf_1, tmp_3, TeaScene$sceneMain$lambda_3(y));
    y._v = y._v + 44.0;
    var tmp_4 = Type_instance.gdp().fdm_1;
    var tmp_5 = Fonts_instance.tdp();
    var stub = kinText(_this__u8e3s4, '', tmp_4, theme.cdf_1, tmp_5, TeaScene$sceneMain$lambda_4(w, h));
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = Str_getInstance().xdg_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'scenes.TeaScene.sceneMain.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var i = checkIndexOverflow(tmp1);
      var tmp_6 = y._v;
      var tmp_7 = i < (Str_getInstance().xdg_1.e1() - 1 | 0);
      y._v = renderRow_0(this, _this__u8e3s4, tmp_6, w, theme, item, tmp_7, TeaScene$sceneMain$lambda_5(stub));
    }
    var tmp_8 = Type_instance.wdf().fdm_1;
    var tmp_9 = Fonts_instance.fdp();
    kinText(_this__u8e3s4, '\u0412\u0441\u0451 \u2014 \u0440\u0430\u0437\u043E\u0432\u044B\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438. \u041F\u043E\u0434\u043F\u0438\u0441\u043E\u043A \u043D\u0435\u0442.', tmp_8, theme.cdf_1, tmp_9, TeaScene$sceneMain$lambda_6(w, y));
  }
}
class KinBoardView extends Container {
  static cdp(game, theme, onCellClick) {
    var $this = this.cae();
    $this.pdo_1 = game;
    $this.qdo_1 = theme;
    $this.rdo_1 = onCellClick;
    $this.sdo_1 = 22.0;
    $this.tdo_1 = 14.0;
    $this.udo_1 = 336.0;
    $this.zdo_1 = -1;
    $this.adp_1 = null;
    $this.bdp_1 = false;
    // Inline function 'korlibs.korge.view.solidRect' call
    var width = $this.udo_1;
    var height = $this.udo_1;
    var color = $this.qdo_1.yde_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = SolidRect.rc2(Size2D.u2l(width, height), color);
    // Inline function 'kotlin.apply' call
    addTo(this_0, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var topGlow = $this.qdo_1.idf_1 ? rgba255(255, 253, 245, 0.04) : rgba255(255, 255, 255, 0.4);
    var dropShadow = $this.qdo_1.idf_1 ? rgba255(0, 0, 0, 0.4) : rgba255(0, 0, 0, 0.05);
    // Inline function 'korlibs.korge.view.solidRect' call
    var width_0 = $this.udo_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SolidRect.rc2(Size2D.u2l(width_0, 1.0), topGlow);
    // Inline function 'kotlin.apply' call
    addTo(this_1, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    // Inline function 'korlibs.korge.view.solidRect' call
    var width_1 = $this.udo_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = SolidRect.rc2(Size2D.u2l(width_1, 1.0), dropShadow);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.<anonymous>' call
    addTo(this_2, $this).tar($this.udo_1);
    drawGrid($this);
    var tmp = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_3 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.<anonymous>' call
    tmp.vdo_1 = addTo(this_3, $this);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.<anonymous>' call
    tmp_0.wdo_1 = addTo(this_4, $this);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_5 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.<anonymous>' call
    tmp_1.xdo_1 = addTo(this_5, $this);
    var tmp_2 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.<anonymous>' call
    tmp_2.ydo_1 = addTo(this_6, $this);
    // Inline function 'korlibs.korge.input.onClick' call
    // Inline function 'korlibs.korge.view.solidRect' call
    var width_2 = $this.udo_1;
    var height_0 = $this.udo_1;
    var color_0 = Colors_getInstance().d45_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = SolidRect.rc2(Size2D.u2l(width_2, height_0), color_0);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var handler = KinBoardView$lambda($this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_2();
    var tmp1_safe_receiver = this_8 == null ? null : this_8.far();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_3 = prop.get(tmp1_safe_receiver_0);
          tmp_3.p22(KinBoardView$lambda_0(handler));
        }
      }
    }
    $this.jdp();
    return $this;
  }
  jdp() {
    this.vdo_1.vaq();
    var tmp0_safe_receiver = this.adp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel(tmp0_safe_receiver);
    }
    this.adp_1 = null;
    this.wdo_1.vaq();
    this.ydo_1.vaq();
    var board = this.pdo_1.ed9();
    var lastMove = lastOrNull(this.pdo_1.gd9());
    var tmp1_safe_receiver = this.pdo_1.gd8_1;
    var winPositions = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.xdd_1;
    var moveCount = this.pdo_1.fd9();
    var animateLast = moveCount === (this.zdo_1 + 1 | 0);
    this.zdo_1 = moveCount;
    var inductionVariable = 0;
    if (inductionVariable < 15)
      do {
        var r = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 15)
          $l$loop: do {
            var c = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_elvis_lhs = board.md8(r, c);
            var tmp;
            if (tmp2_elvis_lhs == null) {
              continue $l$loop;
            } else {
              tmp = tmp2_elvis_lhs;
            }
            var stone = tmp;
            var tmp_0;
            if (lastMove == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'ui.KinBoardView.redraw.<anonymous>' call
              tmp_0 = (lastMove.ad9_1 === r && lastMove.bd9_1 === c);
            }
            var isLast = tmp_0 === true;
            var tmp_1;
            if (winPositions == null) {
              tmp_1 = null;
            } else {
              var tmp$ret$2;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp_2;
                if (isInterface(winPositions, Collection)) {
                  tmp_2 = winPositions.g1();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break $l$block_0;
                }
                var tmp0_iterator = winPositions.a1();
                while (tmp0_iterator.b1()) {
                  var element = tmp0_iterator.c1();
                  // Inline function 'ui.KinBoardView.redraw.<anonymous>' call
                  if (element.odc_1 === r && element.pdc_1 === c) {
                    tmp$ret$2 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$2 = false;
              }
              tmp_1 = tmp$ret$2;
            }
            var isWin = tmp_1 === true;
            var view = position(kinStone(this.vdo_1, stone.equals(StoneColor_BLACK_getInstance()), this.sdo_1 * 0.42, isLast, isWin, this.qdo_1), this.tdo_1 + c * this.sdo_1, this.tdo_1 + r * this.sdo_1);
            if (isLast && animateLast) {
              animateAppear(this, view);
            }
          }
           while (inductionVariable_0 < 15);
      }
       while (inductionVariable < 15);
    if (!(winPositions == null) && winPositions.e1() >= 2) {
      var first_0 = first(winPositions);
      var last_0 = last(winPositions);
      var x1 = this.tdo_1 + first_0.pdc_1 * this.sdo_1;
      var y1 = this.tdo_1 + first_0.odc_1 * this.sdo_1;
      var x2 = this.tdo_1 + last_0.pdc_1 * this.sdo_1;
      var y2 = this.tdo_1 + last_0.odc_1 * this.sdo_1;
      if (this.bdp_1) {
        redraw$drawSeam(this, x1, y1, x2, y2, 1.0);
      } else {
        this.bdp_1 = true;
        var t = {_v: 0.0};
        var tmp_3 = this;
        tmp_3.adp_1 = addUpdater(this, KinBoardView$redraw$lambda(t, this, x1, y1, x2, y2));
      }
    } else {
      this.bdp_1 = false;
    }
    if (moveCount === 0) {
      // Inline function 'korlibs.korge.view.circle' call
      var this_0 = this.vdo_1;
      var fill = new RGBA(this.qdo_1.gdf_1);
      var stroke = new RGBA(Colors_getInstance().y44_1);
      var renderer = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Circle.hbd(numberToDouble(4.0), fill, stroke, numberToDouble(0.0), true, renderer);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.KinBoardView.redraw.<anonymous>' call
      position(this_2, this.tdo_1 + 7 * this.sdo_1 - 4.0, this.tdo_1 + 7 * this.sdo_1 - 4.0);
      var dot = this_2;
      var t_0 = {_v: 0.0};
      addUpdater(dot, KinBoardView$redraw$lambda_0(t_0, dot));
    }
  }
  ndp(r, c, isBlack) {
    this.ydo_1.vaq();
    var crossColor = Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(this.qdo_1.fdf_1), _RGBA___get_g__impl__o8pukr(this.qdo_1.fdf_1), _RGBA___get_b__impl__m6tl80(this.qdo_1.fdf_1), numberToInt(255 * 0.22));
    var lineLen = this.sdo_1 * 14;
    // Inline function 'korlibs.korge.view.solidRect' call
    var this_0 = this.ydo_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SolidRect.rc2(Size2D.u2l(1.0, lineLen), crossColor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.showGhost.<anonymous>' call
    position(this_2, this.tdo_1 + c * this.sdo_1, this.tdo_1);
    // Inline function 'korlibs.korge.view.solidRect' call
    var this_3 = this.ydo_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = SolidRect.rc2(Size2D.u2l(lineLen, 1.0), crossColor);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.showGhost.<anonymous>' call
    position(this_5, this.tdo_1, this.tdo_1 + r * this.sdo_1);
    var stoneR = this.sdo_1 * 0.42;
    // Inline function 'kotlin.apply' call
    var this_6 = kinStone(this.ydo_1, isBlack, stoneR, VOID, VOID, this.qdo_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.showGhost.<anonymous>' call
    position(this_6, this.tdo_1 + c * this.sdo_1, this.tdo_1 + r * this.sdo_1);
    this_6.kas(0.55);
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.korge.view.circle' call
    var this_7 = this.ydo_1;
    var radius = stoneR + 4.0;
    var fill = new RGBA(Colors_getInstance().d45_1);
    var stroke = new RGBA(this.qdo_1.fdf_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_8 = Circle.hbd(numberToDouble(radius), fill, stroke, numberToDouble(1.0), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_9 = addTo(this_8, this_7);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.showGhost.<anonymous>' call
    position(this_9, this.tdo_1 + c * this.sdo_1 - stoneR - 4.0, this.tdo_1 + r * this.sdo_1 - stoneR - 4.0);
    this_9.kas(0.9);
  }
  kdp(r, c) {
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.korge.view.circle' call
    var this_0 = this.ydo_1;
    var radius = this.sdo_1 * 0.5;
    var fill = new RGBA(Colors_getInstance().d45_1);
    var stroke = new RGBA(this.qdo_1.fdf_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Circle.hbd(numberToDouble(radius), fill, stroke, numberToDouble(1.5), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.flashForbidden.<anonymous>' call
    position(this_2, this.tdo_1 + c * this.sdo_1 - this.sdo_1 * 0.5, this.tdo_1 + r * this.sdo_1 - this.sdo_1 * 0.5);
    var ring = this_2;
    var t = {_v: 0.0};
    var upd = {_v: null};
    upd._v = addUpdater(ring, KinBoardView$flashForbidden$lambda(t, ring, upd));
  }
  idp() {
    this.ydo_1.vaq();
  }
  odp(positions) {
    this.xdo_1.vaq();
    var _iterator__ex2g4s = positions.a1();
    while (_iterator__ex2g4s.b1()) {
      var p = _iterator__ex2g4s.c1();
      // Inline function 'korlibs.korge.view.circle' call
      var this_0 = this.xdo_1;
      var fill = new RGBA(this.qdo_1.gdf_1);
      var stroke = new RGBA(Colors_getInstance().y44_1);
      var renderer = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Circle.hbd(numberToDouble(3.0), fill, stroke, numberToDouble(0.0), true, renderer);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.KinBoardView.showHints.<anonymous>' call
      position(this_2, this.tdo_1 + p.pdc_1 * this.sdo_1, this.tdo_1 + p.odc_1 * this.sdo_1);
      this_2.kas(0.7);
    }
  }
}
class KinRng {
  constructor(seed) {
    var tmp = this;
    // Inline function 'kotlin.comparisons.maxOf' call
    var tmp$ret$0 = Math.max(seed, 1);
    tmp.qdu_1 = toLong(tmp$ret$0);
  }
  hp() {
    var tmp = this;
    // Inline function 'kotlin.Long.rem' call
    // Inline function 'kotlin.Long.plus' call
    // Inline function 'kotlin.Long.times' call
    tmp.qdu_1 = this.qdu_1.b4(toLong(9301)).a4(toLong(49297)).d4(toLong(233280));
    // Inline function 'kotlin.Long.div' call
    return this.qdu_1.r4() / 233280.0;
  }
}
class MusicPlayer {
  constructor() {
    this.ddd_1 = null;
    this.edd_1 = null;
    this.fdd_1 = null;
  }
  gdd(context, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this, context), $completion);
  }
  gdt() {
    var want = SettingsStore_getInstance().ddc_1.udb_1;
    if (want && this.edd_1 == null) {
      var tmp0_elvis_lhs = this.ddd_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var s = tmp;
      var tmp1_elvis_lhs = this.fdd_1;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var c = tmp_0;
      var tmp_1 = this;
      // Inline function 'kotlin.also' call
      var this_0 = s.j6e(c, get_infinitePlaybackTimes());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.MusicPlayer.sync.<anonymous>' call
      this_0.l5z(0.25);
      tmp_1.edd_1 = this_0;
    } else if (!want) {
      var tmp2_safe_receiver = this.edd_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.r5z();
      }
      this.edd_1 = null;
    }
  }
}
class Str {
  constructor() {
    Str_instance = this;
    this.bdg_1 = '\u4E94\u76EE';
    this.cdg_1 = 'G  O  M  O  K  U';
    this.ddg_1 = '\u041F\u044F\u0442\u044C \u043A\u0430\u043C\u043D\u0435\u0439 \u0432 \u0440\u044F\u0434';
    this.edg_1 = '2026 \xB7 KORGE EDITION';
    this.fdg_1 = '\u0418\u0433\u0440\u0430 \u0441 AI';
    this.gdg_1 = '\u0418\u0433\u0440\u0430 \u0432\u0434\u0432\u043E\u0451\u043C';
    this.hdg_1 = '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438';
    this.idg_1 = '\u041F\u043E\u043C\u043E\u0449\u044C';
    this.jdg_1 = '\u0416\u0443\u0440\u043D\u0430\u043B';
    this.kdg_1 = '\u041F\u0435\u0447\u0430\u0442\u0438';
    this.ldg_1 = '\u0427\u0430\u0439\u043D\u0430\u044F ';
    this.mdg_1 = '\u8336 \u2192';
    this.ndg_1 = '\u4E94\u76EE\u4E26\u3079';
    this.odg_1 = '\u4E94';
    this.pdg_1 = '\u0413\u043E\u043C\u043E\u043A\u0443';
    this.qdg_1 = '\u0417\u0410\u0413\u0420\u0423\u0417\u041A\u0410\u2026';
    this.rdg_1 = '\u0427\u0430\u0439\u043D\u0430\u044F';
    this.sdg_1 = '\u041F\u041E\u0414\u0414\u0415\u0420\u0416\u041A\u0410 \u041F\u0420\u041E\u0415\u041A\u0422\u0410';
    this.tdg_1 = '\u0413\u043E\u043C\u043E\u043A\u0443 \u2014 \u043F\u0440\u043E\u0435\u043A\u0442 \u0434\u043B\u044F \u0434\u0443\u0448\u0438: \u0431\u0435\u0437 \u043F\u043E\u0434\u043F\u0438\u0441\u043E\u043A \u0438 \u0441\u043B\u0435\u0436\u043A\u0438. \u0415\u0441\u043B\u0438 \u0438\u0433\u0440\u0430 \u0434\u0430\u0440\u0438\u0442 \u0442\u0438\u0448\u0438\u043D\u0443 \u2014 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0442\u0435.';
    this.udg_1 = '\u0412\u0441\u0451 \u2014 \u0440\u0430\u0437\u043E\u0432\u044B\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438. \u041F\u043E\u0434\u043F\u0438\u0441\u043E\u043A \u043D\u0435\u0442.';
    this.vdg_1 = '\u0421\u041A\u041E\u0420\u041E';
    this.wdg_1 = '\u041F\u043E\u043A\u0443\u043F\u043A\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0432 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0439 \u0441\u0431\u043E\u0440\u043A\u0435';
    this.xdg_1 = listOf([new TeaItem('\u8336', TeaTone_VERMILLION_getInstance(), '\u0427\u0430\u0448\u043A\u0430 \u0447\u0430\u044F', '\u0420\u0430\u0437\u043E\u0432\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0430', '$0.99'), new TeaItem('\u58FA', TeaTone_VERMILLION_getInstance(), '\u0427\u0430\u0439\u043D\u0438\u043A', '\u0411\u043E\u043B\u044C\u0448\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u2014 \u043E\u0442 \u0434\u0443\u0448\u0438', '$4.99'), new TeaItem('\u9280', TeaTone_SILVER_getInstance(), '\u0421\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u0430\u044F \u0436\u0438\u043B\u0430', '\u0422\u0435\u043C\u0430 \u043C\u0435\u0442\u0430\u043B\u043B\u0430 \u0434\u043B\u044F \u043A\u0438\u043D\u0446\u0443\u0433\u0438', '$0.99'), new TeaItem('\u9285', TeaTone_COPPER_getInstance(), '\u041C\u0435\u0434\u043D\u0430\u044F \u0436\u0438\u043B\u0430', '\u0422\u0435\u043C\u0430 \u043C\u0435\u0442\u0430\u043B\u043B\u0430 \u0434\u043B\u044F \u043A\u0438\u043D\u0446\u0443\u0433\u0438', '$0.99'), new TeaItem('\u8C9D', TeaTone_SOON_getInstance(), '\u041A\u0430\u043C\u043D\u0438 \u0438\u0437 \u0440\u0430\u043A\u0443\u0448\u043A\u0438', '\u0425\u0430\u043C\u0430\u0433\u0443\u0440\u0438 \u2014 \u043D\u0430\u0431\u043E\u0440 \u043A\u0430\u043C\u043D\u0435\u0439', null), new TeaItem('\u9759', TeaTone_GOLD_getInstance(), '\u0422\u0438\u0448\u0438\u043D\u0430', '\u0423\u0431\u0440\u0430\u0442\u044C \u0440\u0435\u043A\u043B\u0430\u043C\u0443 \u043D\u0430\u0432\u0441\u0435\u0433\u0434\u0430', '$1.99')]);
    this.ydg_1 = 'VS  AI \xB7 ';
    this.zdg_1 = 'VS  \u0418\u0413\u0420\u041E\u041A';
    this.adh_1 = '\u041C\u0415\u041D\u042E';
    this.bdh_1 = '\u0425\u041E\u0414 ';
    this.cdh_1 = 'AI \u0434\u0443\u043C\u0430\u0435\u0442\u2026';
    this.ddh_1 = '\u0425\u043E\u0434 \u0447\u0451\u0440\u043D\u044B\u0445';
    this.edh_1 = '\u0425\u043E\u0434 \u0431\u0435\u043B\u044B\u0445';
    this.fdh_1 = '\u0427\u0451\u0440\u043D\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
    this.gdh_1 = '\u0411\u0435\u043B\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
    this.hdh_1 = '\u041D\u0438\u0447\u044C\u044F';
    this.idh_1 = '\u2190 \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C';
    this.jdh_1 = '\u041D\u043E\u0432\u0430\u044F \u043F\u0430\u0440\u0442\u0438\u044F';
    this.kdh_1 = '\u041F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0430';
    this.ldh_1 = '15 \xD7 15';
    this.mdh_1 = 'vs';
    this.ndh_1 = '\u0427\u0451\u0440\u043D\u044B\u0435';
    this.odh_1 = '\u0411\u0435\u043B\u044B\u0435';
    this.pdh_1 = '\u0412\u042B';
    this.qdh_1 = '\u0418\u0413\u0420\u041E\u041A 1';
    this.rdh_1 = '\u0418\u0413\u0420\u041E\u041A 2';
    this.sdh_1 = 'AI';
    this.tdh_1 = '\u601D\u8003\u4E2D';
    this.udh_1 = '\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043C\u0435\u043D\u044C';
    this.vdh_1 = '\xD7';
    this.wdh_1 = '\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E: \u0440\u044F\u0434 \u0434\u043B\u0438\u043D\u043D\u0435\u0435 \u043F\u044F\u0442\u0438';
    this.xdh_1 = '\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E: \u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0447\u0435\u0442\u0432\u0451\u0440\u043A\u0430';
    this.ydh_1 = '\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E: \u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0442\u0440\u043E\u0439\u043A\u0430';
    this.zdh_1 = '\u2190 \u041D\u0430\u0437\u0430\u0434';
    this.adi_1 = '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438';
    this.bdi_1 = '\u041F\u0410\u0420\u0410\u041C\u0415\u0422\u0420\u042B \u041F\u0410\u0420\u0422\u0418\u0418';
    this.cdi_1 = '\u0422\u0435\u043C\u0430';
    this.ddi_1 = '\u2600  \u0421\u0432\u0435\u0442';
    this.edi_1 = '\u263E  \u0422\u044C\u043C\u0430';
    this.fdi_1 = '\u041F\u0440\u0430\u0432\u0438\u043B\u0430';
    this.gdi_1 = '\u041A\u043B\u0430\u0441\u0441\u0438\u043A\u0430';
    this.hdi_1 = '\u0420\u044D\u043D\u0434\u0437\u044E';
    this.idi_1 = '\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C AI';
    this.jdi_1 = '\u0426\u0432\u0435\u0442 \u0438\u0433\u0440\u043E\u043A\u0430 (vs AI)';
    this.kdi_1 = '\u0427\u0435\u0440\u0435\u0434\u043E\u0432\u0430\u0442\u044C';
    this.ldi_1 = '\u0411\u0435\u043B\u044B\u0435';
    this.mdi_1 = '\u0427\u0451\u0440\u043D\u044B\u0435';
    this.ndi_1 = '\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A\u0438';
    this.odi_1 = '\u041F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 \u0445\u043E\u0434\u043E\u0432';
    this.pdi_1 = '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0445\u043E\u0434\u0430';
    this.qdi_1 = '\u0417\u0432\u0443\u043A\u0438 \u0438 \u0432\u0438\u0431\u0440\u0430\u0446\u0438\u044F';
    this.rdi_1 = '\u041C\u0443\u0437\u044B\u043A\u0430';
    this.sdi_1 = '\u0412\u0415\u0420\u0421\u0418\u042F ';
    this.tdi_1 = '\u041E\u041D\u041B\u0410\u0419\u041D';
    this.udi_1 = '\u041F\u043E\u043C\u043E\u0449\u044C';
    this.vdi_1 = '\u041F\u0420\u0410\u0412\u0418\u041B\u0410 \u0418 \u0421\u041E\u0412\u0415\u0422\u042B';
    this.wdi_1 = '\u041F\u0410\u0420\u0422\u0418\u042F \u0417\u0410\u0412\u0415\u0420\u0428\u0415\u041D\u0410';
    this.xdi_1 = '\u0415\u0449\u0451 \u043F\u0430\u0440\u0442\u0438\u044E';
    this.ydi_1 = '\u0412 \u043C\u0435\u043D\u044E';
    this.zdi_1 = '\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u0441\u043A\u0443';
    this.adj_1 = '\u041D\u041E\u0412\u0410\u042F \u041F\u0415\u0427\u0410\u0422\u042C';
    this.bdj_1 = '\u041A\u0438\u0444\u0443 \u043F\u0430\u0440\u0442\u0438\u0438 \u2192';
    this.cdj_1 = '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435';
    this.ddj_1 = '\u0422\u0440\u0435\u0449\u0438\u043D\u0443 \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u0442 \u0437\u043E\u043B\u043E\u0442\u043E';
    this.edj_1 = '\u0420\u0435\u0432\u0430\u043D\u0448';
    this.fdj_1 = '\u041A\u0438\u0444\u0443';
    this.gdj_1 = '\u041F\u0430\u0440\u0442\u0438\u044F \u043D\u0435 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430';
    this.hdj_1 = '\u0445\u043E\u0434\u043E\u0432: ';
    this.idj_1 = '\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F';
    this.jdj_1 = '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C';
    this.kdj_1 = '\u041D\u043E\u0442\u0430\u0446\u0438\u044F \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440';
    this.ldj_1 = '\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E: ';
    this.mdj_1 = '\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u043E\u0441\u044C \u2014 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437';
    this.ndj_1 = '\u0416\u0443\u0440\u043D\u0430\u043B';
    this.odj_1 = '\u041A\u0418\u0424\u0423 \u0421\u042B\u0413\u0420\u0410\u041D\u041D\u042B\u0425 \u041F\u0410\u0420\u0422\u0418\u0419';
    this.pdj_1 = '\u041F\u0430\u0440\u0442\u0438\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u2014 \u0441\u044B\u0433\u0440\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0432\u0443\u044E.';
    this.qdj_1 = '\u041D\u0435 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430 \xB7 \u0445\u043E\u0434 ';
    this.rdj_1 = '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C';
    this.sdj_1 = '\u041F\u043E\u0431\u0435\u0434\u0430 \u0447\u0451\u0440\u043D\u044B\u0445';
    this.tdj_1 = '\u041F\u043E\u0431\u0435\u0434\u0430 \u0431\u0435\u043B\u044B\u0445';
    this.udj_1 = '\u041D\u0438\u0447\u044C\u044F';
    this.vdj_1 = 'vs AI \xB7 ';
    this.wdj_1 = 'vs \u0418\u0433\u0440\u043E\u043A';
    this.xdj_1 = '\u0421\u0435\u0433\u043E\u0434\u043D\u044F';
    this.ydj_1 = '\u0412\u0447\u0435\u0440\u0430';
    this.zdj_1 = listOf(['\u044F\u043D\u0432\u0430\u0440\u044F', '\u0444\u0435\u0432\u0440\u0430\u043B\u044F', '\u043C\u0430\u0440\u0442\u0430', '\u0430\u043F\u0440\u0435\u043B\u044F', '\u043C\u0430\u044F', '\u0438\u044E\u043D\u044F', '\u0438\u044E\u043B\u044F', '\u0430\u0432\u0433\u0443\u0441\u0442\u0430', '\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F', '\u043E\u043A\u0442\u044F\u0431\u0440\u044F', '\u043D\u043E\u044F\u0431\u0440\u044F', '\u0434\u0435\u043A\u0430\u0431\u0440\u044F']);
    this.adk_1 = '\u041F\u0435\u0447\u0430\u0442\u0438';
    this.bdk_1 = '\u0421\u041E\u0411\u0420\u0410\u041D\u041E ';
    this.cdk_1 = ' \u0418\u0417 ';
    this.ddk_1 = '\u041B\u0415\u0413\u0415\u041D\u0414\u0410';
    this.edk_1 = '\u041B\u0415\u0413\u0415\u041D\u0414\u0410 \xB7 \u0412\u041D\u0415 \u041A\u041E\u041B\u041B\u0415\u041A\u0426\u0418\u0418';
    this.fdk_1 = '\u0417\u043E\u043B\u043E\u0442\u0430\u044F \u043F\u0435\u0447\u0430\u0442\u044C';
    this.gdk_1 = '\u041E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F, \u043A\u043E\u0433\u0434\u0430 \u0441\u043E\u0431\u0435\u0440\u0451\u0442\u0435 \u0432\u0441\u0435 \u0434\u0435\u0432\u044F\u0442\u044C \u043F\u0435\u0447\u0430\u0442\u0435\u0439.';
    this.hdk_1 = '\u548C \xB7 \u041D\u0438\u0447\u044C\u044F';
    this.idk_1 = '225 \u043A\u0430\u043C\u043D\u0435\u0439 \u0438 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u043F\u044F\u0442\u0451\u0440\u043A\u0438. \u041F\u043E\u0447\u0442\u0438 \u043D\u0438\u043A\u0442\u043E \u0435\u0451 \u043D\u0435 \u0432\u0438\u0434\u0435\u043B.';
    this.jdk_1 = '\u041C\u0410\u0421\u0422\u0415\u0420\u0421\u041A\u0410\u042F \u041F\u0415\u0427\u0410\u0422\u042C';
    this.kdk_1 = '\u6975 \xB7 \u0412\u0435\u0440\u0448\u0438\u043D\u0430';
    this.ldk_1 = '\u0412\u0441\u0435 \u043F\u0435\u0447\u0430\u0442\u0438 \u0441\u043E\u0431\u0440\u0430\u043D\u044B \u2014 \u0443\u0437\u043E\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D \u0437\u043E\u043B\u043E\u0442\u043E\u043C.';
    this.mdk_1 = '\u041F\u0435\u0447\u0430\u0442\u0438 \u0441\u0442\u0430\u0432\u044F\u0442\u0441\u044F \u0441\u0430\u043C\u0438 \u2014 \u043F\u0440\u043E\u0441\u0442\u043E \u0438\u0433\u0440\u0430\u0439\u0442\u0435.';
    this.ndk_1 = '\u0423\u0437\u043E\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D. \u041E\u0441\u0442\u0430\u043B\u0430\u0441\u044C \u043B\u0435\u0433\u0435\u043D\u0434\u0430.';
    this.odk_1 = '\u043B\u0443\u0447\u0448\u0430\u044F \u0441\u0435\u0440\u0438\u044F ';
    this.pdk_1 = '\u041B\u0435\u0433\u043A\u043E';
    this.qdk_1 = '\u0421\u0440\u0435\u0434\u043D\u0435';
    this.rdk_1 = '\u0421\u043B\u043E\u0436\u043D\u043E';
    this.sdk_1 = listOf([new HelpEntry('\u4E00', '\u0426\u0435\u043B\u044C \u0438\u0433\u0440\u044B', '\u0412\u044B\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043F\u044F\u0442\u044C \u043A\u0430\u043C\u043D\u0435\u0439 \u0432 \u0440\u044F\u0434 \u043F\u043E \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u0438, \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0438 \u0438\u043B\u0438 \u0434\u0438\u0430\u0433\u043E\u043D\u0430\u043B\u0438. \u0427\u0451\u0440\u043D\u044B\u0435 \u0445\u043E\u0434\u044F\u0442 \u043F\u0435\u0440\u0432\u044B\u043C\u0438.'), new HelpEntry('\u4E8C', '\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435', '\u041A\u0430\u0441\u0430\u043D\u0438\u0435 \u2014 \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043C\u0435\u043D\u044C. \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0445\u043E\u0434 \u043C\u043E\u0436\u043D\u043E \u0438\u0437 \u043D\u0438\u0436\u043D\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438.'), new HelpEntry('\u4E09', '\u0421\u0442\u0440\u0430\u0442\u0435\u0433\u0438\u044F', '\u0411\u043B\u043E\u043A\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0435 \u0442\u0440\u043E\u0439\u043A\u0438 \u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A\u0430 \u0438 \u0441\u0442\u0440\u043E\u0439\u0442\u0435 \xAB\u0432\u0438\u043B\u043A\u0438\xBB \u2014 \u0434\u0432\u043E\u0439\u043D\u044B\u0435 \u0443\u0433\u0440\u043E\u0437\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u0434\u043D\u0438\u043C \u0445\u043E\u0434\u043E\u043C.'), new HelpEntry('\u56DB', '\u0426\u0435\u043D\u0442\u0440', '\u041F\u0435\u0440\u0432\u044B\u0439 \u0445\u043E\u0434 \u2014 \u0442\u0440\u0430\u0434\u0438\u0446\u0438\u043E\u043D\u043D\u043E \u0442\u044D\u043D\u0433\u044D\u043D, \u0446\u0435\u043D\u0442\u0440 \u0434\u043E\u0441\u043A\u0438. \u042D\u0442\u043E \u0434\u0430\u0451\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0439 \u0430\u0442\u0430\u043A\u0438.'), new HelpEntry('\u4E94', '\u041A\u0438\u0444\u0443', '\u041F\u043E\u0441\u043B\u0435 \u043F\u0430\u0440\u0442\u0438\u0438 \u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043A\u0438\u0444\u0443 \u2014 \u0442\u0440\u0430\u0434\u0438\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0438\u0433\u0440\u044B. \u041A\u0430\u0436\u0434\u044B\u0439 \u043A\u0430\u043C\u0435\u043D\u044C \u043F\u0440\u043E\u043D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0445\u043E\u0434\u043E\u0432: \u0432\u0438\u0434\u043D\u043E, \u043A\u0430\u043A \u0441\u0442\u0440\u043E\u0438\u043B\u0430\u0441\u044C \u0430\u0442\u0430\u043A\u0430 \u0438 \u0433\u0434\u0435 \u043F\u0430\u0440\u0442\u0438\u044F \u0431\u044B\u043B\u0430 \u0440\u0435\u0448\u0435\u043D\u0430.'), new HelpEntry('\u516D', '\u0420\u044D\u043D\u0434\u0437\u044E', '\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 (\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442\u0441\u044F \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445). \u0427\u0451\u0440\u043D\u044B\u043C \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u044B \xAB\u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0442\u0440\u043E\u0439\u043A\u0430\xBB, \xAB\u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0447\u0435\u0442\u0432\u0451\u0440\u043A\u0430\xBB \u0438 \u0440\u044F\u0434 \u0434\u043B\u0438\u043D\u043D\u0435\u0435 \u043F\u044F\u0442\u0438. \u0417\u0430\u043F\u0440\u0435\u0449\u0451\u043D\u043D\u0430\u044F \u0442\u043E\u0447\u043A\u0430 \u043F\u043E\u0434\u0441\u0432\u0435\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043A\u0438\u043D\u043E\u0432\u0430\u0440\u044C\u044E, \u0434\u043E\u0441\u043A\u0430 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u0434\u0440\u043E\u0436\u0430\u043D\u0438\u0435\u043C. \u0411\u0435\u043B\u044B\u0435 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439.')]);
  }
  tdk(key) {
    switch (key) {
      case '\u521D':
        return '\u041F\u0435\u0440\u0432\u0430\u044F \u043F\u043E\u0431\u0435\u0434\u0430';
      case '\u9023':
        return '\u0422\u0440\u0438 \u043F\u043E\u0434\u0440\u044F\u0434';
      case '\u901F':
        return '\u0414\u043E 20 \u0445\u043E\u0434\u043E\u0432';
      case '\u5FC3':
        return '\u0411\u0435\u0437 \u043E\u0442\u043C\u0435\u043D';
      case '\u5E2B':
        return '\u0421\u043B\u043E\u0436\u043D\u044B\u0439 AI';
      case '\u767D':
        return '\u041F\u043E\u0431\u0435\u0434\u0430 \u0431\u0435\u043B\u044B\u043C\u0438';
      case '\u77F3':
        return '1000 \u043A\u0430\u043C\u043D\u0435\u0439';
      case '\u6708':
        return '\u041F\u0430\u0440\u0442\u0438\u044F \u0437\u0430 \u043F\u043E\u043B\u043D\u043E\u0447\u044C';
      case '\u53CB':
        return '10 \u043F\u0430\u0440\u0442\u0438\u0439 \u0432\u0434\u0432\u043E\u0451\u043C';
      case '\u548C':
        return '\u041D\u0438\u0447\u044C\u044F';
      case '\u6975':
        return '\u0412\u0435\u0440\u0448\u0438\u043D\u0430';
      default:
        return key;
    }
  }
  fdq(n) {
    return plural(this, n, '\u0445\u043E\u0434', '\u0445\u043E\u0434\u0430', '\u0445\u043E\u0434\u043E\u0432');
  }
  sdq(n) {
    return plural(this, n, '\u043F\u0430\u0440\u0442\u0438\u044F', '\u043F\u0430\u0440\u0442\u0438\u0438', '\u043F\u0430\u0440\u0442\u0438\u0439');
  }
  tdq(n) {
    return plural(this, n, '\u043F\u043E\u0431\u0435\u0434\u0430', '\u043F\u043E\u0431\u0435\u0434\u044B', '\u043F\u043E\u0431\u0435\u0434');
  }
}
class HelpEntry {
  constructor(num, title, body) {
    this.qdp_1 = num;
    this.rdp_1 = title;
    this.sdp_1 = body;
  }
  toString() {
    return 'HelpEntry(num=' + this.qdp_1 + ', title=' + this.rdp_1 + ', body=' + this.sdp_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.qdp_1);
    result = imul(result, 31) + getStringHashCode(this.rdp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sdp_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HelpEntry))
      return false;
    var tmp0_other_with_cast = other instanceof HelpEntry ? other : THROW_CCE();
    if (!(this.qdp_1 === tmp0_other_with_cast.qdp_1))
      return false;
    if (!(this.rdp_1 === tmp0_other_with_cast.rdp_1))
      return false;
    if (!(this.sdp_1 === tmp0_other_with_cast.sdp_1))
      return false;
    return true;
  }
}
class TeaTone extends Enum {}
class TeaItem {
  constructor(kanji, tone, name, sub, price) {
    this.bdu_1 = kanji;
    this.cdu_1 = tone;
    this.ddu_1 = name;
    this.edu_1 = sub;
    this.fdu_1 = price;
  }
  toString() {
    return 'TeaItem(kanji=' + this.bdu_1 + ', tone=' + this.cdu_1.toString() + ', name=' + this.ddu_1 + ', sub=' + this.edu_1 + ', price=' + this.fdu_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.bdu_1);
    result = imul(result, 31) + this.cdu_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.ddu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.edu_1) | 0;
    result = imul(result, 31) + (this.fdu_1 == null ? 0 : getStringHashCode(this.fdu_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TeaItem))
      return false;
    var tmp0_other_with_cast = other instanceof TeaItem ? other : THROW_CCE();
    if (!(this.bdu_1 === tmp0_other_with_cast.bdu_1))
      return false;
    if (!this.cdu_1.equals(tmp0_other_with_cast.cdu_1))
      return false;
    if (!(this.ddu_1 === tmp0_other_with_cast.ddu_1))
      return false;
    if (!(this.edu_1 === tmp0_other_with_cast.edu_1))
      return false;
    if (!(this.fdu_1 == tmp0_other_with_cast.fdu_1))
      return false;
    return true;
  }
}
class KinPalette {
  constructor(paper, paperDeep, surface, ink, inkSoft, muted, line, lineFirm, vermillion, gold, goldSoft, isDark) {
    this.xde_1 = paper;
    this.yde_1 = paperDeep;
    this.zde_1 = surface;
    this.adf_1 = ink;
    this.bdf_1 = inkSoft;
    this.cdf_1 = muted;
    this.ddf_1 = line;
    this.edf_1 = lineFirm;
    this.fdf_1 = vermillion;
    this.gdf_1 = gold;
    this.hdf_1 = goldSoft;
    this.idf_1 = isDark;
  }
  toString() {
    return 'KinPalette(paper=' + RGBA__toString_impl_4lw6dp(this.xde_1) + ', paperDeep=' + RGBA__toString_impl_4lw6dp(this.yde_1) + ', surface=' + RGBA__toString_impl_4lw6dp(this.zde_1) + ', ink=' + RGBA__toString_impl_4lw6dp(this.adf_1) + ', inkSoft=' + RGBA__toString_impl_4lw6dp(this.bdf_1) + ', muted=' + RGBA__toString_impl_4lw6dp(this.cdf_1) + ', line=' + RGBA__toString_impl_4lw6dp(this.ddf_1) + ', lineFirm=' + RGBA__toString_impl_4lw6dp(this.edf_1) + ', vermillion=' + RGBA__toString_impl_4lw6dp(this.fdf_1) + ', gold=' + RGBA__toString_impl_4lw6dp(this.gdf_1) + ', goldSoft=' + RGBA__toString_impl_4lw6dp(this.hdf_1) + ', isDark=' + this.idf_1 + ')';
  }
  hashCode() {
    var result = RGBA__hashCode_impl_h59qf6(this.xde_1);
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.yde_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.zde_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.adf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.bdf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.cdf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.ddf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.edf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.fdf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.gdf_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.hdf_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.idf_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KinPalette))
      return false;
    var tmp0_other_with_cast = other instanceof KinPalette ? other : THROW_CCE();
    if (!(this.xde_1 === tmp0_other_with_cast.xde_1))
      return false;
    if (!(this.yde_1 === tmp0_other_with_cast.yde_1))
      return false;
    if (!(this.zde_1 === tmp0_other_with_cast.zde_1))
      return false;
    if (!(this.adf_1 === tmp0_other_with_cast.adf_1))
      return false;
    if (!(this.bdf_1 === tmp0_other_with_cast.bdf_1))
      return false;
    if (!(this.cdf_1 === tmp0_other_with_cast.cdf_1))
      return false;
    if (!(this.ddf_1 === tmp0_other_with_cast.ddf_1))
      return false;
    if (!(this.edf_1 === tmp0_other_with_cast.edf_1))
      return false;
    if (!(this.fdf_1 === tmp0_other_with_cast.fdf_1))
      return false;
    if (!(this.gdf_1 === tmp0_other_with_cast.gdf_1))
      return false;
    if (!(this.hdf_1 === tmp0_other_with_cast.hdf_1))
      return false;
    if (!(this.idf_1 === tmp0_other_with_cast.idf_1))
      return false;
    return true;
  }
}
class BtnSpec {
  constructor() {
    BtnSpec_instance = this;
    this.xdf_1 = 10.0;
    this.ydf_1 = rgba('#f7f1e4');
  }
  gdq(theme) {
    return theme.fdf_1;
  }
}
class StonePalette {
  constructor(outer, inner, border, needsLightOutline) {
    needsLightOutline = needsLightOutline === VOID ? false : needsLightOutline;
    this.rdu_1 = outer;
    this.sdu_1 = inner;
    this.tdu_1 = border;
    this.udu_1 = needsLightOutline;
  }
  toString() {
    var tmp = RGBA__toString_impl_4lw6dp(this.rdu_1);
    var tmp_0 = RGBA__toString_impl_4lw6dp(this.sdu_1);
    var tmp_1 = this.tdu_1;
    return 'StonePalette(outer=' + tmp + ', inner=' + tmp_0 + ', border=' + toString(tmp_1 == null ? null : new RGBA(tmp_1)) + ', needsLightOutline=' + this.udu_1 + ')';
  }
  hashCode() {
    var result = RGBA__hashCode_impl_h59qf6(this.rdu_1);
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.sdu_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.tdu_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.tdu_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.udu_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StonePalette))
      return false;
    var tmp0_other_with_cast = other instanceof StonePalette ? other : THROW_CCE();
    if (!(this.rdu_1 === tmp0_other_with_cast.rdu_1))
      return false;
    if (!(this.sdu_1 === tmp0_other_with_cast.sdu_1))
      return false;
    var tmp = this.tdu_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.tdu_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!(this.udu_1 === tmp0_other_with_cast.udu_1))
      return false;
    return true;
  }
}
class Theme {
  fdt() {
    return SettingsStore_getInstance().ddc_1.pdb_1;
  }
  wde() {
    return this.fdt() ? get_KIN_DARK() : get_KIN_LIGHT();
  }
  edt(dark) {
    if (this.fdt() === dark)
      return Unit_instance;
    var tmp = SettingsStore_getInstance();
    tmp.hdc(Theme$set$lambda(dark));
  }
  hdp() {
    return this.edt(!this.fdt());
  }
}
class Fonts {
  constructor() {
    this.bdd_1 = false;
  }
  kdf() {
    var tmp = this.udc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('serif');
    }
  }
  fdp() {
    var tmp = this.vdc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('serifItalic');
    }
  }
  zdf() {
    var tmp = this.xdc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('serifJp');
    }
  }
  tdp() {
    var tmp = this.ydc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('ui');
    }
  }
  adg() {
    var tmp = this.zdc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('uiMedium');
    }
  }
  udk() {
    var tmp = this.add_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('uiSemiBold');
    }
  }
  cdd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadOnce__cxfafz.bind(VOID, this), $completion);
  }
}
class KinType {
  constructor(font, size) {
    this.edm_1 = font;
    this.fdm_1 = size;
  }
  toString() {
    return 'KinType(font=' + toString_0(this.edm_1) + ', size=' + this.fdm_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.edm_1);
    result = imul(result, 31) + getNumberHashCode(this.fdm_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KinType))
      return false;
    var tmp0_other_with_cast = other instanceof KinType ? other : THROW_CCE();
    if (!equals(this.edm_1, tmp0_other_with_cast.edm_1))
      return false;
    if (!equals(this.fdm_1, tmp0_other_with_cast.fdm_1))
      return false;
    return true;
  }
}
class Type {
  kds() {
    return new KinType(Type$_get_display_$lambda_qebtru, 56.0);
  }
  g9g() {
    return new KinType(Type$_get_title_$lambda_js578c, 36.0);
  }
  gdm() {
    return new KinType(Type$_get_subtitle_$lambda_xy7r3m, 22.0);
  }
  ddt() {
    return new KinType(Type$_get_body_$lambda_3j9t60, 14.0);
  }
  vdu() {
    return new KinType(Type$_get_button_$lambda_nd8j2w, 16.0);
  }
  wdu() {
    return new KinType(Type$_get_buttonSmall_$lambda_zcb7pj, 14.0);
  }
  gdp() {
    return new KinType(Type$_get_caption_$lambda_f2b3h2, 13.0);
  }
  wdf() {
    return new KinType(Type$_get_captionItalic_$lambda_6pc3wm, 13.0);
  }
  jdf() {
    return new KinType(Type$_get_meta_$lambda_bw6vlx, 11.0);
  }
  edq() {
    return new KinType(Type$_get_labelCaps_$lambda_1d03k7, 12.0);
  }
  lds() {
    return new KinType(Type$_get_trackingBrand_$lambda_kin2i4, 12.0);
  }
  pdp() {
    return new KinType(Type$_get_ideogram_$lambda_p6rub2, 28.0);
  }
}
class BoardSpec {
  constructor() {
    BoardSpec_instance = this;
    this.ldr_1 = 15;
    this.mdr_1 = 22.0;
    this.ndr_1 = 14.0;
    this.odr_1 = 0.42;
    this.pdr_1 = 1.8;
    this.qdr_1 = listOf([to(3, 3), to(3, 11), to(7, 7), to(11, 3), to(11, 11)]);
    this.rdr_1 = 0.6;
    this.sdr_1 = 1.5;
    this.tdr_1 = 336.0;
  }
}
class Display {
  constructor() {
    Display_instance = this;
    var tmp = this;
    tmp.hdd_1 = Display$nativeWidthProvider$lambda;
  }
  xdu() {
    return coerceAtLeast_0(this.hdd_1() / 360, 4.0);
  }
}
//endregion
function checkWin($this, row, col, player) {
  var _iterator__ex2g4s = $this.hd8_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var dRow = _destruct__k2r9zo.ul();
    var dCol = _destruct__k2r9zo.vl();
    var line = getLine($this, row, col, dRow, dCol, player);
    if (line.e1() >= 5) {
      return new WinningLine(line);
    }
  }
  return null;
}
function getLine($this, row, col, dRow, dCol, player) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var line = ArrayList.i1();
  line.h(new Position(row, col));
  var r = row + dRow | 0;
  var c = col + dCol | 0;
  while ($this.cd8_1.ld8(r, c) && equals($this.cd8_1.md8(r, c), player)) {
    line.h(new Position(r, c));
    r = r + dRow | 0;
    c = c + dCol | 0;
  }
  r = row - dRow | 0;
  c = col - dCol | 0;
  while ($this.cd8_1.ld8(r, c) && equals($this.cd8_1.md8(r, c), player)) {
    line.q3(0, new Position(r, c));
    r = r - dRow | 0;
    c = c - dCol | 0;
  }
  return line;
}
var NoMovesToUndo_instance;
function NoMovesToUndo_getInstance() {
  if (NoMovesToUndo_instance === VOID)
    new NoMovesToUndo();
  return NoMovesToUndo_instance;
}
var Companion_instance_3;
function Companion_getInstance_11() {
  if (Companion_instance_3 === VOID)
    new Companion();
  return Companion_instance_3;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
var Companion_instance_4;
function Companion_getInstance_12() {
  if (Companion_instance_4 === VOID)
    new Companion_0();
  return Companion_instance_4;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
var Companion_instance_5;
function Companion_getInstance_13() {
  if (Companion_instance_5 === VOID)
    new Companion_1();
  return Companion_instance_5;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
var Seals_instance;
function Seals_getInstance() {
  if (Seals_instance === VOID)
    new Seals();
  return Seals_instance;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = save(RecordsStore_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_load__qllgda($this, $completion) {
  try {
    var dir = StandardPaths_instance.n36('gomoku');
    var file = localVfs(dir).oi('records.json');
    var tmp = file.u2b($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (tmp) {
      var tmp_0 = $this;
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = $this.hdb_1;
      var tmp_1 = file.r2b(VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var string = tmp_1;
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.ucg();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(RecordsData), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp_0.ddb_1 = this_0.icx(tmp$ret$1, string);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function scheduleSave($this) {
  var tmp = EmptyCoroutineContext_getInstance();
  launchImmediately(tmp, RecordsStore$scheduleSave$slambda_0());
}
function *_generator_save__qhzefp($this, $completion) {
  try {
    var dir = StandardPaths_instance.n36('gomoku');
    var file = localVfs(dir).oi('records.json');
    var tmp = file.l2b().x2b([], $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = $this.hdb_1;
    var value = $this.ddb_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.ucg();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(RecordsData), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.hcx(tmp$ret$1, value);
    var tmp_0 = file.t2b(tmp$ret$2, [], VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function save($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, $this), $completion);
}
function onGameFinished$award(s, earned, key, cond) {
  if (cond && !s.qda_1.z2(key)) {
    // Inline function 'kotlin.collections.plusAssign' call
    earned.h(key);
  }
}
function RecordsStore$json$lambda($this$Json) {
  $this$Json.zcx_1 = true;
  $this$Json.xcx_1 = true;
  return Unit_instance;
}
function RecordsStore$scheduleSave$slambda_0() {
  var i = new RecordsStore$scheduleSave$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
var RecordsStore_instance;
function RecordsStore_getInstance() {
  if (RecordsStore_instance === VOID)
    new RecordsStore();
  return RecordsStore_instance;
}
var RenjuViolation_OVERLINE_instance;
var RenjuViolation_DOUBLE_FOUR_instance;
var RenjuViolation_DOUBLE_THREE_instance;
var RenjuViolation_entriesInitialized;
function RenjuViolation_initEntries() {
  if (RenjuViolation_entriesInitialized)
    return Unit_instance;
  RenjuViolation_entriesInitialized = true;
  RenjuViolation_OVERLINE_instance = new RenjuViolation('OVERLINE', 0);
  RenjuViolation_DOUBLE_FOUR_instance = new RenjuViolation('DOUBLE_FOUR', 1);
  RenjuViolation_DOUBLE_THREE_instance = new RenjuViolation('DOUBLE_THREE', 2);
}
function runLength($this, board, r, c, dr, dc) {
  var len = 1;
  var rr = r + dr | 0;
  var cc = c + dc | 0;
  while (equals(board.md8(rr, cc), StoneColor_BLACK_getInstance())) {
    len = len + 1 | 0;
    rr = rr + dr | 0;
    cc = cc + dc | 0;
  }
  rr = r - dr | 0;
  cc = c - dc | 0;
  while (equals(board.md8(rr, cc), StoneColor_BLACK_getInstance())) {
    len = len + 1 | 0;
    rr = rr - dr | 0;
    cc = cc - dc | 0;
  }
  return len;
}
function countFours($this, board, r, c, dr, dc) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var stoneSets = LinkedHashSet.h1();
  var inductionVariable = -4;
  if (inductionVariable <= 0)
    $l$loop_3: do {
      var offset = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mutableListOf' call
      var blacks = ArrayList.i1();
      var empty = null;
      var ok = true;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 4)
        $l$loop_1: do {
          var k = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var rr = r + imul(offset + k | 0, dr) | 0;
          var cc = c + imul(offset + k | 0, dc) | 0;
          if (!board.ld8(rr, cc)) {
            ok = false;
            break $l$loop_1;
          }
          var tmp0_subject = board.md8(rr, cc);
          switch (tmp0_subject == null ? -1 : tmp0_subject.t3_1) {
            case 0:
              // Inline function 'kotlin.collections.plusAssign' call

              var element = imul(rr, 15) + cc | 0;
              blacks.h(element);
              break;
            case -1:
              if (empty == null)
                empty = to(rr, cc);
              else {
                ok = false;
                break $l$loop_1;
              }

              break;
            default:
              ok = false;
              break $l$loop_1;
          }
        }
         while (inductionVariable_0 <= 4);
      if (!ok || !(blacks.e1() === 4))
        continue $l$loop_3;
      var tmp1_elvis_lhs = empty;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_3;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var e = tmp;
      if (completesExactlyFive($this, board, e.sl_1, e.tl_1, dr, dc)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = sorted(blacks);
        stoneSets.h(element_0);
      }
    }
     while (inductionVariable <= 0);
  return stoneSets.e1();
}
function completesExactlyFive($this, board, r, c, dr, dc) {
  if (!board.rd8(r, c, StoneColor_BLACK_getInstance()))
    return false;
  var len = runLength($this, board, r, c, dr, dc);
  board.zd8();
  return len === 5;
}
function hasOpenThree($this, board, r, c, dr, dc) {
  var inductionVariable = -4;
  if (inductionVariable <= 4)
    $l$loop_1: do {
      var step = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (step === 0)
        continue $l$loop_1;
      var er = r + imul(step, dr) | 0;
      var ec = c + imul(step, dc) | 0;
      if (!board.od8(er, ec))
        continue $l$loop_1;
      if (!board.rd8(er, ec, StoneColor_BLACK_getInstance()))
        continue $l$loop_1;
      var straight = hasStraightFour($this, board, r, c, dr, dc);
      board.zd8();
      if (straight)
        return true;
    }
     while (inductionVariable <= 4);
  return false;
}
function hasStraightFour($this, board, r, c, dr, dc) {
  var inductionVariable = -4;
  if (inductionVariable <= -1)
    do {
      var offset = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var blacks = 0;
      var ok = true;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 5)
        $l$loop_1: do {
          var k = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var rr = r + imul(offset + k | 0, dr) | 0;
          var cc = c + imul(offset + k | 0, dc) | 0;
          if (!board.ld8(rr, cc)) {
            ok = false;
            break $l$loop_1;
          }
          var s = board.md8(rr, cc);
          switch (k) {
            case 0:
            case 5:
              if (!(s == null)) {
                ok = false;
                break $l$loop_1;
              }

              break;
            default:
              if (!equals(s, StoneColor_BLACK_getInstance())) {
                ok = false;
                break $l$loop_1;
              }

              blacks = blacks + 1 | 0;
              break;
          }
        }
         while (inductionVariable_0 <= 5);
      if (ok && blacks === 4)
        return true;
    }
     while (inductionVariable <= -1);
  return false;
}
var RenjuRules_instance;
function RenjuRules_getInstance() {
  if (RenjuRules_instance === VOID)
    new RenjuRules();
  return RenjuRules_instance;
}
function RenjuViolation_OVERLINE_getInstance() {
  RenjuViolation_initEntries();
  return RenjuViolation_OVERLINE_instance;
}
function RenjuViolation_DOUBLE_FOUR_getInstance() {
  RenjuViolation_initEntries();
  return RenjuViolation_DOUBLE_FOUR_instance;
}
function RenjuViolation_DOUBLE_THREE_getInstance() {
  RenjuViolation_initEntries();
  return RenjuViolation_DOUBLE_THREE_instance;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.kdb_1.u1();
}
function PlayerColorPref$Companion$_anonymous__iwyb0q() {
  return createSimpleEnumSerializer('logic.PlayerColorPref', values());
}
var PlayerColorPref_ALTERNATE_instance;
var PlayerColorPref_WHITE_instance;
var PlayerColorPref_BLACK_instance;
function values() {
  return [PlayerColorPref_ALTERNATE_getInstance(), PlayerColorPref_WHITE_getInstance(), PlayerColorPref_BLACK_getInstance()];
}
var Companion_instance_6;
function Companion_getInstance_14() {
  PlayerColorPref_initEntries();
  if (Companion_instance_6 === VOID)
    new Companion_2();
  return Companion_instance_6;
}
var PlayerColorPref_entriesInitialized;
function PlayerColorPref_initEntries() {
  if (PlayerColorPref_entriesInitialized)
    return Unit_instance;
  PlayerColorPref_entriesInitialized = true;
  PlayerColorPref_ALTERNATE_instance = new PlayerColorPref('ALTERNATE', 0);
  PlayerColorPref_WHITE_instance = new PlayerColorPref('WHITE', 1);
  PlayerColorPref_BLACK_instance = new PlayerColorPref('BLACK', 2);
  Companion_getInstance_14();
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.ldb_1.u1();
}
function Rules$Companion$_anonymous__vhp53s() {
  return createSimpleEnumSerializer('logic.Rules', values_0());
}
var Rules_CLASSIC_instance;
var Rules_RENJU_instance;
function values_0() {
  return [Rules_CLASSIC_getInstance(), Rules_RENJU_getInstance()];
}
var Companion_instance_7;
function Companion_getInstance_15() {
  Rules_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_3();
  return Companion_instance_7;
}
var Rules_entriesInitialized;
function Rules_initEntries() {
  if (Rules_entriesInitialized)
    return Unit_instance;
  Rules_entriesInitialized = true;
  Rules_CLASSIC_instance = new Rules('CLASSIC', 0);
  Rules_RENJU_instance = new Rules('RENJU', 1);
  Companion_getInstance_15();
}
var Companion_instance_8;
function Companion_getInstance_16() {
  if (Companion_instance_8 === VOID)
    new Companion_4();
  return Companion_instance_8;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = save_0(SettingsStore_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_load__qllgda_0($this, $completion) {
  try {
    var dir = StandardPaths_instance.n36('gomoku');
    var file = localVfs(dir).oi('settings.json');
    var tmp = file.u2b($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (tmp) {
      var tmp_0 = $this;
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = $this.gdc_1;
      var tmp_1 = file.r2b(VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var string = tmp_1;
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.ucg();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(Settings), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp_0.ddc_1 = this_0.icx(tmp$ret$1, string);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function scheduleSave_0($this) {
  var tmp = EmptyCoroutineContext_getInstance();
  launchImmediately(tmp, SettingsStore$scheduleSave$slambda_0());
}
function *_generator_save__qhzefp_0($this, $completion) {
  try {
    var dir = StandardPaths_instance.n36('gomoku');
    var file = localVfs(dir).oi('settings.json');
    var tmp = file.l2b().x2b([], $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = $this.gdc_1;
    var value = $this.ddc_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.ucg();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(Settings), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.hcx(tmp$ret$1, value);
    var tmp_0 = file.t2b(tmp$ret$2, [], VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function save_0($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp_0.bind(VOID, $this), $completion);
}
function SettingsStore$json$lambda($this$Json) {
  $this$Json.bcy_1 = true;
  $this$Json.zcx_1 = true;
  $this$Json.xcx_1 = true;
  return Unit_instance;
}
function SettingsStore$scheduleSave$slambda_0() {
  var i = new SettingsStore$scheduleSave$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
var SettingsStore_instance;
function SettingsStore_getInstance() {
  if (SettingsStore_instance === VOID)
    new SettingsStore();
  return SettingsStore_instance;
}
function PlayerColorPref_ALTERNATE_getInstance() {
  PlayerColorPref_initEntries();
  return PlayerColorPref_ALTERNATE_instance;
}
function PlayerColorPref_WHITE_getInstance() {
  PlayerColorPref_initEntries();
  return PlayerColorPref_WHITE_instance;
}
function PlayerColorPref_BLACK_getInstance() {
  PlayerColorPref_initEntries();
  return PlayerColorPref_BLACK_instance;
}
function Rules_CLASSIC_getInstance() {
  Rules_initEntries();
  return Rules_CLASSIC_instance;
}
function Rules_RENJU_getInstance() {
  Rules_initEntries();
  return Rules_RENJU_instance;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.td9_1.u1();
}
function Difficulty$Companion$_anonymous__8jmm7g() {
  return createSimpleEnumSerializer('logic.ai.Difficulty', values_1());
}
var Difficulty_EASY_instance;
var Difficulty_MID_instance;
var Difficulty_HARD_instance;
function values_1() {
  return [Difficulty_EASY_getInstance(), Difficulty_MID_getInstance(), Difficulty_HARD_getInstance()];
}
var Companion_instance_9;
function Companion_getInstance_17() {
  Difficulty_initEntries();
  if (Companion_instance_9 === VOID)
    new Companion_5();
  return Companion_instance_9;
}
var Difficulty_entriesInitialized;
function Difficulty_initEntries() {
  if (Difficulty_entriesInitialized)
    return Unit_instance;
  Difficulty_entriesInitialized = true;
  Difficulty_EASY_instance = new Difficulty('EASY', 0);
  Difficulty_MID_instance = new Difficulty('MID', 1);
  Difficulty_HARD_instance = new Difficulty('HARD', 2);
  Companion_getInstance_17();
}
var AiFactory_instance;
function AiFactory_getInstance() {
  return AiFactory_instance;
}
function pickBest($this, sorted) {
  var top = first(sorted).tl_1;
  // Inline function 'kotlin.collections.takeWhile' call
  var list = ArrayList.i1();
  var tmp0_iterator = sorted.a1();
  $l$loop: while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'logic.ai.HeuristicAi.pickBest.<anonymous>' call
    if (!item.tl_1.equals(top))
      break $l$loop;
    list.h(item);
  }
  return random(list, Default_getInstance()).sl_1;
}
function HeuristicAi$chooseMove$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'logic.ai.HeuristicAi.chooseMove.<anonymous>' call
  var tmp = b.tl_1;
  // Inline function 'logic.ai.HeuristicAi.chooseMove.<anonymous>' call
  var tmp$ret$1 = a.tl_1;
  return compareValues(tmp, tmp$ret$1);
}
function HeuristicAi$chooseMove$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'logic.ai.HeuristicAi.chooseMove.<anonymous>' call
  var tmp = b.tl_1;
  // Inline function 'logic.ai.HeuristicAi.chooseMove.<anonymous>' call
  var tmp$ret$1 = a.tl_1;
  return compareValues(tmp, tmp$ret$1);
}
function scoreMove(board, r, c, me, opp, opponentBias) {
  opponentBias = opponentBias === VOID ? 0.9 : opponentBias;
  var dirs = listOf([to(0, 1), to(1, 0), to(1, 1), to(1, -1)]);
  var attack = new Long(0, 0);
  var defense = new Long(0, 0);
  var _iterator__ex2g4s = dirs.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var dr = _destruct__k2r9zo.ul();
    var dc = _destruct__k2r9zo.vl();
    attack = attack.a4(evalWindows(board, r, c, dr, dc, me));
    defense = defense.a4(evalWindows(board, r, c, dr, dc, opp));
  }
  // Inline function 'kotlin.math.max' call
  var a = abs(r - 7 | 0);
  var b = abs(c - 7 | 0);
  var tmp$ret$0 = Math.max(a, b);
  var centerBonus = toLong(7 - tmp$ret$0 | 0);
  var tmp = attack;
  // Inline function 'kotlin.Long.times' call
  var tmp$ret$1 = defense.r4() * opponentBias;
  return tmp.a4(numberToLong(tmp$ret$1)).a4(centerBonus);
}
function legalCandidates(game, radius) {
  var near = candidateCells(game.ed9(), radius);
  if (!game.bd8_1)
    return near;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.i1();
  var tmp0_iterator = near.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'logic.ai.legalCandidates.<anonymous>' call
    if (game.hd9(element.odc_1, element.pdc_1)) {
      destination.h(element);
    }
  }
  var legal = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!legal.g1())
    return legal;
  // Inline function 'kotlin.collections.ifEmpty' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = game.ed9().qdc();
  var destination_0 = ArrayList.i1();
  var tmp0_iterator_0 = this_0.a1();
  while (tmp0_iterator_0.b1()) {
    var element_0 = tmp0_iterator_0.c1();
    // Inline function 'logic.ai.legalCandidates.<anonymous>' call
    if (game.hd9(element_0.odc_1, element_0.pdc_1)) {
      destination_0.h(element_0);
    }
  }
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  if (destination_0.g1()) {
    // Inline function 'logic.ai.legalCandidates.<anonymous>' call
    tmp = near;
  } else {
    tmp = destination_0;
  }
  return tmp;
}
function candidateCells(board, radius) {
  radius = radius === VOID ? 2 : radius;
  // Inline function 'kotlin.collections.mutableSetOf' call
  var out = LinkedHashSet.h1();
  var n = 15;
  var inductionVariable = 0;
  if (inductionVariable < n)
    do {
      var r = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < n)
        do {
          var c = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(board.md8(r, c) == null)) {
            var inductionVariable_1 = -radius | 0;
            if (inductionVariable_1 <= radius)
              do {
                var dr = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var inductionVariable_2 = -radius | 0;
                if (inductionVariable_2 <= radius)
                  do {
                    var dc = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var nr = r + dr | 0;
                    var nc = c + dc | 0;
                    if (board.od8(nr, nc)) {
                      // Inline function 'kotlin.collections.plusAssign' call
                      var element = new Position(nr, nc);
                      out.h(element);
                    }
                  }
                   while (!(dc === radius));
              }
               while (!(dr === radius));
          }
        }
         while (inductionVariable_0 < n);
    }
     while (inductionVariable < n);
  if (out.g1()) {
    // Inline function 'kotlin.collections.plusAssign' call
    var element_0 = new Position(7, 7);
    out.h(element_0);
  }
  return toList(out);
}
function evalWindows(board, r, c, dr, dc, color) {
  var total = new Long(0, 0);
  var inductionVariable = -4;
  if (inductionVariable <= 0)
    $l$loop_1: do {
      var offset = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var mine = 0;
      var blocked = false;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 4)
        $l$loop_0: do {
          var k = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var rr = r + imul(offset + k | 0, dr) | 0;
          var cc = c + imul(offset + k | 0, dc) | 0;
          if (!board.ld8(rr, cc)) {
            blocked = true;
            break $l$loop_0;
          }
          var s = rr === r && cc === c ? color : board.md8(rr, cc);
          var tmp0 = s == null ? -1 : s.t3_1;
          if (equals(s, color)) {
            mine = mine + 1 | 0;
          } else if (tmp0 !== -1) {
            blocked = true;
          }
          if (blocked)
            break $l$loop_0;
        }
         while (inductionVariable_0 <= 4);
      if (blocked)
        continue $l$loop_1;
      var tmp = total;
      var tmp1_subject = mine;
      total = tmp.a4(tmp1_subject === 5 ? new Long(10000000, 0) : tmp1_subject === 4 ? new Long(120000, 0) : tmp1_subject === 3 ? new Long(5000, 0) : tmp1_subject === 2 ? new Long(200, 0) : new Long(5, 0));
    }
     while (inductionVariable <= 0);
  return total;
}
function topMoves(game, count) {
  count = count === VOID ? 3 : count;
  var board = game.ed9();
  var me = game.dd8_1;
  var opp = me.vd8();
  var candidates = candidateCells(board, 1);
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(candidates, 10));
  var tmp0_iterator = candidates.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'logic.ai.topMoves.<anonymous>' call
    var tmp$ret$0 = new HintMove(item, scoreMove(board, item.odc_1, item.pdc_1, me, opp));
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = topMoves$lambda;
  var tmp$ret$3 = new sam$kotlin_Comparator$0_0(tmp);
  var tmp$ret$4 = sortedWith(destination, tmp$ret$3);
  return take(tmp$ret$4, count);
}
function topMoves$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'logic.ai.topMoves.<anonymous>' call
  var tmp = b.sdc_1;
  // Inline function 'logic.ai.topMoves.<anonymous>' call
  var tmp$ret$1 = a.sdc_1;
  return compareValues(tmp, tmp$ret$1);
}
function Difficulty_EASY_getInstance() {
  Difficulty_initEntries();
  return Difficulty_EASY_instance;
}
function Difficulty_MID_getInstance() {
  Difficulty_initEntries();
  return Difficulty_MID_instance;
}
function Difficulty_HARD_getInstance() {
  Difficulty_initEntries();
  return Difficulty_HARD_instance;
}
function *_generator_main__qlaff5($completion) {
  var tmp0_windowSize = Size2D.o2e(360, 720);
  var tmp1_backgroundColor = Colors_getInstance().s4k('#f5f0e6');
  var tmp = Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_windowSize, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 'Gomoku \xB7 Kintsugi', VOID, tmp1_backgroundColor, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function main($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_main__qlaff5.bind(VOID), $completion);
}
function *_generator_invoke__zhh2q8_1($this, $this$Korge, $completion) {
  var tmp = Fonts_instance.cdd($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = SettingsStore_getInstance().idb($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (SettingsStore_getInstance().ddc_1.ydb_1.equals(new Long(0, 0))) {
    var tmp_1 = SettingsStore_getInstance();
    tmp_1.hdc(main$slambda$lambda);
  }
  var tmp_2 = RecordsStore_getInstance().idb($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = MusicPlayer_instance.gdd($this$Korge.fa7().f9x_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = Display_getInstance();
  tmp_4.hdd_1 = main$slambda$lambda_0($this$Korge);
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_10()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_1().x2n_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_5 = views($completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var views_0 = tmp_5;
  var width = size.ul();
  var height = size.vl();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_6 = findFirstAscendant($this$Korge, main$slambda$lambda_1);
    var base = (tmp_6 == null ? true : tmp_6 instanceof FixedSizeContainer) ? tmp_6 : null;
    var tmp1_elvis_lhs = base == null ? null : base.x2p();
    rwidth = tmp1_elvis_lhs == null ? views_0.r9y_1.x2p() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.y2p();
    rheight = tmp3_elvis_lhs == null ? views_0.r9y_1.y2p() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.sa4(views_0, defaultTransition, name, Size2D.u2l(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var container = addTo(this_0, $this$Korge);
  Nav_getInstance().idd_1 = container;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = container.na4_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(SplashScene);
  var injects_0 = injects.slice();
  var sceneInjector = container.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), container).a6i(getKClass(Resources), new Resources(container.s17(), container.ma4_1.oa5().z3b_1, container.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_7 = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp_7, KClass) ? tmp_7 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new SplashScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_8;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$8);
    tmp_8 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_9 = getKClassFromExpression(newScene);
    var tmp_10 = isInterface(tmp_9, KClass) ? tmp_9 : THROW_CCE();
    container.ma4_1.h9x_1.e6i(tmp_10, main$slambda$lambda_2(sceneInjector));
  }
  var tmp_11 = container.vah(newScene, time, transition, $completion);
  if (tmp_11 === get_COROUTINE_SUSPENDED())
    tmp_11 = yield tmp_11;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it.cdc(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance_0().i1y()));
}
function main$slambda$lambda_0($this_Korge) {
  return function () {
    return $this_Korge.fa7().qa5();
  };
}
function main$slambda$lambda_1(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_2($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new SplashScene();
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.a9u($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.vd9_1.u1();
}
function StoneColor$Companion$_anonymous__ru0jxr() {
  return createSimpleEnumSerializer('model.StoneColor', values_2());
}
var StoneColor_BLACK_instance;
var StoneColor_WHITE_instance;
function values_2() {
  return [StoneColor_BLACK_getInstance(), StoneColor_WHITE_getInstance()];
}
var Companion_instance_10;
function Companion_getInstance_18() {
  StoneColor_initEntries();
  if (Companion_instance_10 === VOID)
    new Companion_6();
  return Companion_instance_10;
}
var StoneColor_entriesInitialized;
function StoneColor_initEntries() {
  if (StoneColor_entriesInitialized)
    return Unit_instance;
  StoneColor_entriesInitialized = true;
  StoneColor_BLACK_instance = new StoneColor('BLACK', 0);
  StoneColor_WHITE_instance = new StoneColor('WHITE', 1);
  Companion_getInstance_18();
}
var Companion_instance_11;
function Companion_getInstance_19() {
  return Companion_instance_11;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new $serializer_3();
  return $serializer_instance_3;
}
var Companion_instance_12;
function Companion_getInstance_20() {
  if (Companion_instance_12 === VOID)
    new Companion_8();
  return Companion_instance_12;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new $serializer_4();
  return $serializer_instance_4;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.ud9_1.u1();
}
function GameState$Companion$_anonymous__we4trk() {
  return createSimpleEnumSerializer('model.GameState', values_3());
}
var GameState_PLAYING_instance;
var GameState_BLACK_WINS_instance;
var GameState_WHITE_WINS_instance;
var GameState_DRAW_instance;
function values_3() {
  return [GameState_PLAYING_getInstance(), GameState_BLACK_WINS_getInstance(), GameState_WHITE_WINS_getInstance(), GameState_DRAW_getInstance()];
}
var Companion_instance_13;
function Companion_getInstance_21() {
  GameState_initEntries();
  if (Companion_instance_13 === VOID)
    new Companion_9();
  return Companion_instance_13;
}
var GameState_entriesInitialized;
function GameState_initEntries() {
  if (GameState_entriesInitialized)
    return Unit_instance;
  GameState_entriesInitialized = true;
  GameState_PLAYING_instance = new GameState('PLAYING', 0);
  GameState_BLACK_WINS_instance = new GameState('BLACK_WINS', 1);
  GameState_WHITE_WINS_instance = new GameState('WHITE_WINS', 2);
  GameState_DRAW_instance = new GameState('DRAW', 3);
  Companion_getInstance_21();
}
var Companion_instance_14;
function Companion_getInstance_22() {
  if (Companion_instance_14 === VOID)
    new Companion_10();
  return Companion_instance_14;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new $serializer_5();
  return $serializer_instance_5;
}
function StoneColor_BLACK_getInstance() {
  StoneColor_initEntries();
  return StoneColor_BLACK_instance;
}
function StoneColor_WHITE_getInstance() {
  StoneColor_initEntries();
  return StoneColor_WHITE_instance;
}
function GameState_PLAYING_getInstance() {
  GameState_initEntries();
  return GameState_PLAYING_instance;
}
function GameState_BLACK_WINS_getInstance() {
  GameState_initEntries();
  return GameState_BLACK_WINS_instance;
}
function GameState_WHITE_WINS_getInstance() {
  GameState_initEntries();
  return GameState_WHITE_WINS_instance;
}
function GameState_DRAW_getInstance() {
  GameState_initEntries();
  return GameState_DRAW_instance;
}
function VictoryScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function VictoryScene$sceneMain$lambda_0($cx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $y._v);
    return Unit_instance;
  };
}
function VictoryScene$sceneMain$lambda_1($cx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $y._v);
    return Unit_instance;
  };
}
function VictoryScene$sceneMain$lambda_2() {
  GameSession_getInstance().ide(GameSession_getInstance().cde_1);
  Nav_getInstance().jde();
  return Unit_instance;
}
function VictoryScene$sceneMain$lambda_3() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function VictoryScene$sceneMain$lambda$lambda() {
  Nav_getInstance().kde();
  return Unit_instance;
}
function VictoryScene$sceneMain$lambda_4($record) {
  return function () {
    var tmp = Nav_getInstance();
    tmp.lde($record, VictoryScene$sceneMain$lambda$lambda);
    return Unit_instance;
  };
}
function VictoryScene$sceneMain$lambda_5() {
  Nav_getInstance().jde();
  return Unit_instance;
}
function DefeatScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function DefeatScene$sceneMain$lambda_0($cx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $y._v);
    return Unit_instance;
  };
}
function DefeatScene$sceneMain$lambda_1($cx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $y._v);
    return Unit_instance;
  };
}
function DefeatScene$sceneMain$lambda_2($cx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $y._v);
    return Unit_instance;
  };
}
function DefeatScene$sceneMain$lambda_3() {
  GameSession_getInstance().ide(GameSession_getInstance().cde_1);
  Nav_getInstance().jde();
  return Unit_instance;
}
function DefeatScene$sceneMain$lambda_4() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function DefeatScene$sceneMain$lambda$lambda() {
  Nav_getInstance().ldf();
  return Unit_instance;
}
function DefeatScene$sceneMain$lambda_5($record) {
  return function () {
    var tmp = Nav_getInstance();
    tmp.lde($record, DefeatScene$sceneMain$lambda$lambda);
    return Unit_instance;
  };
}
function DefeatScene$sceneMain$lambda_6() {
  Nav_getInstance().jde();
  return Unit_instance;
}
function renderSealStamp(host, cx, y, seal, theme) {
  var chipW = 200.0;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, host);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.renderSealStamp.<anonymous>' call
  var row = position(this_1, cx - chipW / 2.0, y);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, row);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.renderSealStamp.<anonymous>' call
  // Inline function 'korlibs.korge.view.roundRect' call
  var size = Size2D.u2l(40.0, 40.0);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_2();
  var radius = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
  var fill = new RGBA(theme.fdf_1);
  var stroke = new RGBA(Colors_getInstance().y44_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = RoundRect.hc0(size, radius, fill, stroke, 0.0, true);
  // Inline function 'kotlin.apply' call
  addTo(this_4, this_3);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  var tmp = BtnSpec_getInstance().ydf_1;
  var tmp_0 = Fonts_instance.zdf();
  kinText(this_3, seal, 20.0, tmp, tmp_0, renderSealStamp$lambda);
  var stamp = this_3;
  position(stamp, 20.0, 20.0);
  // Inline function 'korlibs.korge.view.View.forEachChild' call
  var tmp0_safe_receiver = stamp.naq();
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp0_safe_receiver.e1()) {
      // Inline function 'scenes.renderSealStamp.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = tmp0_safe_receiver.d1(_unary__edvuaz);
      position(it, it.o6p() - 20.0, it.p6p() - 20.0);
    }
    tmp_1 = Unit_instance;
  }
  var tmp_2 = Fonts_instance.adg();
  kinText(row, '\u041D\u041E\u0412\u0410\u042F \u041F\u0415\u0427\u0410\u0422\u042C', 9.0, theme.cdf_1, tmp_2, renderSealStamp$lambda_0);
  var tmp_3 = Str_getInstance().tdk(seal);
  var tmp_4 = Fonts_instance.udk();
  kinText(row, tmp_3, 13.0, theme.adf_1, tmp_4, renderSealStamp$lambda_1);
  var t = {_v: -0.35};
  stamp.kas(0.0);
  var upd = {_v: null};
  upd._v = addUpdater(stamp, renderSealStamp$lambda_2(t, stamp, upd));
}
function kinBrokenStone(_this__u8e3s4, theme) {
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.kinBrokenStone.<anonymous>' call
  var r = 52.0;
  // Inline function 'korlibs.korge.view.clipContainer' call
  var size = Size2D.u2l(50.0, 112.0);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = ClipContainer.vbf(size);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.kinBrokenStone.<anonymous>.<anonymous>' call
  position(this_3, 0.0, -4.0);
  this_3.fas(get_degrees(-2.0));
  var leftClip = this_3;
  position(kinStone(leftClip, true, r, VOID, VOID, theme), 52.0, 56.0);
  // Inline function 'korlibs.korge.view.clipContainer' call
  var size_0 = Size2D.u2l(56.0, 112.0);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = ClipContainer.vbf(size_0);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.kinBrokenStone.<anonymous>.<anonymous>' call
  position(this_5, 54.0, -4.0);
  this_5.fas(get_degrees(1.5));
  var rightClip = this_5;
  position(kinStone(rightClip, true, r, VOID, VOID, theme), -2.0, 56.0);
  var tmp0_y1 = -16.0;
  var tmp1_color = theme.gdf_1;
  var tmp2_colorSoft = theme.hdf_1;
  kinSeam(this_1, 60.0, tmp0_y1, 44.0, 118.0, 2.6, 5.0, 29, true, VOID, VOID, tmp1_color, tmp2_colorSoft);
  // Inline function 'korlibs.korge.view.circle' call
  var fill = new RGBA(theme.idf_1 ? Colors_getInstance().s4k('#4a4438') : Colors_getInstance().s4k('#2a2620'));
  var stroke = new RGBA(Colors_getInstance().y44_1);
  var renderer = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Circle.hbd(numberToDouble(2.5), fill, stroke, numberToDouble(0.0), true, renderer);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.kinBrokenStone.<anonymous>.<anonymous>' call
  position(this_7, 20.0, 110.0);
  // Inline function 'korlibs.korge.view.circle' call
  var fill_0 = new RGBA(theme.gdf_1);
  var stroke_0 = new RGBA(Colors_getInstance().y44_1);
  var renderer_0 = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = Circle.hbd(numberToDouble(1.5), fill_0, stroke_0, numberToDouble(0.0), true, renderer_0);
  // Inline function 'kotlin.apply' call
  var this_9 = addTo(this_8, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.kinBrokenStone.<anonymous>.<anonymous>' call
  position(this_9, 36.0, 114.0);
  return this_1;
}
function renderSealStamp$lambda($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().f4u_1);
  position($this$kinText, 20.0, 21.0);
  return Unit_instance;
}
function renderSealStamp$lambda_0($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().s4t_1);
  position($this$kinText, 52.0, 6.0);
  return Unit_instance;
}
function renderSealStamp$lambda_1($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().s4t_1);
  position($this$kinText, 52.0, 20.0);
  return Unit_instance;
}
function renderSealStamp$lambda_2($t, $stamp, $upd) {
  return function ($this$addUpdater, dt) {
    // Inline function 'kotlin.math.min' call
    var b = $t._v + get_milliseconds(dt.xj_1) / 450.0;
    var tmp$ret$0 = Math.min(1.0, b);
    $t._v = tmp$ret$0;
    var tmp;
    if ($t._v <= 0.0) {
      return Unit_instance;
    }
    // Inline function 'kotlin.math.min' call
    var b_0 = $t._v * 3.0;
    var tmp$ret$1 = Math.min(1.0, b_0);
    $stamp.kas(tmp$ret$1);
    var k = 1.0 - $t._v;
    scale($stamp, 1.0 + 0.6 * k * k);
    $stamp.fas(get_degrees(-2.0 - 7.0 * k * k));
    var tmp_0;
    if ($t._v >= 1.0) {
      var tmp0_safe_receiver = $upd._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function GameScene$Companion$petalBitmap$delegate$lambda() {
  return Bitmap32Context2d(12, 12, true, GameScene$Companion$petalBitmap$delegate$lambda$lambda);
}
function GameScene$Companion$petalBitmap$delegate$lambda$lambda($this$Bitmap32Context2d) {
  // Inline function 'korlibs.image.vector.Context2d.fill' call
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.image.vector.Context2d.createRadialGradient' call
  var cycle = CycleMethod_NO_CYCLE_getInstance();
  // Inline function 'korlibs.image.paint.RadialGradientPaint' call
  var transform = Companion_getInstance_3().s2g_1;
  // Inline function 'kotlin.also' call
  var this_0 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(4.2), numberToDouble(4.2), numberToDouble(0.0), numberToDouble(6.0), numberToDouble(6.0), numberToDouble(5.6), VOID, VOID, cycle, transform);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.Context2d.createRadialGradient.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.Companion.petalBitmap$delegate.<anonymous>.<anonymous>.<anonymous>' call
  this_0.q5a(0.0, Colors_getInstance().s4k('#f2c7cb'));
  this_0.q5a(1.0, Colors_getInstance().s4k('#dfa0aa'));
  if (true) {
    $this$Bitmap32Context2d.m4u();
  }
  // Inline function 'scenes.Companion.petalBitmap$delegate.<anonymous>.<anonymous>.<anonymous>' call
  $this$Bitmap32Context2d.b3g(Vector2D.q2f(6.0, 6.0), 5.5);
  $this$Bitmap32Context2d.l5t(this_0, null);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  while (true) {
    var tmp = delay((new Long(9000, 0)).a4(Default_getInstance().fp(new Long(8000, 0))), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if ($this.vdk_1.ed8_1.equals(GameState_PLAYING_getInstance())) {
      spawnPetal($this.wdk_1, $this.xdk_1, $this.ydk_1, $this.zdk_1);
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  var tmp = $this.ndl_1.kdl_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$launch, $completion) {
  var tmp = delay(new Long(1200, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if ($this.odl_1 === GameSession_getInstance().bde_1 && !$this.odl_1.ed8_1.equals(GameState_PLAYING_getInstance())) {
    var lost = $this.pdl_1.equals(GameMode_AI_getInstance()) && !($this.qdl_1.kd9_1 == null) && !equals($this.qdl_1.kd9_1, _get_humanColor__rhjpjp($this.rdl_1));
    if (lost) {
      Nav_getInstance().ldf();
    } else {
      Nav_getInstance().kde();
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  var tmp = $this.sdl_1.kdl_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  if (!$this.tdl_1.equals(GameMode_AI_getInstance()) || !$this.udl_1.ed8_1.equals(GameState_PLAYING_getInstance()) || !$this.udl_1.dd8_1.equals(_get_aiColor__1p1cgm($this.vdl_1)))
    return Unit_instance;
  $this.wdl_1._v = true;
  $this.xdl_1._v();
  var tmp = delay(new Long(450, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = Dispatchers_getInstance().p1e_1;
  var tmp_1 = withContext(tmp_0, GameScene$sceneMain$slambda$slambda_0($this.zdl_1, $this.udl_1), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var pos = tmp_1;
  $this.wdl_1._v = false;
  if (!($this.udl_1 === GameSession_getInstance().bde_1) || !$this.udl_1.ed8_1.equals(GameState_PLAYING_getInstance()) || !$this.udl_1.dd8_1.equals(_get_aiColor__1p1cgm($this.vdl_1)))
    return Unit_instance;
  $this.ydl_1._v(pos.odc_1, pos.pdc_1);
  return Unit_instance;
}
function GameScene$sceneMain$slambda$slambda_0($ai, $game) {
  var i = new GameScene$sceneMain$slambda$slambda($ai, $game);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $this$launch, $completion) {
  var tmp = $this.cdm_1.kdl_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $this$launch, $completion) {
  var tmp = $this.ddm_1.l6e(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function _get_humanColor__rhjpjp($this) {
  return GameSession_getInstance().dde_1;
}
function _get_aiColor__1p1cgm($this) {
  return GameSession_getInstance().dde_1.vd8();
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  var theme = Theme_instance.wde();
  var w = 360;
  var h = 720;
  var game = GameSession_getInstance().bde_1;
  var mode = GameSession_getInstance().cde_1;
  var ai = AiFactory_instance.idc(SettingsStore_getInstance().ddc_1.rdb_1);
  var tmp = $this;
  // Inline function 'kotlin.Result.getOrNull' call
  // Inline function 'kotlin.runCatching' call
  var tmp_0;
  try {
    // Inline function 'kotlin.Companion.success' call
    // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
    var tmp_1 = readSound(get_resourcesVfs().oi('sounds/stone.wav'), VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var value = tmp_1;
    tmp_0 = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var this_0 = tmp_0;
  var tmp_3;
  if (_Result___get_isFailure__impl__jpiriv(this_0)) {
    tmp_3 = null;
  } else {
    var tmp_4 = _Result___get_value__impl__bjfvqg(this_0);
    tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
  }
  tmp.mdl_1 = tmp_3;
  kinPaperBackground(_this__u8e3s4, theme);
  onBackOrEscape(_this__u8e3s4, GameScene$sceneMain$lambda);
  var tmp_5 = Type_instance.gdm().fdm_1;
  var tmp_6 = Fonts_instance.zdf();
  kinText(_this__u8e3s4, '\u4E94\u76EE', tmp_5, theme.adf_1, tmp_6, GameScene$sceneMain$lambda_0);
  var tmp_7;
  if (mode.equals(GameMode_AI_getInstance())) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_7 = 'VS  AI \xB7 ' + get_label(SettingsStore_getInstance().ddc_1.rdb_1).toUpperCase();
  } else {
    tmp_7 = 'VS  \u0418\u0413\u0420\u041E\u041A';
  }
  var modeLabel = tmp_7;
  var tmp_8 = Type_instance.jdf();
  kinText_0(_this__u8e3s4, modeLabel, tmp_8, theme.cdf_1, GameScene$sceneMain$lambda_1);
  var menuBtnW = 64.0;
  position(kinButton(_this__u8e3s4, menuBtnW, '\u041C\u0415\u041D\u042E', VOID, true, VOID, true, VOID, theme, GameScene$sceneMain$lambda_2), w - menuBtnW - 24.0, 20.0);
  var tmp_9 = theme.idf_1 ? '\u263E' : '\u2600';
  position(kinButton(_this__u8e3s4, 44.0, tmp_9, VOID, true, VOID, true, VOID, theme, GameScene$sceneMain$lambda_3), w - menuBtnW - 24.0 - 44.0 - 8.0, 20.0);
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  position(this_2, w / 2.0, 84.0);
  var chipsContainer = this_2;
  position(kinAkaiItoH(_this__u8e3s4, 230.0, theme), w / 2.0 - 115.0, 100.0);
  var boardX = (w - 336.0) / 2.0;
  var boardY = 116.0;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  var tmp0_color = theme.gdf_1;
  var tmp1_colorSoft = theme.hdf_1;
  kinSeam(this_4, 4.0, 32.0, 48.0, 6.0, 1.2, 2.5, 67, VOID, 0.75, VOID, tmp0_color, tmp1_colorSoft);
  position(this_4, boardX - 18.0, boardY - 18.0);
  var boardView = KinBoardView.cdp(game, theme, GameScene$sceneMain$lambda_4);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  position(boardView, boardX, boardY);
  _this__u8e3s4.waq(boardView);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  var tmp0_color_0 = theme.gdf_1;
  var tmp1_colorSoft_0 = theme.hdf_1;
  kinSeam(this_6, 4.0, 42.0, 44.0, 8.0, 1.0, 2.0, 71, VOID, 0.6, VOID, tmp0_color_0, tmp1_colorSoft_0);
  position(this_6, boardX + 336.0 - 28.0, boardY + 336.0 - 28.0);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  // Inline function 'kotlin.text.forEachIndexed' call
  var index = 0;
  var indexedObject = '\u601D\u8003\u4E2D';
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var item = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'scenes.GameScene.sceneMain.<anonymous>.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp_10 = toString_1(item);
    var tmp_11 = Fonts_instance.zdf();
    kinText(this_8, tmp_10, 9.0, theme.cdf_1, tmp_11, GameScene$sceneMain$lambda_5(tmp1));
  }
  this_8.kas(0.45);
  this_8.z8w(false);
  var thinkingLabel = position(this_8, boardX + 336.0 - 8.0, boardY + 8.0);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  var petalLayer = addTo(this_9, _this__u8e3s4);
  launch($this, VOID, VOID, GameScene$sceneMain$slambda_2(game, $this, petalLayer, boardX, boardY));
  var bottomY = h - 78.0;
  // Inline function 'kotlin.apply' call
  var this_10 = kinText_0(_this__u8e3s4, '\u0425\u041E\u0414 ' + game.fd9(), Type_instance.jdf(), theme.cdf_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  this_10.fc7(Companion_getInstance_6().e4u_1);
  position(this_10, 24.0, bottomY);
  var moveCountText = this_10;
  var tmp_12 = Type_instance.jdf();
  kinText_0(_this__u8e3s4, '15 \xD7 15', tmp_12, theme.cdf_1, GameScene$sceneMain$lambda_6(w, bottomY));
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  var controlsContainer = addTo(this_11, _this__u8e3s4);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_12 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_13 = addTo(this_12, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.sceneMain.<anonymous>' call
  var hintContainer = position(this_13, w / 2.0, boardY + 336.0 + 34.0);
  var btnY = h - 50.0;
  var aiThinking = {_v: false};
  var pendingMove = {_v: null};
  var renderUi = {_v: GameScene$sceneMain$lambda_7};
  var renderControlsRef = {_v: GameScene$sceneMain$lambda_8};
  var undoAndRefresh = {_v: GameScene$sceneMain$lambda_9};
  var newGame = {_v: GameScene$sceneMain$lambda_10};
  var applyMoveRef = {_v: GameScene$sceneMain$lambda_11};
  renderControlsRef._v = GameScene$sceneMain$lambda_12($this, controlsContainer, theme, btnY, game, aiThinking, pendingMove, undoAndRefresh, newGame, boardView, renderControlsRef, applyMoveRef, mode);
  renderUi._v = GameScene$sceneMain$lambda_13(pendingMove, boardView, $this, chipsContainer, theme, aiThinking, thinkingLabel, moveCountText, game, hintContainer, renderControlsRef, mode);
  applyMoveRef._v = GameScene$sceneMain$lambda_14(game, $this, renderUi, boardView, boardX, hintContainer, theme, mode);
  undoAndRefresh._v = GameScene$sceneMain$lambda_15(game, mode, $this, renderUi);
  newGame._v = GameScene$sceneMain$lambda_16(mode);
  var tmp_13 = boardView;
  tmp_13.rdo_1 = GameScene$sceneMain$lambda_17(pendingMove, game, boardView, $this, renderControlsRef, boardX, applyMoveRef, mode, aiThinking);
  var tmp_14 = $this;
  tmp_14.kdl_1 = GameScene$sceneMain$slambda_3(mode, game, $this, aiThinking, renderUi, applyMoveRef, ai);
  renderUi._v();
  if (mode.equals(GameMode_AI_getInstance()) && game.dd8_1.equals(_get_aiColor__1p1cgm($this)) && game.ed8_1.equals(GameState_PLAYING_getInstance())) {
    launch($this, VOID, VOID, GameScene$sceneMain$slambda_4($this));
  }
  return Unit_instance;
}
function _get_vibration__7fofzz($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.ldl_1;
  vibration$factory();
  return this_0.u1();
}
function playStoneSound($this) {
  if (!SettingsStore_getInstance().ddc_1.tdb_1)
    return Unit_instance;
  var tmp0_safe_receiver = $this.mdl_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.GameScene.playStoneSound.<anonymous>' call
    launch($this, VOID, VOID, GameScene$playStoneSound$slambda_0(tmp0_safe_receiver));
  }
}
function triggerHaptic($this, strong) {
  if (!SettingsStore_getInstance().ddc_1.tdb_1)
    return Unit_instance;
  try {
    var tmp = _get_vibration__7fofzz($this);
    var tmp_0;
    if (strong) {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_0 = toDuration(60, DurationUnit_MILLISECONDS_getInstance());
    } else {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_0 = toDuration(20, DurationUnit_MILLISECONDS_getInstance());
    }
    tmp.j9h(tmp_0, strong ? 0.9 : 0.5);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
}
function triggerHaptic$default($this, strong, $super) {
  strong = strong === VOID ? false : strong;
  return triggerHaptic($this, strong);
}
function spawnPetal($this, host, boardX, boardY) {
  var x0 = boardX + 20.0 + Default_getInstance().hp() * (336.0 - 40.0);
  var y0 = boardY - 6.0;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.image' call
  var texture = Companion_getInstance_23().edp();
  var anchor_0 = Companion_getInstance_4().i2c_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.cbx(texture, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, host);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.image.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.spawnPetal.<anonymous>' call
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_1, Anchor2D.v2c(numberToDouble(0.5), numberToDouble(0.5)));
  this_1.zar(0.82);
  position(this_1, x0, y0);
  this_1.kas(0.0);
  var img = this_1;
  var t = {_v: 0.0};
  var upd = {_v: null};
  upd._v = addUpdater(img, GameScene$spawnPetal$lambda(t, img, upd, y0, x0));
}
function shake($this, view, baseX) {
  var t = {_v: 0.0};
  var upd = {_v: null};
  upd._v = addUpdater(view, GameScene$shake$lambda(t, view, baseX, upd));
}
function renderChips($this, host, theme, aiThinking) {
  host.vaq();
  var game = GameSession_getInstance().bde_1;
  var mode = GameSession_getInstance().cde_1;
  var gameOver = !game.ed8_1.equals(GameState_PLAYING_getInstance());
  var subB;
  var subW;
  if (mode.equals(GameMode_AI_getInstance())) {
    subB = _get_humanColor__rhjpjp($this).equals(StoneColor_BLACK_getInstance()) ? '\u0412\u042B' : 'AI';
    subW = _get_humanColor__rhjpjp($this).equals(StoneColor_WHITE_getInstance()) ? '\u0412\u042B' : 'AI';
  } else {
    subB = '\u0418\u0413\u0420\u041E\u041A 1';
    subW = '\u0418\u0413\u0420\u041E\u041A 2';
  }
  var tmp = Type_instance.wdf().fdm_1;
  var tmp_0 = Fonts_instance.fdp();
  var vs = kinText(host, 'vs', tmp, theme.cdf_1, tmp_0, GameScene$renderChips$lambda);
  renderChips$chip(gameOver, game, host, theme, mode, $this, aiThinking, StoneColor_BLACK_getInstance(), '\u0427\u0451\u0440\u043D\u044B\u0435', subB, true);
  renderChips$chip(gameOver, game, host, theme, mode, $this, aiThinking, StoneColor_WHITE_getInstance(), '\u0411\u0435\u043B\u044B\u0435', subW, false);
  position(vs, 0.0, 10.0);
}
function renderHintButton($this, host, theme, boardView, canHint) {
  host.vaq();
  if (!SettingsStore_getInstance().ddc_1.sdb_1 || GameSession_getInstance().ede_1 <= 0 || !canHint)
    return Unit_instance;
  // Inline function 'kotlin.apply' call
  var tmp = '\u041F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0430 \xB7 ' + GameSession_getInstance().ede_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.renderHintButton.<anonymous>' call
  kinTextButton(host, tmp, theme.gdf_1, GameScene$renderHintButton$lambda(boardView, $this, host, theme)).fc7(Companion_getInstance_6().f4u_1);
}
function showForbiddenReason($this, host, theme, violation) {
  host.vaq();
  var tmp;
  switch (violation.t3_1) {
    case 0:
      tmp = '\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E: \u0440\u044F\u0434 \u0434\u043B\u0438\u043D\u043D\u0435\u0435 \u043F\u044F\u0442\u0438';
      break;
    case 1:
      tmp = '\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E: \u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0447\u0435\u0442\u0432\u0451\u0440\u043A\u0430';
      break;
    case 2:
      tmp = '\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E: \u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0442\u0440\u043E\u0439\u043A\u0430';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var label = tmp;
  var tmp_0 = Type_instance.gdp().fdm_1;
  var tmp_1 = Fonts_instance.adg();
  var txt = kinText(host, label, tmp_0, theme.fdf_1, tmp_1, GameScene$showForbiddenReason$lambda);
  var t = {_v: 0.0};
  var upd = {_v: null};
  upd._v = addUpdater(txt, GameScene$showForbiddenReason$lambda_0(t, txt, upd));
}
var Companion_instance_15;
function Companion_getInstance_23() {
  if (Companion_instance_15 === VOID)
    new Companion_11();
  return Companion_instance_15;
}
function renderControls($this, host, theme, btnY, game, busy, pending, onUndo, onNew, onCancel, onConfirm) {
  host.vaq();
  var w = 360;
  if (!(pending == null)) {
    var r = pending.ul();
    var c = pending.vl();
    var coord = toString_1(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), c)) + (15 - r | 0);
    var tmp = Fonts_instance.kdf();
    kinText(host, coord, 24.0, theme.adf_1, tmp, GameScene$renderControls$lambda(btnY));
    var tmp_0 = capsTracked('\u0425\u041E\u0414 ' + (game.fd9() + 1 | 0), 0);
    var tmp_1 = Fonts_instance.adg();
    kinText(host, tmp_0, 10.0, theme.cdf_1, tmp_1, GameScene$renderControls$lambda_0(btnY));
    position(kinButton(host, 44.0, '\xD7', VOID, true, VOID, true, VOID, theme, onCancel), 84.0, btnY);
    position(kinButton(host, w - 140.0 - 24.0, '\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043C\u0435\u043D\u044C', true, true, VOID, true, VOID, theme, onConfirm), 140.0, btnY);
    return Unit_instance;
  }
  var btnW = (w - 24.0 * 2.0 - 10.0) / 2.0;
  var tmp0_label = '\u2190 \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C';
  var tmp1_enabled = game.fd9() > 0 && !busy;
  position(kinButton(host, btnW, tmp0_label, VOID, true, VOID, true, tmp1_enabled, theme, onUndo), 24.0, btnY);
  position(kinButton(host, btnW, '\u041D\u043E\u0432\u0430\u044F \u043F\u0430\u0440\u0442\u0438\u044F', true, true, VOID, true, VOID, theme, onNew), 24.0 + btnW + 10.0, btnY);
}
function sceneMain$isHumanTurn(game, mode, this$0, aiThinking) {
  return game.ed8_1.equals(GameState_PLAYING_getInstance()) && (mode.equals(GameMode_PVP_getInstance()) || game.dd8_1.equals(_get_humanColor__rhjpjp(this$0))) && !aiThinking._v;
}
function renderChips$chip(gameOver, game, $host, $theme, mode, this$0, $aiThinking, color, label, sub, alignRight) {
  var active = !gameOver && game.dd8_1.equals(color);
  var won = equals(game.fd8_1, color);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.GameScene.renderChips.chip.<anonymous>' call
  var c = addTo(this_0, $host);
  var isBlack = color.equals(StoneColor_BLACK_getInstance());
  var stoneD = 14.0;
  position(kinStone(c, isBlack, stoneD / 2.0, VOID, VOID, $theme), stoneD / 2.0, 10.0);
  var tmp = Fonts_instance.udk();
  var labelText = kinText(c, label, 13.0, $theme.adf_1, tmp, GameScene$renderChips$chip$lambda(stoneD));
  var rowW = {_v: stoneD + 8.0 + labelText.mbi()};
  if (won) {
    var tmp_0 = Fonts_instance.udk();
    kinText(c, '\u2605', 13.0, $theme.gdf_1, tmp_0, GameScene$renderChips$chip$lambda_0(rowW));
    rowW._v = rowW._v + (5.0 + 14.0);
  }
  var tmp_1 = capsTracked(sub, 1);
  var tmp_2 = Fonts_instance.adg();
  var subText = kinText(c, tmp_1, 10.0, $theme.cdf_1, tmp_2, GameScene$renderChips$chip$lambda_1(stoneD));
  var isAiChip = mode.equals(GameMode_AI_getInstance()) && !color.equals(_get_humanColor__rhjpjp(this$0));
  if (isAiChip && $aiThinking) {
    var dotsX = stoneD + 8.0 + subText.mbi() + 6.0;
    var inductionVariable = 0;
    if (inductionVariable <= 2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.circle' call
        var fill = new RGBA($theme.adf_1);
        var stroke = new RGBA(Colors_getInstance().y44_1);
        var renderer = GraphicsRenderer_GPU_getInstance();
        // Inline function 'korlibs.korge.view.addTo' call
        var this_1 = Circle.hbd(numberToDouble(1.5), fill, stroke, numberToDouble(0.0), true, renderer);
        // Inline function 'kotlin.apply' call
        var this_2 = addTo(this_1, c);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'scenes.GameScene.renderChips.chip.<anonymous>' call
        position(this_2, dotsX + i * 6.0, 18.0);
        var dot = this_2;
        var t = {_v: i * -0.2};
        addUpdater(dot, GameScene$renderChips$chip$lambda_2(t, dot));
      }
       while (inductionVariable <= 2);
  }
  c.kas(active || won ? 1.0 : 0.45);
  position(c, alignRight ? -20.0 - rowW._v : 20.0, 0.0);
}
function GameScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function GameScene$sceneMain$lambda_0($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().s4t_1);
  position($this$kinText, 24.0, 20.0);
  return Unit_instance;
}
function GameScene$sceneMain$lambda_1($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().s4t_1);
  position($this$kinText, 24.0, 50.0);
  return Unit_instance;
}
function GameScene$sceneMain$lambda_2() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function GameScene$sceneMain$lambda_3() {
  Theme_instance.hdp();
  Nav_getInstance().jde();
  return Unit_instance;
}
function GameScene$sceneMain$lambda_4(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return Unit_instance;
}
function GameScene$sceneMain$lambda_5($i) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, 0.0, $i * 15.0);
    return Unit_instance;
  };
}
function GameScene$sceneMain$slambda_2($game, this$0, $petalLayer, $boardX, $boardY) {
  var i = new GameScene$sceneMain$slambda($game, this$0, $petalLayer, $boardX, $boardY);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda_6($w, $bottomY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().g4u_1);
    position($this$kinText, $w - 24.0, $bottomY);
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_7() {
  return Unit_instance;
}
function GameScene$sceneMain$lambda_8() {
  return Unit_instance;
}
function GameScene$sceneMain$lambda_9() {
  return Unit_instance;
}
function GameScene$sceneMain$lambda_10() {
  return Unit_instance;
}
function GameScene$sceneMain$lambda_11(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return false;
}
function GameScene$sceneMain$lambda$lambda($undoAndRefresh) {
  return function () {
    $undoAndRefresh._v();
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$lambda_0($newGame) {
  return function () {
    $newGame._v();
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$lambda_1($pendingMove, $boardView, $renderControlsRef) {
  return function () {
    $pendingMove._v = null;
    $boardView.idp();
    $renderControlsRef._v();
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$lambda$slambda_0(this$0) {
  var i = new GameScene$sceneMain$lambda$lambda$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda$lambda_2($pendingMove, $boardView, $applyMoveRef, $mode, $game, this$0) {
  return function () {
    var p = $pendingMove._v;
    var tmp;
    if (!(p == null)) {
      $pendingMove._v = null;
      $boardView.idp();
      var tmp_0;
      if ($applyMoveRef._v(p.sl_1, p.tl_1) && $mode.equals(GameMode_AI_getInstance()) && $game.ed8_1.equals(GameState_PLAYING_getInstance())) {
        launch(this$0, VOID, VOID, GameScene$sceneMain$lambda$lambda$slambda_0(this$0));
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_12(this$0, $controlsContainer, $theme, $btnY, $game, $aiThinking, $pendingMove, $undoAndRefresh, $newGame, $boardView, $renderControlsRef, $applyMoveRef, $mode) {
  return function () {
    var tmp = $aiThinking._v;
    var tmp_0 = $pendingMove._v;
    var tmp_1 = GameScene$sceneMain$lambda$lambda($undoAndRefresh);
    var tmp_2 = GameScene$sceneMain$lambda$lambda_0($newGame);
    var tmp_3 = GameScene$sceneMain$lambda$lambda_1($pendingMove, $boardView, $renderControlsRef);
    renderControls(this$0, $controlsContainer, $theme, $btnY, $game, tmp, tmp_0, tmp_1, tmp_2, tmp_3, GameScene$sceneMain$lambda$lambda_2($pendingMove, $boardView, $applyMoveRef, $mode, $game, this$0));
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_13($pendingMove, $boardView, this$0, $chipsContainer, $theme, $aiThinking, $thinkingLabel, $moveCountText, $game, $hintContainer, $renderControlsRef, $mode) {
  return function () {
    $pendingMove._v = null;
    $boardView.jdp();
    renderChips(this$0, $chipsContainer, $theme, $aiThinking._v);
    $thinkingLabel.z8w($aiThinking._v);
    $moveCountText.ac7('\u0425\u041E\u0414 ' + $game.fd9());
    renderHintButton(this$0, $hintContainer, $theme, $boardView, sceneMain$isHumanTurn($game, $mode, this$0, $aiThinking));
    $renderControlsRef._v();
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$slambda_1($game, $mode, $res, this$0) {
  var i = new GameScene$sceneMain$lambda$slambda($game, $mode, $res, this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda_14($game, this$0, $renderUi, $boardView, $boardX, $hintContainer, $theme, $mode) {
  return function (r, c) {
    var res = $game.nd8(r, c);
    var tmp;
    if (res instanceof Success) {
      triggerHaptic(this$0, !(res.kd9_1 == null));
      playStoneSound(this$0);
      $renderUi._v();
      if (!res.jd9_1.equals(GameState_PLAYING_getInstance())) {
        GameSession_getInstance().ldp();
        launch(this$0, VOID, VOID, GameScene$sceneMain$lambda$slambda_1($game, $mode, res, this$0));
      }
      tmp = true;
    } else {
      if (res instanceof Forbidden) {
        $boardView.kdp(r, c);
        shake(this$0, $boardView, $boardX);
        triggerHaptic$default(this$0);
        showForbiddenReason(this$0, $hintContainer, $theme, res.pd9_1);
        tmp = false;
      } else {
        if (res instanceof InvalidMove) {
          shake(this$0, $boardView, $boardX);
          tmp = false;
        } else {
          tmp = false;
        }
      }
    }
    return tmp;
  };
}
function GameScene$sceneMain$lambda_15($game, $mode, this$0, $renderUi) {
  return function () {
    var tmp;
    if ($game.fd9() > 0) {
      GameSession_getInstance().fde_1 = true;
      if (!$game.ed8_1.equals(GameState_PLAYING_getInstance())) {
        GameSession_getInstance().mdp();
      }
      $game.xd8();
      if ($mode.equals(GameMode_AI_getInstance()) && $game.fd9() > 0 && !$game.dd8_1.equals(_get_humanColor__rhjpjp(this$0))) {
        $game.xd8();
      }
      tmp = $renderUi._v();
    }
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_16($mode) {
  return function () {
    GameSession_getInstance().ide($mode);
    Nav_getInstance().jde();
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$slambda_2(this$0) {
  var i = new GameScene$sceneMain$lambda$slambda_0(this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda_17($pendingMove, $game, $boardView, this$0, $renderControlsRef, $boardX, $applyMoveRef, $mode, $aiThinking) {
  return function (r, c) {
    var tmp;
    if (!sceneMain$isHumanTurn($game, $mode, this$0, $aiThinking)) {
      return Unit_instance;
    }
    var tmp_0;
    if (SettingsStore_getInstance().ddc_1.vdb_1) {
      if (!equals($pendingMove._v, to(r, c))) {
        if ($game.ed9().od8(r, c)) {
          $pendingMove._v = to(r, c);
          $boardView.ndp(r, c, $game.dd8_1.equals(StoneColor_BLACK_getInstance()));
          triggerHaptic$default(this$0);
          $renderControlsRef._v();
        } else {
          shake(this$0, $boardView, $boardX);
        }
        return Unit_instance;
      }
      $pendingMove._v = null;
      $boardView.idp();
      tmp_0 = Unit_instance;
    }
    var tmp_1;
    if (!$applyMoveRef._v(r, c)) {
      return Unit_instance;
    }
    var tmp_2;
    if ($mode.equals(GameMode_AI_getInstance()) && $game.ed8_1.equals(GameState_PLAYING_getInstance())) {
      launch(this$0, VOID, VOID, GameScene$sceneMain$lambda$slambda_2(this$0));
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  };
}
function GameScene$sceneMain$slambda_3($mode, $game, this$0, $aiThinking, $renderUi, $applyMoveRef, $ai) {
  var i = new GameScene$sceneMain$slambda_0($mode, $game, this$0, $aiThinking, $renderUi, $applyMoveRef, $ai);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function GameScene$sceneMain$slambda_4(this$0) {
  var i = new GameScene$sceneMain$slambda_1(this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$aiTurnRef$slambda_0() {
  var i = new GameScene$aiTurnRef$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function GameScene$vibration$delegate$lambda(this$0) {
  return function () {
    return new NativeVibration(this$0.s17());
  };
}
function GameScene$playStoneSound$slambda_0($it) {
  var i = new GameScene$playStoneSound$slambda($it);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$spawnPetal$lambda($t, $img, $upd, $y0, $x0) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 6500.0;
    var tmp;
    if ($t._v >= 1.0) {
      $img.hat();
      var tmp0_safe_receiver = $upd._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
      return Unit_instance;
    }
    $img.tar($y0 + $t._v * 340.0);
    // Inline function 'kotlin.math.sin' call
    var x = $t._v * 3.141592653589793 * 2.6;
    var tmp$ret$0 = Math.sin(x);
    $img.sar($x0 + tmp$ret$0 * 13.0);
    $img.fas(get_degrees($t._v * 240.0));
    $img.kas($t._v < 0.08 ? $t._v / 0.08 * 0.8 : $t._v > 0.85 ? (1.0 - $t._v) / 0.15 * 0.8 : 0.8);
    return Unit_instance;
  };
}
function GameScene$shake$lambda($t, $view, $baseX, $upd) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 320.0;
    if ($t._v >= 1.0) {
      $view.sar($baseX);
      var tmp0_safe_receiver = $upd._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
    } else {
      // Inline function 'kotlin.math.sin' call
      var x = $t._v * 3.141592653589793 * 4;
      var tmp$ret$0 = Math.sin(x);
      $view.sar($baseX + tmp$ret$0 * 3.0 * (1.0 - $t._v));
    }
    return Unit_instance;
  };
}
function GameScene$renderChips$lambda($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().f4u_1);
  position($this$kinText, 0.0, 10.0);
  return Unit_instance;
}
function GameScene$renderHintButton$lambda($boardView, this$0, $host, $theme) {
  return function () {
    var tmp;
    if (GameSession_getInstance().ede_1 <= 0) {
      return Unit_instance;
    }
    var _unary__edvuaz = GameSession_getInstance().ede_1;
    GameSession_getInstance().ede_1 = _unary__edvuaz - 1 | 0;
    // Inline function 'kotlin.collections.map' call
    var this_0 = topMoves(GameSession_getInstance().bde_1, 3);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'scenes.GameScene.renderHintButton.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.rdc_1;
      destination.h(tmp$ret$0);
    }
    $boardView.odp(destination);
    renderHintButton(this$0, $host, $theme, $boardView, true);
    return Unit_instance;
  };
}
function GameScene$showForbiddenReason$lambda($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().f4u_1);
  return Unit_instance;
}
function GameScene$showForbiddenReason$lambda_0($t, $txt, $upd) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 1600.0;
    var tmp;
    if ($t._v >= 1.0) {
      $txt.hat();
      var tmp0_safe_receiver = $upd._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
      tmp = Unit_instance;
    } else if ($t._v > 0.7) {
      $txt.kas(1.0 - ($t._v - 0.7) / 0.3);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function GameScene$renderControls$lambda($btnY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $btnY - 4.0);
    return Unit_instance;
  };
}
function GameScene$renderControls$lambda_0($btnY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $btnY + 26.0);
    return Unit_instance;
  };
}
function GameScene$renderChips$chip$lambda($stoneD) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().e4u_1);
    position($this$kinText, $stoneD + 8.0, 4.0);
    return Unit_instance;
  };
}
function GameScene$renderChips$chip$lambda_0($rowW) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().e4u_1);
    position($this$kinText, $rowW._v + 5.0, 4.0);
    return Unit_instance;
  };
}
function GameScene$renderChips$chip$lambda_1($stoneD) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().e4u_1);
    position($this$kinText, $stoneD + 8.0, 19.0);
    return Unit_instance;
  };
}
function GameScene$renderChips$chip$lambda_2($t, $dot) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 1300.0;
    var phase = ($t._v % 1.0 + 1.0) % 1.0;
    var tmp;
    if (phase < 0.3) {
      // Inline function 'kotlin.math.sin' call
      var x = phase / 0.3 * 3.141592653589793;
      tmp = Math.sin(x);
    } else {
      tmp = 0.0;
    }
    $dot.kas(0.15 + 0.7 * tmp);
    return Unit_instance;
  };
}
function vibration$factory() {
  return getPropertyCallableRef('vibration', 1, KProperty1, function (receiver) {
    return _get_vibration__7fofzz(receiver);
  }, null);
}
function petalBitmap$factory() {
  return getPropertyCallableRef('petalBitmap', 1, KProperty1, function (receiver) {
    return receiver.edp();
  }, null);
}
function renderEntry($this, host, y, entry, theme) {
  var tmp = Type_instance.pdp();
  kinText_0(host, entry.qdp_1, tmp, theme.gdf_1, HelpScene$renderEntry$lambda(y));
  var tmp_0 = Fonts_instance.udk();
  kinText(host, entry.rdp_1, 16.0, theme.adf_1, tmp_0, HelpScene$renderEntry$lambda_0(y));
  var maxW = 360 - 72.0 - 24.0;
  var lines = wrap(entry.sdp_1, maxW, Fonts_instance.tdp(), 14.0);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = lines.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'scenes.HelpScene.renderEntry.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i = checkIndexOverflow(tmp1);
    var tmp_1 = Fonts_instance.tdp();
    kinText(host, item, 14.0, theme.bdf_1, tmp_1, HelpScene$renderEntry$lambda_1(y, i));
  }
}
function entryHeight($this, entry, theme) {
  var maxW = 360 - 72.0 - 24.0;
  var lines = wrap(entry.sdp_1, maxW, Fonts_instance.tdp(), 14.0);
  return 26.0 + lines.e1() * 22.0;
}
function HelpScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function HelpScene$sceneMain$lambda_0() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function HelpScene$sceneMain$lambda_1($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function HelpScene$sceneMain$lambda_2($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function HelpScene$sceneMain$lambda_3($baseY, $content, $minY) {
  return function ($this$onMouseDrag, info) {
    var tmp;
    if (info.la6_1) {
      $baseY._v = $content.p6p();
      tmp = Unit_instance;
    }
    $content.tar(coerceIn($baseY._v + info.ka6_1, $minY, 0.0));
    return Unit_instance;
  };
}
function HelpScene$renderEntry$lambda($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y - 2.0);
    return Unit_instance;
  };
}
function HelpScene$renderEntry$lambda_0($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 72.0, $y);
    return Unit_instance;
  };
}
function HelpScene$renderEntry$lambda_1($y, $i) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 72.0, $y + 26.0 + $i * 22.0);
    return Unit_instance;
  };
}
function wrap(text, maxPx, font, size) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var out = ArrayList.i1();
  var line = StringBuilder.f();
  var _iterator__ex2g4s = split(text, [' ']).a1();
  while (_iterator__ex2g4s.b1()) {
    var word = _iterator__ex2g4s.c1();
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = line;
    if (charSequenceLength(this_0) === 0) {
      tmp = word;
    } else {
      tmp = line.toString() + ' ' + word;
    }
    var candidate = tmp;
    var tmp_0;
    if (wrap$width(font, size, candidate) > maxPx) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_1 = line;
      tmp_0 = charSequenceLength(this_1) > 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element = line.toString();
      out.h(element);
      line = StringBuilder.ch(word);
    } else {
      line = StringBuilder.ch(candidate);
    }
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_2 = line;
  if (charSequenceLength(this_2) > 0) {
    // Inline function 'kotlin.collections.plusAssign' call
    var element_0 = line.toString();
    out.h(element_0);
  }
  return out;
}
function wrap$width($font, $size, s) {
  return getTextBounds($font, $size, s).p4u_1.t2d_1;
}
var DotKind_WIN_instance;
var DotKind_LOSS_instance;
var DotKind_UNFINISHED_instance;
var DotKind_NEUTRAL_instance;
var DotKind_entriesInitialized;
function DotKind_initEntries() {
  if (DotKind_entriesInitialized)
    return Unit_instance;
  DotKind_entriesInitialized = true;
  DotKind_WIN_instance = new DotKind('WIN', 0);
  DotKind_LOSS_instance = new DotKind('LOSS', 1);
  DotKind_UNFINISHED_instance = new DotKind('UNFINISHED', 2);
  DotKind_NEUTRAL_instance = new DotKind('NEUTRAL', 3);
}
function dotKind($this, rec) {
  var tmp;
  if (rec.cda_1.equals(GameState_DRAW_getInstance())) {
    tmp = DotKind_NEUTRAL_getInstance();
  } else if (rec.ada_1 === 'ai' && !(rec.dda_1 == null)) {
    var humanWon = rec.cda_1.equals(GameState_BLACK_WINS_getInstance()) && equals(rec.dda_1, StoneColor_BLACK_getInstance()) || (rec.cda_1.equals(GameState_WHITE_WINS_getInstance()) && equals(rec.dda_1, StoneColor_WHITE_getInstance()));
    tmp = humanWon ? DotKind_WIN_getInstance() : DotKind_LOSS_getInstance();
  } else {
    tmp = DotKind_WIN_getInstance();
  }
  return tmp;
}
function resultLabel($this, rec) {
  var base;
  switch (rec.cda_1.t3_1) {
    case 1:
      base = '\u041F\u043E\u0431\u0435\u0434\u0430 \u0447\u0451\u0440\u043D\u044B\u0445';
      break;
    case 2:
      base = '\u041F\u043E\u0431\u0435\u0434\u0430 \u0431\u0435\u043B\u044B\u0445';
      break;
    default:
      base = '\u041D\u0438\u0447\u044C\u044F';
      break;
  }
  var n = rec.eda_1.e1();
  return base + ' \xB7 ' + n + ' ' + Str_getInstance().fdq(n);
}
function modeLine($this, mode, difficulty) {
  var tmp;
  if (mode === 'ai') {
    var tmp1_safe_receiver = difficulty == null ? null : get_label(difficulty);
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = tmp1_safe_receiver.toLowerCase();
    }
    var tmp2_elvis_lhs = tmp_0;
    tmp = 'vs AI \xB7 ' + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
  } else {
    tmp = 'vs \u0418\u0433\u0440\u043E\u043A';
  }
  return tmp;
}
function dateLabel($this, endedAt) {
  var dt = get_local(Companion_getInstance_0().h1y(endedAt));
  var now = get_local(Companion_getInstance_0().i1y());
  var tmp = Companion_getInstance_0().i1y();
  // Inline function 'korlibs.time.days' call
  // Inline function 'korlibs.time.days' call
  var tmp$ret$1 = toDuration(1, DurationUnit_DAYS_getInstance());
  var yesterday = get_local(DateTime__minus_impl_10njw8(tmp, tmp$ret$1));
  var tmp_0;
  if (dateLabel$sameDay(dt, now)) {
    var mm = padStart(dt.f6j().toString(), 2, _Char___init__impl__6a9atx(48));
    tmp_0 = '\u0421\u0435\u0433\u043E\u0434\u043D\u044F \xB7 ' + dt.e6j() + ':' + mm;
  } else if (dateLabel$sameDay(dt, yesterday)) {
    tmp_0 = '\u0412\u0447\u0435\u0440\u0430';
  } else {
    tmp_0 = '' + dt.d6j() + ' ' + Str_getInstance().zdj_1.d1(dt.c6j() - 1 | 0);
  }
  return tmp_0;
}
function renderRow($this, host, y, w, theme, moves, winLine, dateLine, label, dot, continueBtn, divider, onTap) {
  var rowH = 82.0;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, host);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.JournalScene.renderRow.<anonymous>' call
  var row = position(this_1, 24.0, y);
  var rowW = w - 48.0;
  position(kinMiniBoard(row, moves, winLine, 56.0, theme), 0.0, (rowH - 56.0) / 2.0 - 4.0);
  var textX = 56.0 + 14.0;
  var tmp = Fonts_instance.tdp();
  kinText(row, dateLine, 11.0, theme.cdf_1, tmp, JournalScene$renderRow$lambda(textX));
  var dotR = 3.5;
  var dotY = 40.0;
  switch (dot.t3_1) {
    case 0:
      // Inline function 'korlibs.korge.view.circle' call

      var fill = new RGBA(theme.gdf_1);
      var stroke = new RGBA(Colors_getInstance().y44_1);
      var renderer = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call

      var this_2 = Circle.hbd(numberToDouble(dotR), fill, stroke, numberToDouble(0.0), true, renderer);
      // Inline function 'kotlin.apply' call

      var this_3 = addTo(this_2, row);
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'scenes.JournalScene.renderRow.<anonymous>' call

      position(this_3, textX, dotY);
      break;
    case 1:
      // Inline function 'korlibs.korge.view.circle' call

      var fill_0 = new RGBA(theme.fdf_1);
      var stroke_0 = new RGBA(Colors_getInstance().y44_1);
      var renderer_0 = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call

      var this_4 = Circle.hbd(numberToDouble(dotR), fill_0, stroke_0, numberToDouble(0.0), true, renderer_0);
      // Inline function 'kotlin.apply' call

      var this_5 = addTo(this_4, row);
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'scenes.JournalScene.renderRow.<anonymous>' call

      position(this_5, textX, dotY);
      break;
    default:
      // Inline function 'korlibs.korge.view.circle' call

      var fill_1 = new RGBA(Colors_getInstance().d45_1);
      var stroke_1 = new RGBA(theme.edf_1);
      var renderer_1 = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call

      var this_6 = Circle.hbd(numberToDouble(dotR), fill_1, stroke_1, numberToDouble(1.0), true, renderer_1);
      // Inline function 'kotlin.apply' call

      var this_7 = addTo(this_6, row);
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'scenes.JournalScene.renderRow.<anonymous>' call

      position(this_7, textX, dotY);
      break;
  }
  var tmp_0 = Fonts_instance.udk();
  kinText(row, label, 13.5, theme.adf_1, tmp_0, JournalScene$renderRow$lambda_0(textX, dotR, dotY));
  if (continueBtn) {
    var btnW = 96.0;
    var btnH = 32.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_8 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_9 = addTo(this_8, row);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.JournalScene.renderRow.<anonymous>' call
    var btn = position(this_9, rowW - btnW, (rowH - btnH) / 2.0 - 4.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.u2l(btnW, btnH);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var corner = 10.0 - 2.0;
    var radius = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var fill_2 = new RGBA(BtnSpec_getInstance().gdq(theme));
    var stroke_2 = new RGBA(Colors_getInstance().y44_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_10 = RoundRect.hc0(size, radius, fill_2, stroke_2, 0.0, true);
    // Inline function 'kotlin.apply' call
    addTo(this_10, btn);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    var tmp_1 = BtnSpec_getInstance().ydf_1;
    var tmp_2 = Fonts_instance.adg();
    kinText(btn, '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C', 12.0, tmp_1, tmp_2, JournalScene$renderRow$lambda_1(btnW, btnH));
  } else {
    var tmp_3 = Fonts_instance.tdp();
    kinText(row, '\u2192', 14.0, theme.cdf_1, tmp_3, JournalScene$renderRow$lambda_2(rowW, rowH));
  }
  // Inline function 'korlibs.korge.input.onClick' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var height = rowH - 8.0;
  var color = Colors_getInstance().d45_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = SolidRect.rc2(Size2D.u2l(rowW, height), color);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, row);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var handler = JournalScene$renderRow$lambda_3(onTap);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory();
  var tmp1_safe_receiver = this_12 == null ? null : this_12.far();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_4 = prop.get(tmp1_safe_receiver_0);
        tmp_4.p22(JournalScene$renderRow$lambda_4(handler));
      }
    }
  }
  if (divider) {
    // Inline function 'korlibs.korge.view.solidRect' call
    var color_0 = theme.ddf_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_13 = SolidRect.rc2(Size2D.u2l(rowW, 1.0), color_0);
    // Inline function 'kotlin.apply' call
    var this_14 = addTo(this_13, host);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.JournalScene.renderRow.<anonymous>' call
    position(this_14, 24.0, y + rowH - 4.0);
  }
  return y + rowH;
}
function dateLabel$sameDay(a, b) {
  return a.b6j() === b.b6j() && a.c6j() === b.c6j() && a.d6j() === b.d6j();
}
function JournalScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function JournalScene$sceneMain$lambda_0() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function JournalScene$sceneMain$lambda_1($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function JournalScene$sceneMain$lambda_2($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function JournalScene$sceneMain$lambda_3($w, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $w / 2.0, $y._v + 80.0);
    return Unit_instance;
  };
}
function JournalScene$sceneMain$lambda_4() {
  Nav_getInstance().jde();
  return Unit_instance;
}
function JournalScene$sceneMain$lambda$lambda() {
  Nav_getInstance().hdq();
  return Unit_instance;
}
function JournalScene$sceneMain$lambda_5($rec) {
  return function () {
    var tmp = Nav_getInstance();
    tmp.lde($rec, JournalScene$sceneMain$lambda$lambda);
    return Unit_instance;
  };
}
function JournalScene$sceneMain$lambda_6($w, $footerY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $w / 2.0, $footerY);
    return Unit_instance;
  };
}
function JournalScene$renderRow$lambda($textX) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $textX, 16.0);
    return Unit_instance;
  };
}
function JournalScene$renderRow$lambda_0($textX, $dotR, $dotY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().e4u_1);
    position($this$kinText, $textX + $dotR * 2 + 7.0, $dotY + $dotR);
    return Unit_instance;
  };
}
function JournalScene$renderRow$lambda_1($btnW, $btnH) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, $btnW / 2.0, $btnH / 2.0);
    return Unit_instance;
  };
}
function JournalScene$renderRow$lambda_2($rowW, $rowH) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().g4u_1);
    position($this$kinText, $rowW, $rowH / 2.0 - 4.0);
    return Unit_instance;
  };
}
function JournalScene$renderRow$lambda_3($onTap) {
  return function (it) {
    $onTap();
    return Unit_instance;
  };
}
function JournalScene$renderRow$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function DotKind_WIN_getInstance() {
  DotKind_initEntries();
  return DotKind_WIN_instance;
}
function DotKind_LOSS_getInstance() {
  DotKind_initEntries();
  return DotKind_LOSS_instance;
}
function DotKind_UNFINISHED_getInstance() {
  DotKind_initEntries();
  return DotKind_UNFINISHED_instance;
}
function DotKind_NEUTRAL_getInstance() {
  DotKind_initEntries();
  return DotKind_NEUTRAL_instance;
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function *_generator_invoke__zhh2q8_9($this, $this$launch, $completion) {
  try {
    var tmp = $this.udq_1.fa7().l9x_1.y8x(new TextClipboardData(notation($this.udq_1)), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.vdq_1.ac7('\u041D\u043E\u0442\u0430\u0446\u0438\u044F \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440');
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      $this.vdq_1.ac7('\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u043E\u0441\u044C \u2014 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437');
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $this$launch, $completion) {
  try {
    var tmp = renderToBitmap($this.wdq_1, $this.xdq_1.fa7(), VOID, VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var bmp = tmp;
    var home = Companion_instance_2.oi('HOME');
    var tmp_0;
    if (home == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.KifuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
      tmp_0 = localVfs(home + '/Downloads');
    }
    var downloads = tmp_0;
    var tmp_1;
    var tmp_2;
    if (!(downloads == null)) {
      var tmp_3 = downloads.u2b($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_2 = tmp_3;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = downloads;
    } else {
      tmp_1 = localVfs(StandardPaths_instance.n36('gomoku'));
    }
    var dir = tmp_1;
    var file = dir.oi('gomoku-kifu-' + $this.xdq_1.jdr_1.zd9_1.toString() + '.png');
    var tmp_4 = writeBitmap(file, bmp, PNG_getInstance(), VOID, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    $this.ydq_1.ac7('\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E: ' + file.g2a());
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      $this.ydq_1.ac7('\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u043E\u0441\u044C \u2014 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437');
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function notation($this) {
  var tmp;
  switch ($this.jdr_1.cda_1.t3_1) {
    case 1:
      tmp = '\u0427\u0451\u0440\u043D\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
      break;
    case 2:
      tmp = '\u0411\u0435\u043B\u044B\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u043B\u0438';
      break;
    case 3:
      tmp = '\u041D\u0438\u0447\u044C\u044F';
      break;
    case 0:
      tmp = '\u041F\u0430\u0440\u0442\u0438\u044F \u043D\u0435 \u043E\u043A\u043E\u043D\u0447\u0435\u043D\u0430';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var header = tmp;
  var moves = joinToString($this.jdr_1.eda_1, ' ', VOID, VOID, VOID, VOID, KifuScene$notation$lambda);
  return header + ' \xB7 ' + $this.jdr_1.eda_1.e1() + ' ' + Str_getInstance().fdq($this.jdr_1.eda_1.e1()) + '\n' + moves;
}
function renderKifuBoard($this, host, x, y, theme) {
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, host);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.KifuScene.renderKifuBoard.<anonymous>' call
  var board = position(this_1, x, y);
  var cell = 22.0;
  var pad = 14.0;
  var total = 336.0;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = theme.yde_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.rc2(Size2D.u2l(total, total), color);
  // Inline function 'kotlin.apply' call
  addTo(this_2, board);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var gridAlpha = theme.idf_1 ? 0.18 : 0.5;
  var gridColor = Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(theme.adf_1), _RGBA___get_g__impl__o8pukr(theme.adf_1), _RGBA___get_b__impl__m6tl80(theme.adf_1), numberToInt(255 * gridAlpha));
  var lineLen = cell * 14;
  var inductionVariable = 0;
  if (inductionVariable < 15)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.solidRect' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = SolidRect.rc2(Size2D.u2l(lineLen, 0.5), gridColor);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, board);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.KifuScene.renderKifuBoard.<anonymous>' call
      position(this_4, pad, renderKifuBoard$pos(pad, cell, i));
      // Inline function 'korlibs.korge.view.solidRect' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_5 = SolidRect.rc2(Size2D.u2l(0.5, lineLen), gridColor);
      // Inline function 'kotlin.apply' call
      var this_6 = addTo(this_5, board);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'scenes.KifuScene.renderKifuBoard.<anonymous>' call
      position(this_6, renderKifuBoard$pos(pad, cell, i), pad);
    }
     while (inductionVariable < 15);
  var _iterator__ex2g4s = BoardSpec_getInstance().qdr_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var r = _destruct__k2r9zo.ul();
    var c = _destruct__k2r9zo.vl();
    // Inline function 'korlibs.korge.view.circle' call
    var fill = new RGBA(Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(theme.adf_1), _RGBA___get_g__impl__o8pukr(theme.adf_1), _RGBA___get_b__impl__m6tl80(theme.adf_1), numberToInt(255 * (theme.idf_1 ? 0.4 : 0.8))));
    var stroke = new RGBA(Colors_getInstance().y44_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = Circle.hbd(numberToDouble(1.6), fill, stroke, numberToDouble(0.0), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, board);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.KifuScene.renderKifuBoard.<anonymous>' call
    position(this_8, renderKifuBoard$pos(pad, cell, c) - 1.6, renderKifuBoard$pos(pad, cell, r) - 1.6);
  }
  var blackFill = theme.idf_1 ? Colors_getInstance().s4k('#8f8578') : Colors_getInstance().s4k('#1a1814');
  var whiteFill = Colors_getInstance().s4k('#f8f4ea');
  var blackNum = theme.idf_1 ? Colors_getInstance().s4k('#14130f') : Colors_getInstance().s4k('#f5f0e6');
  var whiteNum = Colors_getInstance().s4k('#1a1814');
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = $this.jdr_1.fda_1;
  var win = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  var stoneR = 9.2;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = $this.jdr_1.eda_1.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'scenes.KifuScene.renderKifuBoard.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i_0 = checkIndexOverflow(tmp1);
    var isBlack = item.cd9_1.equals(StoneColor_BLACK_getInstance());
    var tmp$ret$18;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(win, Collection)) {
        tmp = win.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$18 = false;
        break $l$block_0;
      }
      var tmp0_iterator_0 = win.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'scenes.KifuScene.renderKifuBoard.<anonymous>.<anonymous>' call
        if (element.odc_1 === item.ad9_1 && element.pdc_1 === item.bd9_1) {
          tmp$ret$18 = true;
          break $l$block_0;
        }
      }
      tmp$ret$18 = false;
    }
    var isWin = tmp$ret$18;
    // Inline function 'korlibs.korge.view.circle' call
    var fill_0 = new RGBA(isBlack ? blackFill : whiteFill);
    var stroke_0 = new RGBA(isWin ? theme.gdf_1 : !isBlack ? rgba255(0, 0, 0, 0.25) : Colors_getInstance().d45_1);
    var strokeThickness = isWin ? 1.5 : !isBlack ? 0.5 : 0.0;
    var renderer_0 = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_9 = Circle.hbd(numberToDouble(stoneR), fill_0, stroke_0, numberToDouble(strokeThickness), true, renderer_0);
    // Inline function 'kotlin.apply' call
    var this_10 = addTo(this_9, board);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    position(this_10, renderKifuBoard$pos(pad, cell, item.bd9_1) - stoneR, renderKifuBoard$pos(pad, cell, item.ad9_1) - stoneR);
    var tmp_0 = '' + (i_0 + 1 | 0);
    var tmp_1 = isBlack ? blackNum : whiteNum;
    var tmp_2 = Fonts_instance.udk();
    kinText(board, tmp_0, 8.5, tmp_1, tmp_2, KifuScene$renderKifuBoard$lambda(item, pad, cell));
  }
  return board;
}
function renderKifuBoard$pos(pad, cell, i) {
  return pad + i * cell;
}
function KifuScene$sceneMain$lambda(this$0) {
  return function () {
    this$0.kdr_1();
    return Unit_instance;
  };
}
function KifuScene$sceneMain$lambda_0(this$0) {
  return function () {
    this$0.kdr_1();
    return Unit_instance;
  };
}
function KifuScene$sceneMain$lambda_1($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function KifuScene$sceneMain$lambda_2($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function KifuScene$sceneMain$lambda_3($w, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $w / 2.0, $y._v + 44.0 + 12.0);
    return Unit_instance;
  };
}
function KifuScene$sceneMain$lambda$slambda_1(this$0, $status) {
  var i = new KifuScene$sceneMain$lambda$slambda(this$0, $status);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function KifuScene$sceneMain$lambda_4(this$0, $status) {
  return function () {
    launch(this$0, VOID, VOID, KifuScene$sceneMain$lambda$slambda_1(this$0, $status));
    return Unit_instance;
  };
}
function KifuScene$sceneMain$lambda$slambda_2($board, this$0, $status) {
  var i = new KifuScene$sceneMain$lambda$slambda_0($board, this$0, $status);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function KifuScene$sceneMain$lambda_5(this$0, $board, $status) {
  return function () {
    launch(this$0, VOID, VOID, KifuScene$sceneMain$lambda$slambda_2($board, this$0, $status));
    return Unit_instance;
  };
}
function KifuScene$notation$lambda(it) {
  return '' + it.dd9_1 + '.' + it.cd9_1.kdd() + it.tdd();
}
function KifuScene$renderKifuBoard$lambda($m, $pad, $cell) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, renderKifuBoard$pos($pad, $cell, $m.bd9_1), renderKifuBoard$pos($pad, $cell, $m.ad9_1));
    return Unit_instance;
  };
}
function MenuScene$sceneMain$slambda_0(this$0) {
  var i = new MenuScene$sceneMain$slambda(this$0);
  var l = function (it, $completion) {
    return i.fa6(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function MenuScene$sceneMain$lambda() {
  Theme_instance.hdp();
  Nav_getInstance().zdd();
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_0($i) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, 0.0, $i * 17.0);
    return Unit_instance;
  };
}
function MenuScene$sceneMain$lambda_1($centerX, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $centerX, $y._v);
    return Unit_instance;
  };
}
function MenuScene$sceneMain$lambda_2($centerX, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $centerX, $y._v);
    return Unit_instance;
  };
}
function MenuScene$sceneMain$lambda_3($centerX, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $centerX, $y._v);
    return Unit_instance;
  };
}
function MenuScene$sceneMain$lambda_4() {
  Nav_getInstance().vdr(GameMode_AI_getInstance());
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_5() {
  Nav_getInstance().vdr(GameMode_PVP_getInstance());
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_6() {
  Nav_getInstance().hdq();
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_7() {
  Nav_getInstance().wdr();
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_8() {
  Nav_getInstance().xdr();
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_9() {
  Nav_getInstance().ydr();
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_10($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().s4t_1);
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_11($part1) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $part1.mbi(), 0.0);
    return Unit_instance;
  };
}
function MenuScene$sceneMain$lambda_12(it) {
  Nav_getInstance().zdr();
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_13($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function MenuScene$sceneMain$lambda_14($this$kinText) {
  $this$kinText.fc7(Companion_getInstance_6().f4u_1);
  position($this$kinText, 8.0, 8.5);
  return Unit_instance;
}
function MenuScene$sceneMain$lambda_15($centerX, $footerY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().e4u_1);
    position($this$kinText, $centerX - 72.0, $footerY);
    return Unit_instance;
  };
}
function click$factory_0() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function get_crossfade() {
  _init_properties_Nav_kt__dqb6kv();
  return crossfade;
}
var crossfade;
function onBackOrEscape(_this__u8e3s4, handler) {
  _init_properties_Nav_kt__dqb6kv();
  var tmp = get_keys(_this__u8e3s4);
  tmp.ha6(onBackOrEscape$slambda_0(handler));
}
var GameMode_PVP_instance;
var GameMode_AI_instance;
var GameMode_entriesInitialized;
function GameMode_initEntries() {
  if (GameMode_entriesInitialized)
    return Unit_instance;
  GameMode_entriesInitialized = true;
  GameMode_PVP_instance = new GameMode('PVP', 0);
  GameMode_AI_instance = new GameMode('AI', 1);
}
var GameSession_instance;
function GameSession_getInstance() {
  if (GameSession_instance === VOID)
    new GameSession();
  return GameSession_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(MenuScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goMenu.<anonymous>.<anonymous>' call
  var newScene = new MenuScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goMenu$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goMenu$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goMenu.<anonymous>.<anonymous>' call
    return new MenuScene();
  };
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  GameSession_getInstance().ide($this.nds_1);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goGame.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goGame$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goGame$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goGame.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goGameKeepState.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goGameKeepState$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goGameKeepState$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goGameKeepState.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(SettingsScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goSettings.<anonymous>.<anonymous>' call
  var newScene = new SettingsScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goSettings$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goSettings$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goSettings.<anonymous>.<anonymous>' call
    return new SettingsScene();
  };
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(HelpScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goHelp.<anonymous>.<anonymous>' call
  var newScene = new HelpScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goHelp$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goHelp$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goHelp.<anonymous>.<anonymous>' call
    return new HelpScene();
  };
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(JournalScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goJournal.<anonymous>.<anonymous>' call
  var newScene = new JournalScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goJournal$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goJournal$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goJournal.<anonymous>.<anonymous>' call
    return new JournalScene();
  };
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(SealsScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goSeals.<anonymous>.<anonymous>' call
  var newScene = new SealsScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goSeals$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goSeals$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goSeals.<anonymous>.<anonymous>' call
    return new SealsScene();
  };
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(TeaScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goTea.<anonymous>.<anonymous>' call
  var newScene = new TeaScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goTea$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goTea$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goTea.<anonymous>.<anonymous>' call
    return new TeaScene();
  };
}
function *_generator_invoke__zhh2q8_19($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(VictoryScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goVictory.<anonymous>.<anonymous>' call
  var newScene = new VictoryScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goVictory$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goVictory$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goVictory.<anonymous>.<anonymous>' call
    return new VictoryScene();
  };
}
function *_generator_invoke__zhh2q8_20($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(DefeatScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goDefeat.<anonymous>.<anonymous>' call
  var newScene = new DefeatScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goDefeat$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goDefeat$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goDefeat.<anonymous>.<anonymous>' call
    return new DefeatScene();
  };
}
function *_generator_invoke__zhh2q8_21($this, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = Nav_getInstance().mds();
  var injects = [];
  var time = Nav_getInstance().jdd_1;
  var transition = get_crossfade();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(KifuScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.ma4_1.h9x_1.c6i().a6i(getKClass(SceneContainer), this_0).a6i(getKClass(Resources), new Resources(this_0.s17(), this_0.ma4_1.oa5().z3b_1, this_0.ma4_1.oa5()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6i(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'scenes.Nav.goKifu.<anonymous>.<anonymous>' call
  var newScene = new KifuScene($this.ods_1, $this.pds_1);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_9().tah_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.q31(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$1 = 'Changing scene to... ' + toString_0(clazz) + ' ... ' + toString_0(newScene);
    this_1.r31(level, tmp$ret$1);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.l6i(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.ma4_1.h9x_1.e6i(tmp_2, Nav$goKifu$slambda$lambda(sceneInjector, $this.ods_1, $this.pds_1));
  }
  var tmp_3 = this_0.vah(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Nav$goKifu$slambda$lambda($sceneInjector, $record, $back) {
  return function ($this$mapPrototype) {
    // Inline function 'scenes.Nav.goKifu.<anonymous>.<anonymous>' call
    return new KifuScene($record, $back);
  };
}
function *_generator_invoke__zhh2q8_22($this, $completion) {
  var tmp = $this.qds_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function launch_0($this, block) {
  var tmp = $this.mds();
  launchImmediately_0(tmp, Nav$launch$slambda_0(block));
}
function Nav$goMenu$slambda_0() {
  var i = new Nav$goMenu$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goGame$slambda_0($mode) {
  var i = new Nav$goGame$slambda($mode);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goGameKeepState$slambda_0() {
  var i = new Nav$goGameKeepState$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goSettings$slambda_0() {
  var i = new Nav$goSettings$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goHelp$slambda_0() {
  var i = new Nav$goHelp$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goJournal$slambda_0() {
  var i = new Nav$goJournal$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goSeals$slambda_0() {
  var i = new Nav$goSeals$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goTea$slambda_0() {
  var i = new Nav$goTea$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goVictory$slambda_0() {
  var i = new Nav$goVictory$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goDefeat$slambda_0() {
  var i = new Nav$goDefeat$slambda();
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$goKifu$slambda_0($record, $back) {
  var i = new Nav$goKifu$slambda($record, $back);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Nav$launch$slambda_0($block) {
  var i = new Nav$launch$slambda($block);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
var Nav_instance;
function Nav_getInstance() {
  if (Nav_instance === VOID)
    new Nav();
  return Nav_instance;
}
function crossfade$lambda(_unused_var__etf5q3, prev, next, ratio) {
  _init_properties_Nav_kt__dqb6kv();
  var r = Ratio__toFloat_impl_1ftup5(ratio.f10_1);
  prev.las(1.0 - r);
  next.las(r);
  return Unit_instance;
}
function onBackOrEscape$slambda_0($handler) {
  var i = new onBackOrEscape$slambda($handler);
  var l = function (it, $completion) {
    return i.fa6(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameMode_PVP_getInstance() {
  GameMode_initEntries();
  return GameMode_PVP_instance;
}
function GameMode_AI_getInstance() {
  GameMode_initEntries();
  return GameMode_AI_instance;
}
var properties_initialized_Nav_kt_q81erx;
function _init_properties_Nav_kt__dqb6kv() {
  if (!properties_initialized_Nav_kt_q81erx) {
    properties_initialized_Nav_kt_q81erx = true;
    crossfade = Transition('crossfade', crossfade$lambda);
  }
}
function renderTile($this, host, x, y, size, key, bg, ink, theme) {
  // Inline function 'korlibs.korge.view.roundRect' call
  var size_0 = Size2D.u2l(size, size);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_2();
  var radius = new RectCorners(numberToDouble(6.0), numberToDouble(6.0), numberToDouble(6.0), numberToDouble(6.0));
  var fill = new RGBA(bg);
  var stroke = new RGBA(Colors_getInstance().y44_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = RoundRect.hc0(size_0, radius, fill, stroke, 0.0, true);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, host);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  position(this_1, x, y);
  var tmp = size * 0.48;
  var tmp_0 = ink ? Colors_getInstance().s4k('#14130f') : Colors_getInstance().s4k('#f7f1e4');
  var tmp_1 = Fonts_instance.zdf();
  kinText(host, key, tmp, tmp_0, tmp_1, SealsScene$renderTile$lambda(x, size, y));
}
function SealsScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function SealsScene$sceneMain$lambda_0() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function SealsScene$sceneMain$lambda_1($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_2($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_3($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0 + 80.0, $y._v + 16.0);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_4($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0 + 80.0, $y._v + 30.0);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_5($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0 + 80.0, $y._v + 48.0);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_6($tileSize) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, 0.0, $tileSize / 2.0);
    $this$kinText.kas(0.13);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_7($cx, $ty, $tileSize, $gotIt) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $ty + $tileSize + 8.0);
    var tmp;
    if (!$gotIt) {
      $this$kinText.kas(0.65);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_8($legendSize, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, 24.0 + $legendSize / 2.0, $y._v + $legendSize / 2.0 + 1.0);
    $this$kinText.kas(0.75);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_9($lx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $lx, $y._v + 2.0);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_10($lx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $lx, $y._v + 16.0);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_11($lx, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $lx, $y._v + 34.0);
    return Unit_instance;
  };
}
function SealsScene$sceneMain$lambda_12($w, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $w / 2.0, $y._v);
    return Unit_instance;
  };
}
function SealsScene$renderTile$lambda($x, $size, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, $x + $size / 2.0, $y + $size / 2.0 + 1.0);
    return Unit_instance;
  };
}
function renderToggleRow($this, host, w, y, label, initial, theme, last, onChange) {
  var tmp = Type_instance.ddt();
  kinText_0(host, label, tmp, theme.adf_1, SettingsScene$renderToggleRow$lambda(y));
  position(kinToggle(host, initial, theme, onChange), w - 24.0 - 44.0, y + 10.0);
  if (!last) {
    // Inline function 'korlibs.korge.view.solidRect' call
    var width = w - 48.0;
    var color = theme.ddf_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = SolidRect.rc2(Size2D.u2l(width, 1.0), color);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, host);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.SettingsScene.renderToggleRow.<anonymous>' call
    position(this_1, 24.0, y + 43.0);
  }
}
function renderToggleRow$default($this, host, w, y, label, initial, theme, last, onChange, $super) {
  last = last === VOID ? false : last;
  return renderToggleRow($this, host, w, y, label, initial, theme, last, onChange);
}
function SettingsScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda_0() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda_1($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function SettingsScene$sceneMain$lambda_2($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function SettingsScene$sceneMain$lambda_3(idx) {
  var wantsDark = idx === 1;
  if (!(Theme_instance.fdt() === wantsDark)) {
    Theme_instance.edt(wantsDark);
    Nav_getInstance().xdr();
  }
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda$lambda($rulesList, $idx) {
  return function (it) {
    return it.cdc(VOID, $rulesList.d1($idx));
  };
}
function SettingsScene$sceneMain$lambda_4($rulesList) {
  return function (idx) {
    var tmp = SettingsStore_getInstance();
    tmp.hdc(SettingsScene$sceneMain$lambda$lambda($rulesList, idx));
    return Unit_instance;
  };
}
function SettingsScene$sceneMain$lambda$lambda_0($diffs, $idx) {
  return function (it) {
    return it.cdc(VOID, VOID, $diffs.d1($idx));
  };
}
function SettingsScene$sceneMain$lambda_5($diffs) {
  return function (idx) {
    var tmp = SettingsStore_getInstance();
    tmp.hdc(SettingsScene$sceneMain$lambda$lambda_0($diffs, idx));
    return Unit_instance;
  };
}
function SettingsScene$sceneMain$lambda$lambda_1($colorPrefs, $idx) {
  return function (it) {
    return it.cdc(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $colorPrefs.d1($idx));
  };
}
function SettingsScene$sceneMain$lambda_6($colorPrefs) {
  return function (idx) {
    var tmp = SettingsStore_getInstance();
    tmp.hdc(SettingsScene$sceneMain$lambda$lambda_1($colorPrefs, idx));
    return Unit_instance;
  };
}
function SettingsScene$sceneMain$lambda_7(v) {
  var tmp = SettingsStore_getInstance();
  tmp.hdc(SettingsScene$sceneMain$lambda$lambda_2(v));
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda$lambda_2($v) {
  return function (it) {
    return it.cdc(VOID, VOID, VOID, $v);
  };
}
function SettingsScene$sceneMain$lambda_8(v) {
  var tmp = SettingsStore_getInstance();
  tmp.hdc(SettingsScene$sceneMain$lambda$lambda_3(v));
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda$lambda_3($v) {
  return function (it) {
    return it.cdc(VOID, VOID, VOID, VOID, VOID, VOID, $v);
  };
}
function SettingsScene$sceneMain$lambda_9(v) {
  var tmp = SettingsStore_getInstance();
  tmp.hdc(SettingsScene$sceneMain$lambda$lambda_4(v));
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda$lambda_4($v) {
  return function (it) {
    return it.cdc(VOID, VOID, VOID, VOID, $v);
  };
}
function SettingsScene$sceneMain$lambda_10(v) {
  var tmp = SettingsStore_getInstance();
  tmp.hdc(SettingsScene$sceneMain$lambda$lambda_5(v));
  MusicPlayer_instance.gdt();
  return Unit_instance;
}
function SettingsScene$sceneMain$lambda$lambda_5($v) {
  return function (it) {
    return it.cdc(VOID, VOID, VOID, VOID, VOID, $v);
  };
}
function SettingsScene$renderToggleRow$lambda($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().e4u_1);
    position($this$kinText, 24.0, $y + 22.0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_23($this, $this$launch, $completion) {
  var tmp = delay(new Long(1200, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  Nav_getInstance().zdd();
  return Unit_instance;
}
function SplashScene$sceneMain$lambda($t, $motif) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 2600.0;
    // Inline function 'kotlin.math.sin' call
    var x = $t._v * 2.0 * 3.141592653589793;
    var k = (Math.sin(x) + 1.0) / 2.0;
    scale($motif, 1.0 + 0.015 * k);
    $motif.kas(0.94 + 0.06 * k);
    return Unit_instance;
  };
}
function SplashScene$sceneMain$lambda_0($cx, $h) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $h * 0.4 + 44.0 + 26.0);
    return Unit_instance;
  };
}
function SplashScene$sceneMain$lambda_1($cx, $h) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $h * 0.4 + 44.0 + 76.0);
    return Unit_instance;
  };
}
function SplashScene$sceneMain$lambda_2($cx, $h) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $cx, $h - 36.0);
    $this$kinText.kas(0.7);
    return Unit_instance;
  };
}
function SplashScene$sceneMain$slambda_0() {
  var i = new SplashScene$sceneMain$slambda();
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function renderRow_0($this, host, y, w, theme, item, divider, onBuy) {
  var rowH = 66.0;
  var soon = item.cdu_1.equals(TeaTone_SOON_getInstance());
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, host);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'scenes.TeaScene.renderRow.<anonymous>' call
  var row = position(this_1, 24.0, y);
  var rowW = w - 48.0;
  if (soon) {
    row.kas(0.6);
  }
  var tile = 42.0;
  var tmp;
  switch (item.cdu_1.t3_1) {
    case 0:
      tmp = theme.fdf_1;
      break;
    case 1:
      tmp = theme.gdf_1;
      break;
    case 2:
      tmp = Colors_getInstance().s4k('#9aa0ab');
      break;
    case 3:
      tmp = Colors_getInstance().s4k('#a86b4c');
      break;
    case 4:
      tmp = Colors_getInstance().d45_1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tileBg = tmp;
  var tileY = (rowH - tile) / 2.0 - 4.0;
  if (soon) {
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.u2l(tile, tile);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var radius = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    var fill = new RGBA(Colors_getInstance().d45_1);
    var stroke = new RGBA(theme.edf_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = RoundRect.hc0(size, radius, fill, stroke, 1.0, true);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, row);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    position(this_3, 0.0, tileY);
  } else {
    // Inline function 'korlibs.korge.view.roundRect' call
    var size_0 = Size2D.u2l(tile, tile);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var radius_0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    var fill_0 = new RGBA(tileBg);
    var stroke_0 = new RGBA(Colors_getInstance().y44_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = RoundRect.hc0(size_0, radius_0, fill_0, stroke_0, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, row);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    position(this_5, 0.0, tileY);
  }
  var kanjiColor = soon ? theme.cdf_1 : item.cdu_1.equals(TeaTone_GOLD_getInstance()) ? Colors_getInstance().s4k('#14130f') : Colors_getInstance().s4k('#f7f1e4');
  var tmp_0 = Fonts_instance.zdf();
  kinText(row, item.bdu_1, 20.0, kanjiColor, tmp_0, TeaScene$renderRow$lambda(tile, tileY));
  var textX = tile + 14.0;
  var tmp_1 = Fonts_instance.udk();
  kinText(row, item.ddu_1, 14.0, theme.adf_1, tmp_1, TeaScene$renderRow$lambda_0(textX, tileY));
  var tmp_2 = Fonts_instance.tdp();
  kinText(row, item.edu_1, 11.0, theme.cdf_1, tmp_2, TeaScene$renderRow$lambda_1(textX, tileY));
  if (soon) {
    var tmp_3 = Fonts_instance.adg();
    kinText(row, '\u0421\u041A\u041E\u0420\u041E', 11.0, theme.cdf_1, tmp_3, TeaScene$renderRow$lambda_2(rowW, rowH));
  } else {
    var btnW = 74.0;
    var btnH = 34.0;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = Container.cae(false);
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(this_6, row);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.TeaScene.renderRow.<anonymous>' call
    var btn = position(this_7, rowW - btnW, (rowH - btnH) / 2.0 - 4.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var size_1 = Size2D.u2l(btnW, btnH);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var corner = 10.0 - 2.0;
    var radius_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var fill_1 = new RGBA(Colors_getInstance().d45_1);
    var stroke_1 = new RGBA(theme.edf_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_8 = RoundRect.hc0(size_1, radius_1, fill_1, stroke_1, 1.0, true);
    // Inline function 'kotlin.apply' call
    addTo(this_8, btn);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    var tmp1_elvis_lhs = item.fdu_1;
    var tmp_4 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    var tmp_5 = Fonts_instance.udk();
    kinText(btn, tmp_4, 12.5, theme.adf_1, tmp_5, TeaScene$renderRow$lambda_3(btnW, btnH));
    // Inline function 'korlibs.korge.input.onClick' call
    // Inline function 'korlibs.korge.view.solidRect' call
    var color = Colors_getInstance().d45_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_9 = SolidRect.rc2(Size2D.u2l(btnW, btnH), color);
    // Inline function 'kotlin.apply' call
    var this_10 = addTo(this_9, btn);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var handler = TeaScene$renderRow$lambda_4(onBuy);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_1();
    var tmp1_safe_receiver = this_10 == null ? null : this_10.far();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_6 = prop.get(tmp1_safe_receiver_0);
          tmp_6.p22(TeaScene$renderRow$lambda_5(handler));
        }
      }
    }
  }
  if (divider) {
    // Inline function 'korlibs.korge.view.solidRect' call
    var color_0 = theme.ddf_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_11 = SolidRect.rc2(Size2D.u2l(rowW, 1.0), color_0);
    // Inline function 'kotlin.apply' call
    var this_12 = addTo(this_11, host);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'scenes.TeaScene.renderRow.<anonymous>' call
    position(this_12, 24.0, y + rowH - 6.0);
  }
  return y + rowH;
}
function TeaScene$sceneMain$lambda() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function TeaScene$sceneMain$lambda_0() {
  Nav_getInstance().zdd();
  return Unit_instance;
}
function TeaScene$sceneMain$lambda_1($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function TeaScene$sceneMain$lambda_2($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function TeaScene$sceneMain$lambda_3($y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, 24.0, $y._v);
    return Unit_instance;
  };
}
function TeaScene$sceneMain$lambda_4($w, $h) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $w / 2.0, $h - 64.0);
    return Unit_instance;
  };
}
function TeaScene$sceneMain$lambda_5($stub) {
  return function () {
    $stub.ac7('\u041F\u043E\u043A\u0443\u043F\u043A\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0432 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0439 \u0441\u0431\u043E\u0440\u043A\u0435');
    return Unit_instance;
  };
}
function TeaScene$sceneMain$lambda_6($w, $y) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().t4t_1);
    position($this$kinText, $w / 2.0, $y._v + 14.0);
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda($tile, $tileY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, $tile / 2.0, $tileY + $tile / 2.0 + 1.0);
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda_0($textX, $tileY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $textX, $tileY + 4.0);
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda_1($textX, $tileY) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().s4t_1);
    position($this$kinText, $textX, $tileY + 23.0);
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda_2($rowW, $rowH) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().g4u_1);
    position($this$kinText, $rowW, $rowH / 2.0 - 4.0);
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda_3($btnW, $btnH) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, $btnW / 2.0, $btnH / 2.0);
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda_4($onBuy) {
  return function (it) {
    $onBuy();
    return Unit_instance;
  };
}
function TeaScene$renderRow$lambda_5($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function click$factory_1() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function threadColor(theme) {
  return Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(theme.fdf_1), _RGBA___get_g__impl__o8pukr(theme.fdf_1), _RGBA___get_b__impl__m6tl80(theme.fdf_1), numberToInt(255 * 0.4));
}
function kinAkaiItoH(_this__u8e3s4, width, theme) {
  width = width === VOID ? 230.0 : width;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinAkaiItoH.<anonymous>' call
  var k = width / 230.0;
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_2 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinAkaiItoH.<anonymous>.<anonymous>' call
  $l$block: {
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var paint = new RGBA(Companion_getInstance_7().g4l(threadColor(theme)));
    var info = new StrokeInfo(0.8, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance());
    if (paint == null || info == null) {
      break $l$block;
    }
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var lineWidth = info.c3g_1;
    var lineCap = info.f3g_1;
    var lineJoin = info.h3g_1;
    var miterLimit = info.i3g_1;
    var lineDash = info.j3g_1;
    var lineDashOffset = info.k3g_1;
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinAkaiItoH.<anonymous>.<anonymous>.<anonymous>' call
    this_2.t3s(4.0 * k, 6.0);
    this_2.s3v(42.0 * k, 2.0, 78.0 * k, 10.0, 115.0 * k, 6.0);
    this_2.s3v(152.0 * k, 2.0, 192.0 * k, 2.0, 226.0 * k, 6.0);
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    this_2.f4w();
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this_2.g4w(numberToDouble(lineWidth));
      this_2.h4w(lineCap);
      this_2.i4w(lineJoin);
      this_2.j4w(numberToDouble(miterLimit));
      this_2.k4w(lineDash);
      this_2.l4w(numberToDouble(lineDashOffset));
      this_2.m4w(paint);
    }finally {
      this_2.n4w();
    }
  }
  var shape = this_2.f4t();
  // Inline function 'korlibs.korge.view.cpuGraphics' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = CpuGraphics(shape, true);
  // Inline function 'kotlin.apply' call
  addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
  return this_1;
}
function kinAkaiItoV(_this__u8e3s4, height, theme) {
  height = height === VOID ? 380.0 : height;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinAkaiItoV.<anonymous>' call
  var k = height / 380.0;
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_2 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinAkaiItoV.<anonymous>.<anonymous>' call
  $l$block: {
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var paint = new RGBA(Companion_getInstance_7().g4l(Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(theme.fdf_1), _RGBA___get_g__impl__o8pukr(theme.fdf_1), _RGBA___get_b__impl__m6tl80(theme.fdf_1), numberToInt(255 * 0.3))));
    var info = new StrokeInfo(0.8, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance());
    if (paint == null || info == null) {
      break $l$block;
    }
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var lineWidth = info.c3g_1;
    var lineCap = info.f3g_1;
    var lineJoin = info.h3g_1;
    var miterLimit = info.i3g_1;
    var lineDash = info.j3g_1;
    var lineDashOffset = info.k3g_1;
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinAkaiItoV.<anonymous>.<anonymous>.<anonymous>' call
    this_2.t3s(8.0, 0.0);
    this_2.s3v(3.0, 60.0 * k, 13.0, 120.0 * k, 8.0, 190.0 * k);
    this_2.s3v(3.0, 260.0 * k, 4.0, 300.0 * k, 8.0, 380.0 * k);
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    this_2.f4w();
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this_2.g4w(numberToDouble(lineWidth));
      this_2.h4w(lineCap);
      this_2.i4w(lineJoin);
      this_2.j4w(numberToDouble(miterLimit));
      this_2.k4w(lineDash);
      this_2.l4w(numberToDouble(lineDashOffset));
      this_2.m4w(paint);
    }finally {
      this_2.n4w();
    }
  }
  var shape = this_2.f4t();
  // Inline function 'korlibs.korge.view.cpuGraphics' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = CpuGraphics(shape, true);
  // Inline function 'kotlin.apply' call
  addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
  return this_1;
}
function kinEnso(_this__u8e3s4, pixelSize, theme, seamSeed) {
  pixelSize = pixelSize === VOID ? 96.0 : pixelSize;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  seamSeed = seamSeed === VOID ? 3 : seamSeed;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinEnso.<anonymous>' call
  var viewBox = 84.0;
  var s = pixelSize / viewBox;
  scale(this_1, s);
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_2 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinEnso.<anonymous>.<anonymous>' call
  $l$block: {
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var paint = new RGBA(Companion_getInstance_7().g4l(theme.adf_1));
    var info = new StrokeInfo(3.5, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance(), LineJoin_ROUND_getInstance());
    if (paint == null || info == null) {
      break $l$block;
    }
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var lineWidth = info.c3g_1;
    var lineCap = info.f3g_1;
    var lineJoin = info.h3g_1;
    var miterLimit = info.i3g_1;
    var lineDash = info.j3g_1;
    var lineDashOffset = info.k3g_1;
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinEnso.<anonymous>.<anonymous>.<anonymous>' call
    this_2.t3s(42.0, 10.0);
    this_2.s3v(22.0, 10.0, 10.0, 26.0, 10.0, 44.0);
    this_2.s3v(10.0, 62.0, 26.0, 74.0, 44.0, 74.0);
    this_2.s3v(62.0, 74.0, 74.0, 60.0, 72.0, 44.0);
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    this_2.f4w();
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this_2.g4w(numberToDouble(lineWidth));
      this_2.h4w(lineCap);
      this_2.i4w(lineJoin);
      this_2.j4w(numberToDouble(miterLimit));
      this_2.k4w(lineDash);
      this_2.l4w(numberToDouble(lineDashOffset));
      this_2.m4w(paint);
    }finally {
      this_2.n4w();
    }
  }
  var shape = this_2.f4t();
  // Inline function 'korlibs.korge.view.cpuGraphics' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = CpuGraphics(shape, true);
  // Inline function 'kotlin.apply' call
  addTo(this_3, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
  var tmp0_color = theme.gdf_1;
  var tmp1_colorSoft = theme.hdf_1;
  kinSeam(this_1, 18.0, 56.0, 66.0, 28.0, 1.6, 3.0, seamSeed, true, VOID, VOID, tmp0_color, tmp1_colorSoft);
  return this_1;
}
function drawGrid($this) {
  var gridAlpha = $this.qdo_1.idf_1 ? 0.45 : 0.7;
  var gridColor = Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo($this.qdo_1.adf_1), _RGBA___get_g__impl__o8pukr($this.qdo_1.adf_1), _RGBA___get_b__impl__m6tl80($this.qdo_1.adf_1), numberToInt(255 * gridAlpha));
  var lineLen = $this.sdo_1 * 14;
  var inductionVariable = 0;
  if (inductionVariable < 15)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.solidRect' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = SolidRect.rc2(Size2D.u2l(lineLen, 0.6), gridColor);
      // Inline function 'kotlin.apply' call
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.KinBoardView.drawGrid.<anonymous>' call
      position(this_1, $this.tdo_1, $this.tdo_1 + i * $this.sdo_1 - 0.6 / 2.0);
      // Inline function 'korlibs.korge.view.solidRect' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_2 = SolidRect.rc2(Size2D.u2l(0.6, lineLen), gridColor);
      // Inline function 'kotlin.apply' call
      var this_3 = addTo(this_2, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.KinBoardView.drawGrid.<anonymous>' call
      position(this_3, $this.tdo_1 + i * $this.sdo_1 - 0.6 / 2.0, $this.tdo_1);
    }
     while (inductionVariable < 15);
  var hoshiColor = $this.qdo_1.idf_1 ? Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo($this.qdo_1.adf_1), _RGBA___get_g__impl__o8pukr($this.qdo_1.adf_1), _RGBA___get_b__impl__m6tl80($this.qdo_1.adf_1), numberToInt(255 * 0.8)) : $this.qdo_1.adf_1;
  var _iterator__ex2g4s = BoardSpec_getInstance().qdr_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var r = _destruct__k2r9zo.ul();
    var c = _destruct__k2r9zo.vl();
    // Inline function 'korlibs.korge.view.circle' call
    var fill = new RGBA(hoshiColor);
    var stroke = new RGBA(Colors_getInstance().y44_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Circle.hbd(numberToDouble(1.8), fill, stroke, numberToDouble(0.0), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.KinBoardView.drawGrid.<anonymous>' call
    position(this_5, $this.tdo_1 + c * $this.sdo_1, $this.tdo_1 + r * $this.sdo_1);
  }
}
function animateAppear($this, view) {
  scale(view, 0.7);
  var t = {_v: 0.0};
  var upd = {_v: null};
  upd._v = addUpdater(view, KinBoardView$animateAppear$lambda(t, view, upd));
}
function redraw$drawSeam(this$0, x1, y1, x2, y2, progress) {
  this$0.wdo_1.vaq();
  var tmp0_$receiver = this$0.wdo_1;
  var tmp1_color = this$0.qdo_1.gdf_1;
  var tmp2_colorSoft = this$0.qdo_1.hdf_1;
  kinSeam(tmp0_$receiver, x1, y1, x2, y2, 2.4, 4.0, 12, VOID, VOID, VOID, tmp1_color, tmp2_colorSoft, progress);
}
function KinBoardView$lambda(this$0) {
  return function (e) {
    var pt = e.vaa();
    var c = roundToInt((pt.h2d_1 - this$0.tdo_1) / this$0.sdo_1);
    var r = roundToInt((pt.i2d_1 - this$0.tdo_1) / this$0.sdo_1);
    var tmp;
    if ((0 <= r ? r < 15 : false) && (0 <= c ? c < 15 : false)) {
      tmp = this$0.rdo_1(r, c);
    }
    return Unit_instance;
  };
}
function KinBoardView$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function KinBoardView$redraw$lambda($t, this$0, $x1, $y1, $x2, $y2) {
  return function ($this$addUpdater, dt) {
    // Inline function 'kotlin.math.min' call
    var b = $t._v + get_milliseconds(dt.xj_1) / 600.0;
    var tmp$ret$0 = Math.min(1.0, b);
    $t._v = tmp$ret$0;
    redraw$drawSeam(this$0, $x1, $y1, $x2, $y2, $t._v);
    var tmp;
    if ($t._v >= 1.0) {
      var tmp0_safe_receiver = $this$addUpdater.adp_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
      $this$addUpdater.adp_1 = null;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function KinBoardView$redraw$lambda_0($t, $dot) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 1800.0;
    // Inline function 'kotlin.math.sin' call
    var x = $t._v * 2.0 * 3.141592653589793;
    var k = (Math.sin(x) + 1.0) / 2.0;
    $dot.kas(0.2 + 0.45 * k);
    scale($dot, 1.0 + 0.5 * k);
    return Unit_instance;
  };
}
function KinBoardView$animateAppear$lambda($t, $view, $upd) {
  return function ($this$addUpdater, dt) {
    // Inline function 'kotlin.math.min' call
    var b = $t._v + get_milliseconds(dt.xj_1) / 120.0;
    var tmp$ret$0 = Math.min(1.0, b);
    $t._v = tmp$ret$0;
    var k = $t._v - 1.0;
    var ease = 1.0 + 2.70158 * k * k * k + 1.70158 * k * k;
    scale($view, 0.7 + 0.3 * ease);
    var tmp;
    if ($t._v >= 1.0) {
      scale($view, 1.0);
      var tmp0_safe_receiver = $upd._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function KinBoardView$flashForbidden$lambda($t, $ring, $upd) {
  return function ($this$addUpdater, dt) {
    $t._v = $t._v + get_milliseconds(dt.xj_1) / 700.0;
    if ($t._v >= 1.0) {
      $ring.hat();
      var tmp0_safe_receiver = $upd._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancel(tmp0_safe_receiver);
      }
    } else {
      $ring.kas(1.0 - $t._v * $t._v);
    }
    return Unit_instance;
  };
}
function click$factory_2() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function buildPoints(p1, p2, jitter, segments, seed) {
  var rng = new KinRng(seed);
  var dx = p2.h2d_1 - p1.h2d_1;
  var dy = p2.i2d_1 - p1.i2d_1;
  // Inline function 'kotlin.math.sqrt' call
  var x = dx * dx + dy * dy;
  var len = Math.sqrt(x);
  if (len < 0.001)
    return listOf([p1, p2]);
  var px = -dy / len;
  var py = dx / len;
  var out = mutableListOf([p1]);
  var inductionVariable = 1;
  if (inductionVariable < segments)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var t = i / segments;
      // Inline function 'kotlin.math.sin' call
      var x_0 = t * 3.141592653589793;
      var taper = Math.sin(x_0);
      var off = (rng.hp() - 0.5) * 2.0 * jitter * taper;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = Vector2D.q2f(p1.h2d_1 + dx * t + px * off, p1.i2d_1 + dy * t + py * off);
      out.h(element);
    }
     while (inductionVariable < segments);
  // Inline function 'kotlin.collections.plusAssign' call
  out.h(p2);
  return out;
}
function samplePolyline(pts, samplesPerSegment) {
  samplesPerSegment = samplesPerSegment === VOID ? 8 : samplesPerSegment;
  if (pts.e1() < 2)
    return emptyList();
  // Inline function 'kotlin.collections.mutableListOf' call
  var out = ArrayList.i1();
  var inductionVariable = 0;
  var last_0 = pts.e1() - 1 | 0;
  if (inductionVariable < last_0)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p0 = i > 0 ? pts.d1(i - 1 | 0) : pts.d1(i);
      var p1 = pts.d1(i);
      var p2 = pts.d1(i + 1 | 0);
      var p3 = (i + 2 | 0) < pts.e1() ? pts.d1(i + 2 | 0) : p2;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < samplesPerSegment)
        do {
          var s = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var t = s / samplesPerSegment;
          var t2 = t * t;
          var t3 = t2 * t;
          var x = 0.5 * (2.0 * p1.h2d_1 + (-p0.h2d_1 + p2.h2d_1) * t + (2.0 * p0.h2d_1 - 5.0 * p1.h2d_1 + 4.0 * p2.h2d_1 - p3.h2d_1) * t2 + (-p0.h2d_1 + 3.0 * p1.h2d_1 - 3.0 * p2.h2d_1 + p3.h2d_1) * t3);
          var y = 0.5 * (2.0 * p1.i2d_1 + (-p0.i2d_1 + p2.i2d_1) * t + (2.0 * p0.i2d_1 - 5.0 * p1.i2d_1 + 4.0 * p2.i2d_1 - p3.i2d_1) * t2 + (-p0.i2d_1 + 3.0 * p1.i2d_1 - 3.0 * p2.i2d_1 + p3.i2d_1) * t3);
          // Inline function 'kotlin.collections.plusAssign' call
          var element = Vector2D.q2f(x, y);
          out.h(element);
        }
         while (inductionVariable_0 < samplesPerSegment);
    }
     while (inductionVariable < last_0);
  // Inline function 'kotlin.collections.plusAssign' call
  var element_0 = last(pts);
  out.h(element_0);
  return out;
}
function scaleAlpha(_this__u8e3s4, k) {
  return Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(_this__u8e3s4), _RGBA___get_g__impl__o8pukr(_this__u8e3s4), _RGBA___get_b__impl__m6tl80(_this__u8e3s4), coerceIn_0(numberToInt(_RGBA___get_a__impl__6msvu7(_this__u8e3s4) * coerceIn(k, 0.0, 1.0)), 0, 255));
}
function kinSeam(_this__u8e3s4, x1, y1, x2, y2, width, jitter, seed, branches, opacity, segments, color, colorSoft, progress) {
  width = width === VOID ? 1.4 : width;
  jitter = jitter === VOID ? 2.5 : jitter;
  seed = seed === VOID ? 1 : seed;
  branches = branches === VOID ? false : branches;
  opacity = opacity === VOID ? 1.0 : opacity;
  segments = segments === VOID ? 8 : segments;
  color = color === VOID ? Theme_instance.wde().gdf_1 : color;
  colorSoft = colorSoft === VOID ? Theme_instance.wde().hdf_1 : colorSoft;
  progress = progress === VOID ? 1.0 : progress;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinSeam.<anonymous>' call
  var pts = buildPoints(Vector2D.q2f(x1, y1), Vector2D.q2f(x2, y2), jitter, segments, seed);
  var full = samplePolyline(pts, 8);
  var line = progress >= 1.0 ? full : take(full, coerceAtLeast(numberToInt(full.e1() * progress), 2));
  var main = scaleAlpha(color, opacity);
  var soft = scaleAlpha(colorSoft, opacity);
  var glow = scaleAlpha(color, 0.18 * opacity);
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_2 = new ShapeBuilder(null, null);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinSeam.<anonymous>.<anonymous>' call
  $l$block: {
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var paint = new RGBA(Companion_getInstance_7().g4l(glow));
    var info = new StrokeInfo(width * 2.6, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance(), LineJoin_ROUND_getInstance());
    if (paint == null || info == null) {
      break $l$block;
    }
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var lineWidth = info.c3g_1;
    var lineCap = info.f3g_1;
    var lineJoin = info.h3g_1;
    var miterLimit = info.i3g_1;
    var lineDash = info.j3g_1;
    var lineDashOffset = info.k3g_1;
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
    this_2.p3v(line);
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    this_2.f4w();
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this_2.g4w(numberToDouble(lineWidth));
      this_2.h4w(lineCap);
      this_2.i4w(lineJoin);
      this_2.j4w(numberToDouble(miterLimit));
      this_2.k4w(lineDash);
      this_2.l4w(numberToDouble(lineDashOffset));
      this_2.m4w(paint);
    }finally {
      this_2.n4w();
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var paint_0 = new RGBA(Companion_getInstance_7().g4l(main));
    var info_0 = new StrokeInfo(width, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance(), LineJoin_ROUND_getInstance());
    if (paint_0 == null || info_0 == null) {
      break $l$block_0;
    }
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var lineWidth_0 = info_0.c3g_1;
    var lineCap_0 = info_0.f3g_1;
    var lineJoin_0 = info_0.h3g_1;
    var miterLimit_0 = info_0.i3g_1;
    var lineDash_0 = info_0.j3g_1;
    var lineDashOffset_0 = info_0.k3g_1;
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
    this_2.p3v(line);
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    this_2.f4w();
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this_2.g4w(numberToDouble(lineWidth_0));
      this_2.h4w(lineCap_0);
      this_2.i4w(lineJoin_0);
      this_2.j4w(numberToDouble(miterLimit_0));
      this_2.k4w(lineDash_0);
      this_2.l4w(numberToDouble(lineDashOffset_0));
      this_2.m4w(paint_0);
    }finally {
      this_2.n4w();
    }
  }
  $l$block_1: {
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var paint_1 = new RGBA(Companion_getInstance_7().g4l(soft));
    // Inline function 'kotlin.math.max' call
    var b = width * 0.4;
    var tmp$ret$2 = Math.max(0.4, b);
    var info_1 = new StrokeInfo(tmp$ret$2, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance(), LineJoin_ROUND_getInstance());
    if (paint_1 == null || info_1 == null) {
      break $l$block_1;
    }
    // Inline function 'korlibs.image.vector.Context2d.stroke' call
    var lineWidth_1 = info_1.c3g_1;
    var lineCap_1 = info_1.f3g_1;
    var lineJoin_1 = info_1.h3g_1;
    var miterLimit_1 = info_1.i3g_1;
    var lineDash_1 = info_1.j3g_1;
    var lineDashOffset_1 = info_1.k3g_1;
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
    this_2.p3v(line);
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    this_2.f4w();
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this_2.g4w(numberToDouble(lineWidth_1));
      this_2.h4w(lineCap_1);
      this_2.i4w(lineJoin_1);
      this_2.j4w(numberToDouble(miterLimit_1));
      this_2.k4w(lineDash_1);
      this_2.l4w(numberToDouble(lineDashOffset_1));
      this_2.m4w(paint_1);
    }finally {
      this_2.n4w();
    }
  }
  if (branches && pts.e1() >= 5 && progress >= 1.0) {
    var rng = new KinRng(seed + 7 | 0);
    var bp1 = pts.d1(2);
    var bp2 = pts.d1(numberToInt(pts.e1() * 0.66));
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_3 = pts.d1(3);
    var that = pts.d1(1);
    var dirRef = Vector2D.q2f(this_3.h2d_1 - that.h2d_1, this_3.i2d_1 - that.i2d_1);
    // Inline function 'kotlin.math.max' call
    var b_0 = dirRef.a();
    var dirLen = Math.max(0.001, b_0);
    var ux = dirRef.h2d_1 / dirLen;
    var uy = dirRef.i2d_1 / dirLen;
    var a1 = -3.141592653589793 / 2.0 - rng.hp() * 0.4;
    // Inline function 'kotlin.math.cos' call
    var tmp = ux * Math.cos(a1);
    // Inline function 'kotlin.math.sin' call
    var d1x = tmp - uy * Math.sin(a1);
    // Inline function 'kotlin.math.sin' call
    var tmp_0 = ux * Math.sin(a1);
    // Inline function 'kotlin.math.cos' call
    var d1y = tmp_0 + uy * Math.cos(a1);
    var l1 = 6.0 + rng.hp() * 4.0;
    var b1End = Vector2D.q2f(bp1.h2d_1 + d1x * l1, bp1.i2d_1 + d1y * l1);
    $l$block_2: {
      // Inline function 'korlibs.image.vector.Context2d.stroke' call
      var paint_2 = new RGBA(Companion_getInstance_7().g4l(main));
      var info_2 = new StrokeInfo(width * 0.7, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance());
      if (paint_2 == null || info_2 == null) {
        break $l$block_2;
      }
      // Inline function 'korlibs.image.vector.Context2d.stroke' call
      var lineWidth_2 = info_2.c3g_1;
      var lineCap_2 = info_2.f3g_1;
      var lineJoin_2 = info_2.h3g_1;
      var miterLimit_2 = info_2.i3g_1;
      var lineDash_2 = info_2.j3g_1;
      var lineDashOffset_2 = info_2.k3g_1;
      if (true) {
        this_2.m4u();
      }
      // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
      this_2.t3l(bp1);
      this_2.v3l(b1End);
      // Inline function 'korlibs.image.vector.Context2d.keep' call
      this_2.f4w();
      try {
        // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
        this_2.g4w(numberToDouble(lineWidth_2));
        this_2.h4w(lineCap_2);
        this_2.i4w(lineJoin_2);
        this_2.j4w(numberToDouble(miterLimit_2));
        this_2.k4w(lineDash_2);
        this_2.l4w(numberToDouble(lineDashOffset_2));
        this_2.m4w(paint_2);
      }finally {
        this_2.n4w();
      }
    }
    var a2 = 3.141592653589793 / 2.0 + rng.hp() * 0.4;
    // Inline function 'kotlin.math.cos' call
    var tmp_1 = ux * Math.cos(a2);
    // Inline function 'kotlin.math.sin' call
    var d2x = tmp_1 - uy * Math.sin(a2);
    // Inline function 'kotlin.math.sin' call
    var tmp_2 = ux * Math.sin(a2);
    // Inline function 'kotlin.math.cos' call
    var d2y = tmp_2 + uy * Math.cos(a2);
    var l2 = 5.0 + rng.hp() * 3.0;
    var b2End = Vector2D.q2f(bp2.h2d_1 + d2x * l2, bp2.i2d_1 + d2y * l2);
    $l$block_3: {
      // Inline function 'korlibs.image.vector.Context2d.stroke' call
      var paint_3 = new RGBA(Companion_getInstance_7().g4l(scaleAlpha(main, 0.85)));
      var info_3 = new StrokeInfo(width * 0.6, VOID, VOID, LineCap_ROUND_getInstance(), LineCap_ROUND_getInstance());
      if (paint_3 == null || info_3 == null) {
        break $l$block_3;
      }
      // Inline function 'korlibs.image.vector.Context2d.stroke' call
      var lineWidth_3 = info_3.c3g_1;
      var lineCap_3 = info_3.f3g_1;
      var lineJoin_3 = info_3.h3g_1;
      var miterLimit_3 = info_3.i3g_1;
      var lineDash_3 = info_3.j3g_1;
      var lineDashOffset_3 = info_3.k3g_1;
      if (true) {
        this_2.m4u();
      }
      // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
      this_2.t3l(bp2);
      this_2.v3l(b2End);
      // Inline function 'korlibs.image.vector.Context2d.keep' call
      this_2.f4w();
      try {
        // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
        this_2.g4w(numberToDouble(lineWidth_3));
        this_2.h4w(lineCap_3);
        this_2.i4w(lineJoin_3);
        this_2.j4w(numberToDouble(miterLimit_3));
        this_2.k4w(lineDash_3);
        this_2.l4w(numberToDouble(lineDashOffset_3));
        this_2.m4w(paint_3);
      }finally {
        this_2.n4w();
      }
    }
    var pool = pts.d1(pts.e1() / 2 | 0);
    // Inline function 'korlibs.image.vector.Context2d.fill' call
    var paint_4 = new RGBA(Companion_getInstance_7().g4l(main));
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
    this_2.b3g(pool, width * 0.9);
    this_2.l5t(paint_4, null);
    // Inline function 'korlibs.image.vector.Context2d.fill' call
    var paint_5 = new RGBA(Companion_getInstance_7().g4l(soft));
    if (true) {
      this_2.m4u();
    }
    // Inline function 'ui.kinSeam.<anonymous>.<anonymous>.<anonymous>' call
    this_2.b3g(Vector2D.q2f(pool.h2d_1 - 0.5, pool.i2d_1 - 0.5), width * 0.35);
    this_2.l5t(paint_5, null);
  }
  var shape = this_2.f4t();
  // Inline function 'korlibs.korge.view.cpuGraphics' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = CpuGraphics(shape, true);
  // Inline function 'kotlin.apply' call
  addTo(this_4, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
  return this_1;
}
function kinMiniBoard(_this__u8e3s4, moves, winLine, size, theme, showSeam) {
  theme = theme === VOID ? Theme_instance.wde() : theme;
  showSeam = showSeam === VOID ? false : showSeam;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinMiniBoard.<anonymous>' call
  var n = 15;
  var cell = size / (n + 1 | 0);
  var pad = cell;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = theme.yde_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.rc2(Size2D.u2l(size, size), color);
  // Inline function 'kotlin.apply' call
  addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var gridAlpha = theme.idf_1 ? 0.15 : 0.35;
  var gridColor = Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(theme.adf_1), _RGBA___get_g__impl__o8pukr(theme.adf_1), _RGBA___get_b__impl__m6tl80(theme.adf_1), numberToInt(255 * gridAlpha));
  var lineLen = cell * (n - 1 | 0);
  var inductionVariable = 0;
  if (inductionVariable < n)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.solidRect' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = SolidRect.rc2(Size2D.u2l(lineLen, 0.5), gridColor);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, this_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.kinMiniBoard.<anonymous>.<anonymous>' call
      position(this_4, pad, kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, i));
      // Inline function 'korlibs.korge.view.solidRect' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_5 = SolidRect.rc2(Size2D.u2l(0.5, lineLen), gridColor);
      // Inline function 'kotlin.apply' call
      var this_6 = addTo(this_5, this_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.kinMiniBoard.<anonymous>.<anonymous>' call
      position(this_6, kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, i), pad);
    }
     while (inductionVariable < n);
  var blackFill = theme.idf_1 ? Colors_getInstance().s4k('#8f8578') : Colors_getInstance().s4k('#1a1814');
  var whiteFill = Colors_getInstance().s4k('#f8f4ea');
  var whiteStroke = rgba255(0, 0, 0, 0.25);
  var isWin = kinMiniBoard$lambda(winLine);
  var stoneR = cell * 0.44;
  var _iterator__ex2g4s = moves.a1();
  while (_iterator__ex2g4s.b1()) {
    var m = _iterator__ex2g4s.c1();
    var win = isWin(m.ad9_1, m.bd9_1);
    var isBlack = m.cd9_1.equals(StoneColor_BLACK_getInstance());
    // Inline function 'korlibs.korge.view.circle' call
    var fill = new RGBA(isBlack ? blackFill : whiteFill);
    var stroke = new RGBA(win ? theme.gdf_1 : !isBlack ? whiteStroke : Colors_getInstance().d45_1);
    var strokeThickness = win ? 1.0 : !isBlack ? 0.4 : 0.0;
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = Circle.hbd(numberToDouble(stoneR), fill, stroke, numberToDouble(strokeThickness), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    position(this_8, kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, m.bd9_1) - stoneR, kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, m.ad9_1) - stoneR);
  }
  if (showSeam && !(winLine == null) && winLine.e1() >= 2) {
    var a = first(winLine);
    var b = last(winLine);
    var tmp0_x1 = kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, a.pdc_1);
    var tmp1_y1 = kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, a.odc_1);
    var tmp2_x2 = kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, b.pdc_1);
    var tmp3_y2 = kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, b.odc_1);
    var tmp4_color = theme.gdf_1;
    var tmp5_colorSoft = theme.hdf_1;
    kinSeam(this_1, tmp0_x1, tmp1_y1, tmp2_x2, tmp3_y2, 1.2, 2.0, 12, VOID, VOID, VOID, tmp4_color, tmp5_colorSoft);
  }
  return this_1;
}
function kinMiniBoard$_anonymous_$pos_wike7c(pad, cell, i) {
  return pad + i * cell;
}
function kinMiniBoard$lambda($winLine) {
  return function (r, c) {
    var tmp0_safe_receiver = $winLine;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0_safe_receiver, Collection)) {
          tmp_0 = tmp0_safe_receiver.g1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = tmp0_safe_receiver.a1();
        while (tmp0_iterator.b1()) {
          var element = tmp0_iterator.c1();
          // Inline function 'ui.kinMiniBoard.<anonymous>.<anonymous>.<anonymous>' call
          if (element.odc_1 === r && element.pdc_1 === c) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    return tmp === true;
  };
}
function *_generator_init__qn9atk($this, context, $completion) {
  $this.fdd_1 = context;
  var tmp = $this;
  // Inline function 'kotlin.Result.getOrNull' call
  // Inline function 'kotlin.runCatching' call
  var tmp_0;
  try {
    // Inline function 'kotlin.Companion.success' call
    // Inline function 'ui.MusicPlayer.init.<anonymous>' call
    var tmp_1 = readMusic(get_resourcesVfs().oi('sounds/ambient.wav'), VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var value = tmp_1;
    tmp_0 = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var this_0 = tmp_0;
  var tmp_3;
  if (_Result___get_isFailure__impl__jpiriv(this_0)) {
    tmp_3 = null;
  } else {
    var tmp_4 = _Result___get_value__impl__bjfvqg(this_0);
    tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
  }
  tmp.ddd_1 = tmp_3;
  $this.gdt();
  return Unit_instance;
}
var MusicPlayer_instance;
function MusicPlayer_getInstance() {
  return MusicPlayer_instance;
}
function get_stoneCache() {
  _init_properties_Stone_kt__d58fwt();
  return stoneCache;
}
var stoneCache;
function stoneBitmap(palette, radius) {
  _init_properties_Stone_kt__d58fwt();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.stoneBitmap.<anonymous>' call
  this_0.gh(_RGBA___get_value__impl__hhco8v(palette.rdu_1));
  this_0.fc(_Char___init__impl__6a9atx(95));
  this_0.gh(_RGBA___get_value__impl__hhco8v(palette.sdu_1));
  this_0.fc(_Char___init__impl__6a9atx(95));
  var tmp0_safe_receiver = palette.tdu_1;
  var tmp;
  var tmp_0 = tmp0_safe_receiver;
  if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _RGBA___get_value__impl__hhco8v(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  this_0.gh(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
  this_0.fc(_Char___init__impl__6a9atx(95));
  this_0.gh(palette.udu_1 ? 1 : 0);
  this_0.fc(_Char___init__impl__6a9atx(95));
  this_0.gh(numberToInt(radius * 10));
  var key = this_0.toString();
  var tmp0_safe_receiver_0 = get_stoneCache().h3(key);
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return tmp0_safe_receiver_0;
  }
  var pad = 6.0;
  var size = coerceAtLeast(numberToInt((radius + pad) * 2), 8);
  var cx = size / 2.0;
  var cy = size / 2.0;
  var bm = Bitmap32Context2d(size, size, true, stoneBitmap$lambda(cx, cy, radius, palette));
  // Inline function 'kotlin.collections.set' call
  get_stoneCache().j3(key, bm);
  return bm;
}
function kinStone(_this__u8e3s4, isBlack, radius, isLast, isWin, theme) {
  isLast = isLast === VOID ? false : isLast;
  isWin = isWin === VOID ? false : isWin;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Stone_kt__d58fwt();
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinStone.<anonymous>' call
  var palette = isBlack ? blackStonePalette(theme) : whiteStonePalette(theme);
  var bm = stoneBitmap(palette, radius);
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.image' call
  var anchor_0 = Companion_getInstance_4().i2c_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Image.cbx(bm, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.image.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinStone.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_3, Anchor2D.v2c(numberToDouble(0.5), numberToDouble(0.5)));
  if (isWin) {
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.korge.view.circle' call
    var radius_0 = radius + 1.0;
    var fill = new RGBA(Colors_getInstance().d45_1);
    var stroke = new RGBA(theme.gdf_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Circle.hbd(numberToDouble(radius_0), fill, stroke, numberToDouble(1.6), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.kinStone.<anonymous>.<anonymous>' call
    position(this_5, -radius - 1.0, -radius - 1.0);
  }
  if (isLast && !isWin) {
    var dotColor = isBlack ? theme.xde_1 : theme.fdf_1;
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.korge.view.circle' call
    var radius_1 = radius * 0.2;
    var fill_0 = new RGBA(dotColor);
    var stroke_0 = new RGBA(Colors_getInstance().y44_1);
    var renderer_0 = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = Circle.hbd(numberToDouble(radius_1), fill_0, stroke_0, numberToDouble(0.0), true, renderer_0);
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(this_6, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.kinStone.<anonymous>.<anonymous>' call
    position(this_7, -radius * 0.2, -radius * 0.2);
  }
  return this_1;
}
function rgba255(r, g, b, alpha) {
  _init_properties_Stone_kt__d58fwt();
  return Companion_getInstance_7().k4j(r, g, b, numberToInt(coerceIn(alpha, 0.0, 1.0) * 255));
}
function mix(a, b, t) {
  _init_properties_Stone_kt__d58fwt();
  var k = coerceIn(t, 0.0, 1.0);
  return Companion_getInstance_7().k4j(numberToInt(_RGBA___get_r__impl__duz7mo(a) + (_RGBA___get_r__impl__duz7mo(b) - _RGBA___get_r__impl__duz7mo(a) | 0) * k), numberToInt(_RGBA___get_g__impl__o8pukr(a) + (_RGBA___get_g__impl__o8pukr(b) - _RGBA___get_g__impl__o8pukr(a) | 0) * k), numberToInt(_RGBA___get_b__impl__m6tl80(a) + (_RGBA___get_b__impl__m6tl80(b) - _RGBA___get_b__impl__m6tl80(a) | 0) * k), numberToInt(_RGBA___get_a__impl__6msvu7(a) + (_RGBA___get_a__impl__6msvu7(b) - _RGBA___get_a__impl__6msvu7(a) | 0) * k));
}
function stoneBitmap$lambda($cx, $cy, $radius, $palette) {
  return function ($this$Bitmap32Context2d) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.Context2d.createRadialGradient' call
    var x0 = $cx;
    var y0 = $cy + 1.5;
    var x1 = $cx;
    var y1 = $cy + 1.5;
    var r1 = $radius * 1.15;
    var cycle = CycleMethod_NO_CYCLE_getInstance();
    // Inline function 'korlibs.image.paint.RadialGradientPaint' call
    var transform = Companion_getInstance_3().s2g_1;
    // Inline function 'kotlin.also' call
    var this_0 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0), numberToDouble(y0), numberToDouble(0.0), numberToDouble(x1), numberToDouble(y1), numberToDouble(r1), VOID, VOID, cycle, transform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.Context2d.createRadialGradient.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
    this_0.q5a(0.0, Companion_getInstance_7().k4j(0, 0, 0, 90));
    this_0.q5a(0.65, Companion_getInstance_7().k4j(0, 0, 0, 70));
    this_0.q5a(1.0, Companion_getInstance_7().k4j(0, 0, 0, 0));
    if (true) {
      $this$Bitmap32Context2d.m4u();
    }
    // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
    $this$Bitmap32Context2d.b3g(Vector2D.q2f($cx, $cy + 1.5), $radius * 1.15);
    $this$Bitmap32Context2d.l5t(this_0, null);
    var hx = $cx - $radius * 0.3;
    var hy = $cy - $radius * 0.32;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.Context2d.createRadialGradient' call
    var x1_0 = $cx;
    var y1_0 = $cy;
    var r1_0 = $radius;
    var cycle_0 = CycleMethod_NO_CYCLE_getInstance();
    // Inline function 'korlibs.image.paint.RadialGradientPaint' call
    var transform_0 = Companion_getInstance_3().s2g_1;
    // Inline function 'kotlin.also' call
    var this_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(hx), numberToDouble(hy), numberToDouble(0.0), numberToDouble(x1_0), numberToDouble(y1_0), numberToDouble(r1_0), VOID, VOID, cycle_0, transform_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.Context2d.createRadialGradient.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
    this_1.q5a(0.0, $palette.sdu_1);
    this_1.q5a(0.55, mix($palette.sdu_1, $palette.rdu_1, 0.55));
    this_1.q5a(1.0, $palette.rdu_1);
    if (true) {
      $this$Bitmap32Context2d.m4u();
    }
    // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
    $this$Bitmap32Context2d.b3g(Vector2D.q2f($cx, $cy), $radius);
    $this$Bitmap32Context2d.l5t(this_1, null);
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.Context2d.createRadialGradient' call
    var r1_1 = $radius * 0.42;
    var cycle_1 = CycleMethod_NO_CYCLE_getInstance();
    // Inline function 'korlibs.image.paint.RadialGradientPaint' call
    var transform_1 = Companion_getInstance_3().s2g_1;
    // Inline function 'kotlin.also' call
    var this_2 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(hx), numberToDouble(hy), numberToDouble(0.0), numberToDouble(hx), numberToDouble(hy), numberToDouble(r1_1), VOID, VOID, cycle_1, transform_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.Context2d.createRadialGradient.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
    this_2.q5a(0.0, Companion_getInstance_7().k4j(255, 255, 255, 90));
    this_2.q5a(1.0, Companion_getInstance_7().k4j(255, 255, 255, 0));
    if (true) {
      $this$Bitmap32Context2d.m4u();
    }
    // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
    $this$Bitmap32Context2d.b3g(Vector2D.q2f(hx, hy), $radius * 0.42);
    $this$Bitmap32Context2d.l5t(this_2, null);
    var tmp0_safe_receiver = $palette.tdu_1;
    var tmp = tmp0_safe_receiver;
    if ((tmp == null ? null : new RGBA(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp0_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var borderColor = (tmp_0 == null ? null : new RGBA(tmp_0)).u4k_1;
      // Inline function 'korlibs.image.vector.Context2d.stroke' call
      var paint = new RGBA(Companion_getInstance_7().g4l(borderColor));
      var lineCap = $this$Bitmap32Context2d.a4w();
      var lineJoin = $this$Bitmap32Context2d.b4w();
      var miterLimit = $this$Bitmap32Context2d.c4w();
      var lineDash = $this$Bitmap32Context2d.d4w();
      var lineDashOffset = $this$Bitmap32Context2d.e4w();
      if (true) {
        $this$Bitmap32Context2d.m4u();
      }
      // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>.<anonymous>' call
      $this$Bitmap32Context2d.b3g(Vector2D.q2f($cx, $cy), $radius - 0.3);
      // Inline function 'korlibs.image.vector.Context2d.keep' call
      $this$Bitmap32Context2d.f4w();
      try {
        // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
        $this$Bitmap32Context2d.g4w(numberToDouble(0.7));
        $this$Bitmap32Context2d.h4w(lineCap);
        $this$Bitmap32Context2d.i4w(lineJoin);
        $this$Bitmap32Context2d.j4w(numberToDouble(miterLimit));
        $this$Bitmap32Context2d.k4w(lineDash);
        $this$Bitmap32Context2d.l4w(numberToDouble(lineDashOffset));
        $this$Bitmap32Context2d.m4w(paint);
      }finally {
        $this$Bitmap32Context2d.n4w();
      }
    }
    var tmp_1;
    if ($palette.udu_1) {
      var paint_0 = new RGBA(Companion_getInstance_7().g4l(rgba255(255, 253, 245, 0.45)));
      var lineCap_0 = $this$Bitmap32Context2d.a4w();
      var lineJoin_0 = $this$Bitmap32Context2d.b4w();
      var miterLimit_0 = $this$Bitmap32Context2d.c4w();
      var lineDash_0 = $this$Bitmap32Context2d.d4w();
      var lineDashOffset_0 = $this$Bitmap32Context2d.e4w();
      if (true) {
        $this$Bitmap32Context2d.m4u();
      }
      // Inline function 'ui.stoneBitmap.<anonymous>.<anonymous>' call
      $this$Bitmap32Context2d.b3g(Vector2D.q2f($cx, $cy), $radius - 0.25);
      $this$Bitmap32Context2d.f4w();
      var tmp_2;
      try {
        $this$Bitmap32Context2d.g4w(numberToDouble(0.5));
        $this$Bitmap32Context2d.h4w(lineCap_0);
        $this$Bitmap32Context2d.i4w(lineJoin_0);
        $this$Bitmap32Context2d.j4w(numberToDouble(miterLimit_0));
        $this$Bitmap32Context2d.k4w(lineDash_0);
        $this$Bitmap32Context2d.l4w(numberToDouble(lineDashOffset_0));
        $this$Bitmap32Context2d.m4w(paint_0);
        tmp_2 = Unit_instance;
      }finally {
        $this$Bitmap32Context2d.n4w();
      }
      tmp_1 = tmp_2;
    }
    return Unit_instance;
  };
}
var properties_initialized_Stone_kt_kwmcad;
function _init_properties_Stone_kt__d58fwt() {
  if (!properties_initialized_Stone_kt_kwmcad) {
    properties_initialized_Stone_kt_kwmcad = true;
    // Inline function 'kotlin.collections.mutableMapOf' call
    stoneCache = LinkedHashMap.rc();
  }
}
function plural($this, n, one, few, many) {
  var d10 = n % 10 | 0;
  var d100 = n % 100 | 0;
  return (11 <= d100 ? d100 <= 14 : false) ? many : d10 === 1 ? one : (2 <= d10 ? d10 <= 4 : false) ? few : many;
}
var Str_instance;
function Str_getInstance() {
  if (Str_instance === VOID)
    new Str();
  return Str_instance;
}
var TeaTone_VERMILLION_instance;
var TeaTone_GOLD_instance;
var TeaTone_SILVER_instance;
var TeaTone_COPPER_instance;
var TeaTone_SOON_instance;
var TeaTone_entriesInitialized;
function TeaTone_initEntries() {
  if (TeaTone_entriesInitialized)
    return Unit_instance;
  TeaTone_entriesInitialized = true;
  TeaTone_VERMILLION_instance = new TeaTone('VERMILLION', 0);
  TeaTone_GOLD_instance = new TeaTone('GOLD', 1);
  TeaTone_SILVER_instance = new TeaTone('SILVER', 2);
  TeaTone_COPPER_instance = new TeaTone('COPPER', 3);
  TeaTone_SOON_instance = new TeaTone('SOON', 4);
}
function get_label(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.t3_1) {
    case 0:
      tmp = '\u041B\u0435\u0433\u043A\u043E';
      break;
    case 1:
      tmp = '\u0421\u0440\u0435\u0434\u043D\u0435';
      break;
    case 2:
      tmp = '\u0421\u043B\u043E\u0436\u043D\u043E';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function TeaTone_VERMILLION_getInstance() {
  TeaTone_initEntries();
  return TeaTone_VERMILLION_instance;
}
function TeaTone_GOLD_getInstance() {
  TeaTone_initEntries();
  return TeaTone_GOLD_instance;
}
function TeaTone_SILVER_getInstance() {
  TeaTone_initEntries();
  return TeaTone_SILVER_instance;
}
function TeaTone_COPPER_getInstance() {
  TeaTone_initEntries();
  return TeaTone_COPPER_instance;
}
function TeaTone_SOON_getInstance() {
  TeaTone_initEntries();
  return TeaTone_SOON_instance;
}
function get_KIN_LIGHT() {
  _init_properties_Theme_kt__w31tqv();
  return KIN_LIGHT;
}
var KIN_LIGHT;
function get_KIN_DARK() {
  _init_properties_Theme_kt__w31tqv();
  return KIN_DARK;
}
var KIN_DARK;
function rgba(hex, alpha) {
  alpha = alpha === VOID ? 1.0 : alpha;
  _init_properties_Theme_kt__w31tqv();
  var c = Colors_getInstance().s4k(hex);
  return Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_b__impl__m6tl80(c), numberToInt(coerceIn(alpha, 0.0, 1.0) * 255));
}
var BtnSpec_instance;
function BtnSpec_getInstance() {
  if (BtnSpec_instance === VOID)
    new BtnSpec();
  return BtnSpec_instance;
}
function blackStonePalette(theme) {
  _init_properties_Theme_kt__w31tqv();
  var tmp;
  if (theme.idf_1) {
    tmp = new StonePalette(rgba('#1a1814'), rgba('#9a8f80'), null, true);
  } else {
    tmp = new StonePalette(rgba('#0d0c0a'), rgba('#4a4640'), null);
  }
  return tmp;
}
function whiteStonePalette(theme) {
  _init_properties_Theme_kt__w31tqv();
  return new StonePalette(rgba('#d8d2c4'), rgba('#ffffff'), rgba('#000000', 0.18));
}
function Theme$set$lambda($dark) {
  return function (it) {
    return it.cdc($dark);
  };
}
var Theme_instance;
function Theme_getInstance() {
  return Theme_instance;
}
function *_generator_loadOnce__cxfafz($this, $completion) {
  if ($this.bdd_1)
    return Unit_instance;
  var tmp = $this;
  var tmp_0 = readFont(get_resourcesVfs().oi('fonts/NotoSerif-Regular.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.udc_1 = tmp_0;
  var tmp_1 = $this;
  var tmp_2 = readFont(get_resourcesVfs().oi('fonts/NotoSerif-Italic.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  tmp_1.vdc_1 = tmp_2;
  var tmp_3 = $this;
  var tmp_4 = readFont(get_resourcesVfs().oi('fonts/NotoSerif-SemiBold.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  tmp_3.wdc_1 = tmp_4;
  var tmp_5 = $this;
  var tmp_6 = readFont(get_resourcesVfs().oi('fonts/NotoSerifJP-Regular.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  tmp_5.xdc_1 = tmp_6;
  var tmp_7 = $this;
  var tmp_8 = readFont(get_resourcesVfs().oi('fonts/Inter-Regular.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  tmp_7.ydc_1 = tmp_8;
  var tmp_9 = $this;
  var tmp_10 = readFont(get_resourcesVfs().oi('fonts/Inter-Medium.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  tmp_9.zdc_1 = tmp_10;
  var tmp_11 = $this;
  var tmp_12 = readFont(get_resourcesVfs().oi('fonts/Inter-SemiBold.ttf'), VOID, VOID, VOID, $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  tmp_11.add_1 = tmp_12;
  $this.bdd_1 = true;
  return Unit_instance;
}
var Fonts_instance;
function Fonts_getInstance() {
  return Fonts_instance;
}
function Type$_get_display_$lambda_qebtru() {
  return Fonts_instance.zdf();
}
function Type$_get_title_$lambda_js578c() {
  return Fonts_instance.kdf();
}
function Type$_get_subtitle_$lambda_xy7r3m() {
  return Fonts_instance.kdf();
}
function Type$_get_body_$lambda_3j9t60() {
  return Fonts_instance.tdp();
}
function Type$_get_button_$lambda_nd8j2w() {
  return Fonts_instance.adg();
}
function Type$_get_buttonSmall_$lambda_zcb7pj() {
  return Fonts_instance.adg();
}
function Type$_get_caption_$lambda_f2b3h2() {
  return Fonts_instance.tdp();
}
function Type$_get_captionItalic_$lambda_6pc3wm() {
  return Fonts_instance.fdp();
}
function Type$_get_meta_$lambda_bw6vlx() {
  return Fonts_instance.adg();
}
function Type$_get_labelCaps_$lambda_1d03k7() {
  return Fonts_instance.adg();
}
function Type$_get_trackingBrand_$lambda_kin2i4() {
  return Fonts_instance.adg();
}
function Type$_get_ideogram_$lambda_p6rub2() {
  return Fonts_instance.zdf();
}
var Type_instance;
function Type_getInstance() {
  return Type_instance;
}
var BoardSpec_instance;
function BoardSpec_getInstance() {
  if (BoardSpec_instance === VOID)
    new BoardSpec();
  return BoardSpec_instance;
}
function Display$nativeWidthProvider$lambda() {
  return 360;
}
var Display_instance;
function Display_getInstance() {
  if (Display_instance === VOID)
    new Display();
  return Display_instance;
}
function capsTracked(text, intensity) {
  intensity = intensity === VOID ? 1 : intensity;
  _init_properties_Theme_kt__w31tqv();
  // Inline function 'kotlin.text.map' call
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var this_0 = text.toUpperCase();
  // Inline function 'kotlin.text.mapTo' call
  var destination = ArrayList.w(charSequenceLength(this_0));
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(this_0)) {
    var item = charSequenceGet(this_0, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'ui.capsTracked.<anonymous>' call
    var tmp$ret$2 = toString_1(item);
    destination.h(tmp$ret$2);
  }
  return joinToString(destination, repeat(' ', intensity));
}
var properties_initialized_Theme_kt_uwj6hl;
function _init_properties_Theme_kt__w31tqv() {
  if (!properties_initialized_Theme_kt_uwj6hl) {
    properties_initialized_Theme_kt_uwj6hl = true;
    KIN_LIGHT = new KinPalette(rgba('#f5f0e6'), rgba('#ede5d4'), rgba('#faf6ec'), rgba('#1a1814'), rgba('#3a3530'), rgba('#6f695f'), rgba('#1a1814', 0.1), rgba('#1a1814', 0.32), rgba('#c1442a'), rgba('#b48a3c'), rgba('#d9b46a'), false);
    KIN_DARK = new KinPalette(rgba('#14130f'), rgba('#2a2722'), rgba('#0e0d0a'), rgba('#f0ede4'), rgba('#bdb8ad'), rgba('#857f72'), rgba('#fffdf5', 0.08), rgba('#fffdf5', 0.22), rgba('#d35a3e'), rgba('#d4a652'), rgba('#e9c476'), true);
  }
}
function get_cyrillicAll() {
  _init_properties_Widgets_kt__gwc459();
  return cyrillicAll;
}
var cyrillicAll;
function get_extraChars() {
  _init_properties_Widgets_kt__gwc459();
  return extraChars;
}
var extraChars;
function get_kinChars() {
  _init_properties_Widgets_kt__gwc459();
  return kinChars;
}
var kinChars;
function get_bitmapFontCache() {
  _init_properties_Widgets_kt__gwc459();
  return bitmapFontCache;
}
var bitmapFontCache;
function get_paperCache() {
  _init_properties_Widgets_kt__gwc459();
  return paperCache;
}
var paperCache;
function bitmapFontFor(font, atlasSize) {
  _init_properties_Widgets_kt__gwc459();
  var key = to(font, atlasSize);
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = get_bitmapFontCache();
  var value = this_0.h3(key);
  var tmp;
  if (value == null) {
    // Inline function 'ui.bitmapFontFor.<anonymous>' call
    // Inline function 'korlibs.image.font.toBitmapFont' call
    var chars = get_kinChars();
    var fontName = font.u3();
    var paint = new RGBA(Colors_getInstance().y44_1);
    var answer = Companion_instance_0.b4m(font, numberToDouble(atlasSize), chars, fontName, paint, true, null);
    this_0.j3(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function kinText(_this__u8e3s4, label, size, color, font, block) {
  var tmp;
  if (block === VOID) {
    tmp = kinText$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_Widgets_kt__gwc459();
  var s = Display_getInstance().xdu();
  var atlasSize = size * s;
  var bmpFont = bitmapFontFor(font, atlasSize);
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.text' call
  var alignment = Companion_getInstance_6().s4t_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance_1.vc6_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Text.zc6(label, numberToDouble(atlasSize), color, bmpFont, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinText.<anonymous>' call
  this_1.var(1.0 / s);
  this_1.gc5_1 = true;
  block(this_1);
  return this_1;
}
function kinText_0(_this__u8e3s4, label, type, color, block) {
  var tmp;
  if (block === VOID) {
    tmp = kinText$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_Widgets_kt__gwc459();
  return kinText(_this__u8e3s4, label, type.fdm_1, color, type.edm_1(), block);
}
function kinPaperBackground(_this__u8e3s4, theme) {
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Widgets_kt__gwc459();
  var w = 360;
  var h = 720;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = theme.xde_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.rc2(Size2D.u2l(w, h), color);
  // Inline function 'kotlin.apply' call
  addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.collections.getOrPut' call
  var this_1 = get_paperCache();
  var key = theme.idf_1;
  var value = this_1.h3(key);
  var tmp;
  if (value == null) {
    // Inline function 'ui.kinPaperBackground.<anonymous>' call
    var answer = Bitmap32Context2d(360, 720, true, kinPaperBackground$lambda(theme, h, w));
    this_1.j3(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var bm = tmp;
  // Inline function 'korlibs.korge.view.image' call
  var anchor = Companion_getInstance_4().i2c_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Image.cbx(bm, anchor);
  // Inline function 'kotlin.apply' call
  addTo(this_2, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.image.<anonymous>' call
}
function kinButton(_this__u8e3s4, width, label, primary, small, rightArrow, centered, enabled, theme, onPress) {
  primary = primary === VOID ? false : primary;
  small = small === VOID ? false : small;
  rightArrow = rightArrow === VOID ? false : rightArrow;
  centered = centered === VOID ? small : centered;
  enabled = enabled === VOID ? true : enabled;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Widgets_kt__gwc459();
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinButton.<anonymous>' call
  var height = small ? 44.0 : 52.0;
  var padH = small ? 16.0 : 24.0;
  var typo = small ? Type_instance.wdu() : Type_instance.vdu();
  var fgColor = primary ? BtnSpec_getInstance().ydf_1 : theme.adf_1;
  if (primary) {
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.u2l(width, height);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var radius = new RectCorners(numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0));
    var fill = new RGBA(BtnSpec_getInstance().gdq(theme));
    var stroke = new RGBA(Colors_getInstance().y44_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = RoundRect.hc0(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  } else {
    // Inline function 'korlibs.korge.view.roundRect' call
    var size_0 = Size2D.u2l(width, height);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var radius_0 = new RectCorners(numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0));
    var fill_0 = new RGBA(Colors_getInstance().d45_1);
    var stroke_0 = new RGBA(theme.edf_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_3 = RoundRect.hc0(size_0, radius_0, fill_0, stroke_0, 1.0, true);
    // Inline function 'kotlin.apply' call
    addTo(this_3, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  }
  var mainText = kinText_0(this_1, label, typo, fgColor, kinButton$lambda(centered));
  position(mainText, centered ? width / 2.0 : padH, height / 2.0);
  if (rightArrow) {
    var arrowAlpha = primary ? 0.7 : 0.5;
    var arrowColor = Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(fgColor), _RGBA___get_g__impl__o8pukr(fgColor), _RGBA___get_b__impl__m6tl80(fgColor), numberToInt(255 * arrowAlpha));
    var tmp = Fonts_instance.tdp();
    kinText(this_1, '\u2192', 14.0, arrowColor, tmp, kinButton$lambda_0(width, padH, height));
  }
  if (enabled) {
    // Inline function 'korlibs.korge.input.onClick' call
    var handler = kinButton$lambda_1(onPress);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_3();
    var tmp1_safe_receiver = this_1 == null ? null : this_1.far();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop.get(tmp1_safe_receiver_0);
          tmp_0.p22(kinButton$lambda_2(handler));
        }
      }
    }
  } else {
    this_1.kas(0.4);
  }
  return this_1;
}
function kinTextButton(_this__u8e3s4, label, color, onPress) {
  color = color === VOID ? Theme_instance.wde().cdf_1 : color;
  _init_properties_Widgets_kt__gwc459();
  // Inline function 'kotlin.apply' call
  var this_0 = kinText_0(_this__u8e3s4, label, Type_instance.ddt(), color);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinTextButton.<anonymous>' call
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = kinTextButton$lambda(onPress);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_4();
  var tmp1_safe_receiver = this_0 == null ? null : this_0.far();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.p22(kinTextButton$lambda_0(handler));
      }
    }
  }
  return this_0;
}
function kinIconRound(_this__u8e3s4, icon, theme, onPress) {
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Widgets_kt__gwc459();
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinIconRound.<anonymous>' call
  var size = 36.0;
  // Inline function 'korlibs.korge.view.circle' call
  var radius = size / 2.0;
  var fill = new RGBA(Colors_getInstance().d45_1);
  var stroke = new RGBA(theme.edf_1);
  var renderer = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Circle.hbd(numberToDouble(radius), fill, stroke, numberToDouble(1.0), true, renderer);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinIconRound.<anonymous>.<anonymous>' call
  position(this_3, size / 2.0, size / 2.0);
  var tmp = Fonts_instance.tdp();
  kinText(this_1, icon, 14.0, theme.adf_1, tmp, kinIconRound$lambda(size));
  // Inline function 'korlibs.korge.input.onClick' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().d45_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = SolidRect.rc2(Size2D.u2l(size, size), color);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var handler = kinIconRound$lambda_0(onPress);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_5();
  var tmp1_safe_receiver = this_5 == null ? null : this_5.far();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop.get(tmp1_safe_receiver_0);
        tmp_0.p22(kinIconRound$lambda_1(handler));
      }
    }
  }
  return this_1;
}
function kinToggle(_this__u8e3s4, initialOn, theme, onChange) {
  initialOn = initialOn === VOID ? false : initialOn;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Widgets_kt__gwc459();
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinToggle.<anonymous>' call
  var on = {_v: initialOn};
  var w = 44.0;
  var h = 24.0;
  var trackOff = theme.idf_1 ? rgba255(255, 253, 245, 0.18) : rgba255(0, 0, 0, 0.15);
  var trackOn = BtnSpec_getInstance().gdq(theme);
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.korge.view.roundRect' call
  var size = Size2D.u2l(w, h);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_2();
  var corner = h / 2.0;
  var radius = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  var fill = new RGBA(Colors_getInstance().y44_1);
  var stroke = new RGBA(Colors_getInstance().y44_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = RoundRect.hc0(size, radius, fill, stroke, 0.0, true);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinToggle.<anonymous>.<anonymous>' call
  this_3.m4k(on._v ? trackOn : trackOff);
  var track = this_3;
  var r = 10.0;
  var cy = h / 2.0;
  var cxOff = h / 2.0;
  var cxOn = w - h / 2.0;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.circle' call
  var fill_0 = new RGBA(Companion_getInstance_7().k4j(0, 0, 0, 50));
  var stroke_0 = new RGBA(Colors_getInstance().y44_1);
  var renderer = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Circle.hbd(numberToDouble(r), fill_0, stroke_0, numberToDouble(0.0), true, renderer);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.circle.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinToggle.<anonymous>.<anonymous>' call
  position(this_5, (on._v ? cxOn : cxOff) - r, cy - r + 1.0);
  var shadow = this_5;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.circle' call
  var fill_1 = new RGBA(theme.xde_1);
  var stroke_1 = new RGBA(Colors_getInstance().y44_1);
  var renderer_0 = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Circle.hbd(numberToDouble(r), fill_1, stroke_1, numberToDouble(0.0), true, renderer_0);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.circle.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinToggle.<anonymous>.<anonymous>' call
  position(this_7, (on._v ? cxOn : cxOff) - r, cy - r);
  var thumb = this_7;
  // Inline function 'korlibs.korge.input.onClick' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().d45_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = SolidRect.rc2(Size2D.u2l(w, h), color);
  // Inline function 'kotlin.apply' call
  var this_9 = addTo(this_8, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var handler = kinToggle$lambda(on, track, trackOn, trackOff, cxOn, cxOff, thumb, r, shadow, onChange);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_6();
  var tmp1_safe_receiver = this_9 == null ? null : this_9.far();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = prop.get(tmp1_safe_receiver_0);
        tmp.p22(kinToggle$lambda_0(handler));
      }
    }
  }
  return this_1;
}
function kinSegmented(_this__u8e3s4, items, initialIndex, totalWidth, theme, onChange) {
  initialIndex = initialIndex === VOID ? 0 : initialIndex;
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Widgets_kt__gwc459();
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.cae(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinSegmented.<anonymous>' call
  var height = 42.0;
  var itemWidth = totalWidth / items.e1();
  var current = {_v: initialIndex};
  var activeBg = BtnSpec_getInstance().gdq(theme);
  var activeFg = BtnSpec_getInstance().ydf_1;
  var r = 10.0 - 1.0;
  // Inline function 'kotlin.collections.mutableListOf' call
  var bgs = ArrayList.i1();
  // Inline function 'kotlin.collections.mutableListOf' call
  var txts = ArrayList.i1();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = items.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i = checkIndexOverflow(tmp1);
    var isActive = i === current._v;
    var corners = new RectCorners(i === 0 ? r : 0.0, i === (items.e1() - 1 | 0) ? r : 0.0, i === (items.e1() - 1 | 0) ? r : 0.0, i === 0 ? r : 0.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.u2l(itemWidth, height);
    var fill = new RGBA(Colors_getInstance().y44_1);
    var stroke = new RGBA(Colors_getInstance().y44_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = RoundRect.hc0(size, corners, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>.<anonymous>' call
    this_3.sar(i * itemWidth);
    this_3.m4k(isActive ? activeBg : Colors_getInstance().d45_1);
    var bg = this_3;
    // Inline function 'kotlin.collections.plusAssign' call
    bgs.h(bg);
    if (i > 0) {
      // Inline function 'korlibs.korge.view.solidRect' call
      var color = theme.edf_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_4 = SolidRect.rc2(Size2D.u2l(1.0, height), color);
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>.<anonymous>' call
      addTo(this_4, this_1).sar(i * itemWidth);
    }
    var tmp = Type_instance.gdp().fdm_1;
    var tmp_0 = isActive ? activeFg : theme.adf_1;
    var tmp_1 = Fonts_instance.adg();
    var tx = kinText(this_1, item, tmp, tmp_0, tmp_1, kinSegmented$lambda(i, itemWidth, height));
    // Inline function 'kotlin.collections.plusAssign' call
    txts.h(tx);
  }
  // Inline function 'korlibs.korge.view.roundRect' call
  var size_0 = Size2D.u2l(totalWidth, height);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_2();
  var radius = new RectCorners(numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0), numberToDouble(10.0));
  var fill_0 = new RGBA(Colors_getInstance().d45_1);
  var stroke_0 = new RGBA(theme.edf_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = RoundRect.hc0(size_0, radius, fill_0, stroke_0, 1.0, true);
  // Inline function 'kotlin.apply' call
  addTo(this_5, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index_0 = 0;
  var tmp0_iterator_0 = items.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>' call
    var tmp1_0 = index_0;
    index_0 = tmp1_0 + 1 | 0;
    var i_0 = checkIndexOverflow(tmp1_0);
    // Inline function 'korlibs.korge.view.solidRect' call
    var color_0 = Colors_getInstance().d45_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = SolidRect.rc2(Size2D.u2l(itemWidth, height), color_0);
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(this_6, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>.<anonymous>' call
    this_7.sar(i_0 * itemWidth);
    // Inline function 'korlibs.korge.input.onClick' call
    var handler = kinSegmented$lambda_0(current, i_0, bgs, activeBg, txts, activeFg, theme, onChange);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_7();
    var tmp1_safe_receiver = this_7 == null ? null : this_7.far();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_2 = prop.get(tmp1_safe_receiver_0);
          tmp_2.p22(kinSegmented$lambda_1(handler));
        }
      }
    }
  }
  return this_1;
}
function kinFieldLabel(_this__u8e3s4, text, theme) {
  theme = theme === VOID ? Theme_instance.wde() : theme;
  _init_properties_Widgets_kt__gwc459();
  return kinText(_this__u8e3s4, capsTracked(text, 1), Type_instance.edq().fdm_1, theme.cdf_1, Fonts_instance.adg());
}
function kinPaperBackground$_anonymous_$_anonymous_$wash_az5h6h($this_Bitmap32Context2d, radius, w, h, cx, cy, color) {
  // Inline function 'korlibs.image.vector.Context2d.fill' call
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.image.vector.Context2d.createRadialGradient' call
  var cycle = CycleMethod_NO_CYCLE_getInstance();
  // Inline function 'korlibs.image.paint.RadialGradientPaint' call
  var transform = Companion_getInstance_3().s2g_1;
  // Inline function 'kotlin.also' call
  var this_0 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(cx), numberToDouble(cy), numberToDouble(0.0), numberToDouble(cx), numberToDouble(cy), numberToDouble(radius), VOID, VOID, cycle, transform);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.Context2d.createRadialGradient.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'ui.kinPaperBackground.<anonymous>$<anonymous>$wash.<anonymous>' call
  this_0.q5a(0.0, color);
  this_0.q5a(1.0, Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(color), _RGBA___get_g__impl__o8pukr(color), _RGBA___get_b__impl__m6tl80(color), 0));
  if (true) {
    $this_Bitmap32Context2d.m4u();
  }
  // Inline function 'ui.kinPaperBackground.<anonymous>$<anonymous>$wash.<anonymous>' call
  $this_Bitmap32Context2d.i3v(0.0, 0.0, w, h);
  $this_Bitmap32Context2d.l5t(this_0, null);
}
function kinText$lambda(_this__u8e3s4) {
  _init_properties_Widgets_kt__gwc459();
  return Unit_instance;
}
function kinText$lambda_0(_this__u8e3s4) {
  _init_properties_Widgets_kt__gwc459();
  return Unit_instance;
}
function kinPaperBackground$lambda($theme, $h, $w) {
  return function ($this$Bitmap32Context2d) {
    var ink = $theme.adf_1;
    var waveColor = Companion_getInstance_7().k4j(_RGBA___get_r__impl__duz7mo(ink), _RGBA___get_g__impl__o8pukr(ink), _RGBA___get_b__impl__m6tl80(ink), numberToInt(255 * ($theme.idf_1 ? 0.035 : 0.04)));
    var paint = new RGBA(Companion_getInstance_7().g4l(waveColor));
    var lineCap = $this$Bitmap32Context2d.a4w();
    var lineJoin = $this$Bitmap32Context2d.b4w();
    var miterLimit = $this$Bitmap32Context2d.c4w();
    var lineDash = $this$Bitmap32Context2d.d4w();
    var lineDashOffset = $this$Bitmap32Context2d.e4w();
    if (true) {
      $this$Bitmap32Context2d.m4u();
    }
    // Inline function 'ui.kinPaperBackground.<anonymous>.<anonymous>.<anonymous>' call
    var row = 0;
    var cy = 14.0;
    while (cy < $h + 28.0) {
      var cx = (row % 2 | 0) === 0 ? 14.0 : 28.0;
      while (cx < $w + 28.0) {
        var _iterator__ex2g4s = listOf([28.0, 14.0, 7.0]).a1();
        while (_iterator__ex2g4s.b1()) {
          var r = _iterator__ex2g4s.c1();
          $this$Bitmap32Context2d.t3l(Vector2D.q2f(cx - r, cy));
          $this$Bitmap32Context2d.l3v(Vector2D.q2f(cx, cy), r, Companion_getInstance_5().a2d_1, Companion_getInstance_5().c2d_1);
        }
        cx = cx + 28.0;
      }
      cy = cy + 14.0;
      row = row + 1 | 0;
    }
    $this$Bitmap32Context2d.f4w();
    var tmp;
    try {
      $this$Bitmap32Context2d.g4w(numberToDouble(0.8));
      $this$Bitmap32Context2d.h4w(lineCap);
      $this$Bitmap32Context2d.i4w(lineJoin);
      $this$Bitmap32Context2d.j4w(numberToDouble(miterLimit));
      $this$Bitmap32Context2d.k4w(lineDash);
      $this$Bitmap32Context2d.l4w(numberToDouble(lineDashOffset));
      $this$Bitmap32Context2d.m4w(paint);
      tmp = Unit_instance;
    }finally {
      $this$Bitmap32Context2d.n4w();
    }
    // Inline function 'kotlin.math.hypot' call
    var x = $w;
    var y = $h;
    var radius = hypot(x, y) * 0.5;
    var tmp_0;
    if ($theme.idf_1) {
      kinPaperBackground$_anonymous_$_anonymous_$wash_az5h6h($this$Bitmap32Context2d, radius, $w, $h, $w * 0.2, $h * 0.1, rgba255(255, 253, 245, 0.025));
      kinPaperBackground$_anonymous_$_anonymous_$wash_az5h6h($this$Bitmap32Context2d, radius, $w, $h, $w * 0.8, $h * 0.9, rgba255(180, 138, 60, 0.05));
      tmp_0 = Unit_instance;
    } else {
      kinPaperBackground$_anonymous_$_anonymous_$wash_az5h6h($this$Bitmap32Context2d, radius, $w, $h, $w * 0.2, $h * 0.1, rgba255(0, 0, 0, 0.025));
      kinPaperBackground$_anonymous_$_anonymous_$wash_az5h6h($this$Bitmap32Context2d, radius, $w, $h, $w * 0.8, $h * 0.9, rgba255(0, 0, 0, 0.03));
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function kinButton$lambda($centered) {
  return function ($this$kinText) {
    $this$kinText.fc7($centered ? Companion_getInstance_6().f4u_1 : Companion_getInstance_6().e4u_1);
    return Unit_instance;
  };
}
function kinButton$lambda_0($width, $padH, $height) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().g4u_1);
    position($this$kinText, $width - $padH, $height / 2.0);
    return Unit_instance;
  };
}
function kinButton$lambda_1($onPress) {
  return function (it) {
    $onPress();
    return Unit_instance;
  };
}
function kinButton$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function kinTextButton$lambda($onPress) {
  return function (it) {
    $onPress();
    return Unit_instance;
  };
}
function kinTextButton$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function kinIconRound$lambda($size) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, $size / 2.0, $size / 2.0);
    return Unit_instance;
  };
}
function kinIconRound$lambda_0($onPress) {
  return function (it) {
    $onPress();
    return Unit_instance;
  };
}
function kinIconRound$lambda_1($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function kinToggle$lambda($on, $track, $trackOn, $trackOff, $cxOn, $cxOff, $thumb, $r, $shadow, $onChange) {
  return function (it) {
    $on._v = !$on._v;
    $track.m4k($on._v ? $trackOn : $trackOff);
    var cx = $on._v ? $cxOn : $cxOff;
    $thumb.sar(cx - $r);
    $shadow.sar(cx - $r);
    $onChange($on._v);
    return Unit_instance;
  };
}
function kinToggle$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function kinSegmented$lambda($i, $itemWidth, $height) {
  return function ($this$kinText) {
    $this$kinText.fc7(Companion_getInstance_6().f4u_1);
    position($this$kinText, $i * $itemWidth + $itemWidth / 2.0, $height / 2.0);
    return Unit_instance;
  };
}
function kinSegmented$lambda_0($current, $i, $bgs, $activeBg, $txts, $activeFg, $theme, $onChange) {
  return function (it) {
    var tmp;
    if ($current._v === $i) {
      return Unit_instance;
    }
    $current._v = $i;
    var index = 0;
    var tmp0_iterator = $bgs.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var j = checkIndexOverflow(tmp1);
      item.m4k(j === $current._v ? $activeBg : Colors_getInstance().d45_1);
    }
    var index_0 = 0;
    var tmp0_iterator_0 = $txts.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'ui.kinSegmented.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp1_0 = index_0;
      index_0 = tmp1_0 + 1 | 0;
      var j_0 = checkIndexOverflow(tmp1_0);
      item_0.cc7(j_0 === $current._v ? $activeFg : $theme.adf_1);
    }
    $onChange($i);
    return Unit_instance;
  };
}
function kinSegmented$lambda_1($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function click$factory_3() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function click$factory_4() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function click$factory_5() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function click$factory_6() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
function click$factory_7() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.ya7_1;
  }, null);
}
var properties_initialized_Widgets_kt_kx7x4v;
function _init_properties_Widgets_kt__gwc459() {
  if (!properties_initialized_Widgets_kt_kx7x4v) {
    properties_initialized_Widgets_kt_kx7x4v = true;
    cyrillicAll = CharacterSet.g4q('\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F');
    extraChars = CharacterSet.g4q('\u4E94\u76EE\u4E00\u4E8C\u4E09\u56DB\u516D\u4E26\u601D\u8003\u4E2D\u521D\u9023\u901F\u5FC3\u5E2B\u767D\u77F3\u6708\u53CB\u548C\u6975\u8336\u58FA\u9280\u9285\u8C9D\u9759\u2192\u2600\u263E\xB7\xAB\xBB\u2014\u2013\u2022\u2605\xD7\u2026\u20BD');
    kinChars = Companion_getInstance_8().f4q_1.h4q(get_cyrillicAll()).h4q(get_extraChars());
    // Inline function 'kotlin.collections.mutableMapOf' call
    bitmapFontCache = LinkedHashMap.rc();
    // Inline function 'kotlin.collections.mutableMapOf' call
    paperCache = LinkedHashMap.rc();
  }
}
//region block: post-declaration
initMetadataForClass(GameLogic, 'GameLogic', GameLogic);
initMetadataForClass(MoveResult, 'MoveResult');
initMetadataForClass(Success, 'Success');
initMetadataForClass(InvalidMove, 'InvalidMove');
initMetadataForClass(GameEnded, 'GameEnded');
initMetadataForClass(Forbidden, 'Forbidden');
initMetadataForClass(UndoResult, 'UndoResult');
initMetadataForClass(Success_0, 'Success');
initMetadataForObject(NoMovesToUndo, 'NoMovesToUndo');
initMetadataForClass(Error_0, 'Error');
initMetadataForCompanion(Companion);
protoOf($serializer).ico = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameRecord, 'GameRecord', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
protoOf($serializer_0).ico = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayerStats, 'PlayerStats', PlayerStats, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
protoOf($serializer_1).ico = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RecordsData, 'RecordsData', RecordsData, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForObject(Seals, 'Seals');
initMetadataForLambda(RecordsStore$scheduleSave$slambda, VOID, VOID, [0]);
initMetadataForObject(RecordsStore, 'RecordsStore', VOID, VOID, VOID, [0]);
initMetadataForClass(RenjuViolation, 'RenjuViolation');
initMetadataForObject(RenjuRules, 'RenjuRules');
initMetadataForCompanion(Companion_2, VOID, [SerializerFactory]);
initMetadataForClass(PlayerColorPref, 'PlayerColorPref', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_14});
initMetadataForCompanion(Companion_3, VOID, [SerializerFactory]);
initMetadataForClass(Rules, 'Rules', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_15});
initMetadataForCompanion(Companion_4);
protoOf($serializer_2).ico = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Settings, 'Settings', Settings, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForLambda(SettingsStore$scheduleSave$slambda, VOID, VOID, [0]);
initMetadataForObject(SettingsStore, 'SettingsStore', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_5, VOID, [SerializerFactory]);
initMetadataForClass(Difficulty, 'Difficulty', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_17});
initMetadataForObject(AiFactory, 'AiFactory');
initMetadataForClass(RandomNearAi, 'RandomNearAi', RandomNearAi);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(HeuristicAi, 'HeuristicAi', HeuristicAi);
initMetadataForClass(HintMove, 'HintMove');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForClass(Board, 'Board', Board);
initMetadataForCompanion(Companion_6, VOID, [SerializerFactory]);
initMetadataForClass(StoneColor, 'StoneColor', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_18});
initMetadataForCompanion(Companion_7);
protoOf($serializer_3).ico = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Position, 'Position', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_8);
protoOf($serializer_4).ico = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Move, 'Move', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_9, VOID, [SerializerFactory]);
initMetadataForClass(GameState, 'GameState', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_21});
initMetadataForCompanion(Companion_10);
protoOf($serializer_5).ico = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(WinningLine, 'WinningLine', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForClass(VictoryScene, 'VictoryScene', VictoryScene, VOID, VOID, [0]);
initMetadataForClass(DefeatScene, 'DefeatScene', DefeatScene, VOID, VOID, [0]);
initMetadataForLambda(GameScene$sceneMain$slambda$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_11);
initMetadataForLambda(GameScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$lambda$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$lambda$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(GameScene$sceneMain$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(GameScene$aiTurnRef$slambda, VOID, VOID, [0]);
initMetadataForLambda(GameScene$playStoneSound$slambda, VOID, VOID, [1]);
initMetadataForClass(GameScene, 'GameScene', GameScene, VOID, VOID, [0]);
initMetadataForClass(HelpScene, 'HelpScene', HelpScene, VOID, VOID, [0]);
initMetadataForClass(DotKind, 'DotKind');
initMetadataForClass(JournalScene, 'JournalScene', JournalScene, VOID, VOID, [0]);
initMetadataForLambda(KifuScene$sceneMain$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KifuScene$sceneMain$lambda$slambda_0, VOID, VOID, [1]);
initMetadataForClass(KifuScene, 'KifuScene', VOID, VOID, VOID, [0]);
initMetadataForLambda(MenuScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForClass(MenuScene, 'MenuScene', MenuScene, VOID, VOID, [0]);
initMetadataForClass(GameMode, 'GameMode');
initMetadataForObject(GameSession, 'GameSession');
initMetadataForLambda(Nav$goMenu$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goGame$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goGameKeepState$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goSettings$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goHelp$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goJournal$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goSeals$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goTea$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goVictory$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goDefeat$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$goKifu$slambda, VOID, VOID, [0]);
initMetadataForLambda(Nav$launch$slambda, VOID, VOID, [0]);
initMetadataForObject(Nav, 'Nav');
initMetadataForLambda(onBackOrEscape$slambda, VOID, VOID, [1]);
initMetadataForClass(SealsScene, 'SealsScene', SealsScene, VOID, VOID, [0]);
initMetadataForClass(SettingsScene, 'SettingsScene', SettingsScene, VOID, VOID, [0]);
initMetadataForLambda(SplashScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForClass(SplashScene, 'SplashScene', SplashScene, VOID, VOID, [0]);
initMetadataForClass(TeaScene, 'TeaScene', TeaScene, VOID, VOID, [0]);
initMetadataForClass(KinBoardView, 'KinBoardView');
initMetadataForClass(KinRng, 'KinRng');
initMetadataForObject(MusicPlayer, 'MusicPlayer', VOID, VOID, VOID, [1]);
initMetadataForObject(Str, 'Str');
initMetadataForClass(HelpEntry, 'HelpEntry');
initMetadataForClass(TeaTone, 'TeaTone');
initMetadataForClass(TeaItem, 'TeaItem');
initMetadataForClass(KinPalette, 'KinPalette');
initMetadataForObject(BtnSpec, 'BtnSpec');
initMetadataForClass(StonePalette, 'StonePalette');
initMetadataForObject(Theme, 'Theme');
initMetadataForObject(Fonts, 'Fonts', VOID, VOID, VOID, [0]);
initMetadataForClass(KinType, 'KinType');
initMetadataForObject(Type, 'Type');
initMetadataForObject(BoardSpec, 'BoardSpec');
initMetadataForObject(Display, 'Display');
//endregion
//region block: init
AiFactory_instance = new AiFactory();
Companion_instance_11 = new Companion_7();
MusicPlayer_instance = new MusicPlayer();
Theme_instance = new Theme();
Fonts_instance = new Fonts();
Type_instance = new Type();
//endregion
mainWrapper();
